import { createContext, useContext, useState, useCallback, useEffect } from "react";

const translations = {
  ro: {
    nav: { rooms: "Camere", house: "Casa întreagă", gallery: "Galerie", experiences: "Experiențe", attractions: "Atracții", events: "Festivaluri", retreats: "Grupuri", reviews: "Recenzii", faq: "Întrebări", book: "Verifică disponibilitatea", menu: "Meniu" },
    hero: {
      eyebrow: "BOUTIQUE GUEST HOUSE · RÂȘNOV",
      h1a: "Nu trebuie să fie perfect",
      h1b: "ca să te simți perfect.",
      sub: "Camere spațioase, tihnă, natură și ospitalitate sinceră, aproape de Bran, Brașov și cele mai frumoase locuri din jurul Râșnovului.",
      slogan: "Locul în care Imperfect devine I.M. Perfect. Simplu.",
      cta1: "Verifică disponibilitatea",
      cta2: "Rezervă pe WhatsApp",
      cta3: "Descoperă locul",
      trust: "din 58 de evaluări",
      badge: "scor oaspeți",
    },
    widget: { checkin: "Sosire", checkout: "Plecare", adults: "Adulți", children: "Copii", pet: "Animal de companie", type: "Tip cazare", room: "Cameră", house: "Casă întreagă", cta: "Vezi disponibilitatea" },
    marquee: "mai puțin zgomot · mai mult din ce contează · liniște · natură · tihnă ·",
    gal: { eyebrow: "GALERIE", title: "Casa, în imagini", sub: "Fotografii reale, făcute aici — fără filtre, fără poze." },
    rp: { back: "Înapoi la site", type_room: "Cameră · Imperfect House", type_house: "Casă integrală · Imperfect House", size: "Suprafață", bed: "Pat", view: "Vedere", capacity: "Capacitate", adults: "adulți", children: "copii", gallery: "Galerie", amenities: "Facilități", shared: "Acces la spațiile comune: living, bar, grădină, terasă.", includes_rooms: "Include toate cele 4 camere — Crem, Salvie, Teracotă și Nuc — fiecare cu baie proprie, plus living, bucătărie, balcon și grădină.", book: "Rezervă", from: "de la", night: "/noapte" },
    bf: {
      eyebrow: "CAFEA & MIC DEJUN · LA CERERE", title: "Ți-e poftă de ceva?",
      intro: "La Imperfect House nu avem restaurant și nici mese întinse ca la hotel. Avem însă un bar, cafea, ceai și o gazdă care se adaptează. Dacă îți dorești un mic dejun, spune-ne din timp și vedem ce bunătăți putem pregăti. Iar seara, dacă ai chef de un pahar și de-o poveste, barul e chiar acolo.",
      includes_title: "Toate variantele includ",
      includes: ["Cafea proaspăt măcinată — espresso, lung, cu lapte sau cappuccino", "Ceai — verde, negru, de mentă, de fructe sau ghimbir", "Apă plată sau minerală", "Shot-ul „Bună dimineața” — elixir din mere și cătină, plin de vitamine"],
      philosophy: "Folosim ingrediente de la producători locali — ouă de la ferma din Zărnești, telemea de la stâna din Piatra Craiului, legume de la sera din Ghimbav, pâine cu maia de la brutăria artizanală din Brașov. Nu promitem un mic dejun perfect. Promitem unul autentic, pregătit cu suflet și servit cu zâmbet.",
      serving: "Îl iei în living, unde lumina dimineții intră pe geamurile mari — sau, când vremea e bună, pe terasă, privind spre dealuri.",
      info1: "În fiecare dimineață · 8:00 – 10:00", info2: "50 lei / persoană", info3: "Comandă până la ora 20:00", info4: "Alergii sau preferințe? Ne adaptăm cu drag",
      quote1: "Diminețile… un adevărat răsfăț! Mic dejun extraordinar de bogat, cu produse locale, proaspete și sănătoase, pregătit cu mult drag.",
      quote2: "Foarte frumos locul, gazda foarte primitoare și amabilă, iar la micul dejun ai produse tradiționale românești.",
      final: "Nu promitem bufet suedez. Promitem că încercăm să începi ziua bine.",
      img_alt: "Micul dejun la Imperfect House — produse locale, cafea și pâine cu maia",
    },
    ck: {
      title: "Cookie-uri, pe scurt",
      text: "Folosim cookie-uri strict necesare pentru funcționarea site-ului și, doar cu acordul tău, cookie-uri de analiză și marketing. Îți poți schimba oricând preferințele.",
      accept_all: "Accept toate", reject: "Doar necesare", customize: "Personalizează", save: "Salvează",
      necessary: "Necesare", necessary_d: "Esențiale pentru funcționarea site-ului.",
      analytics: "Analiză", analytics_d: "Ne ajută să înțelegem cum este folosit site-ul (opțional).",
      marketing: "Marketing", marketing_d: "Conținut personalizat și campanii (opțional).",
      always_on: "mereu active",
    },
    story: {
      eyebrow: "POVESTEA NOASTRĂ", title: "Un acasă temporar",
      p1: "Undeva în Râșnov, la poalele dealului, există o casă care nu încearcă să fie altceva decât ceea ce este: un loc viu, sincer, în care poți fi tu. Fără mască. Fără presiune. Cu liniște, aer curat și spațiu de respirat.",
      p2: "Nu suntem hotel. Și nici nu vrem să fim. Imperfect House este o casă în Râșnov în care ai suficient confort încât să te simți răsfățat și suficientă libertate încât să te simți acasă.",
      sig: "Mai puțin hotel. Mai mult acasă.",
      c1t: "Liniște", c1d: "Zonă de case, departe de zgomotul orașului. Clopotele bisericii nu bat înainte de 9 dimineața.",
      c2t: "Natură", c2d: "Pădurea începe la 3 minute de mers. Grădina, focul de tabără și cerul liber sunt ale tale.",
      c3t: "Tihnă", c3d: "Paturi king-size, camere mari și dimineți fără grabă. Aici timpul curge mai încet.",
    },
    acc: {
      eyebrow: "CAZARE", title: "Alege cum vrei să stai", sub: "4 camere calde, fiecare cu povestea ei. Iar dacă veniți în grup, vorbim despre toată casa.",
      from: "de la", night: "/noapte", capacity: "Capacitate", book_room: "Alege camera", book_house: "Rezervă casa întreagă",
      rooms_name: "Camerele Imperfect", rooms_tag: "4 camere · băi proprii",
      rf: ["Pat 180 × 200 cm și duș generos (cca. 100 × 170 cm)", "Baie proprie în fiecare cameră", "Mansardă 30 mp sau parter 20 mp", "Acces la living, bar și grădină"],
      house_name: "Imperfect Private House", house_tag: "toată casa · doar pentru voi",
      hf: ["4 camere cu paturi 180 × 200 cm + living și bucătărie", "8 persoane standard, până la 12 cu locuri suplimentare", "Balcon, baie și grădină privată", "Intimitate totală pentru grupuri"],
      note: "Nu avem lobby. Avem living. Nu avem recepție cu clopoțel — avem un bar și, de cele mai multe ori, pe Mihai prin apropiere.",
      group_title: "Veniți în grup?",
      group_text: "La cerere, putem discuta și varianta închirierii integrale a proprietății: 8 persoane în cele 4 paturi matrimoniale 180 × 200 cm, maximum 12 în configurație extinsă, cu locurile suplimentare disponibile.",
      group_cta: "Întreabă-l pe Mihai despre casa întreagă",
      group_wa: "Bună, Mihai! Venim în grup și ne interesează închirierea integrală a Imperfect House. Ne poți spune mai multe?",
    },
    am: {
      eyebrow: "FACILITĂȚI", title: "Tot ce ai nevoie, nimic în plus",
      g1: "În cameră", g2: "În proprietate", g3: "Servicii opționale",
      pet: "Pet friendly — animalele de companie sunt acceptate la cerere. Pot exista taxe suplimentare.",
      room: ["Baie proprie", "Pat king-size", "TV cu ecran plat", "Zonă de relaxare", "Fierbător & cafetieră", "Prosoape și lenjerie", "Uscător de păr", "Articole de toaletă", "Dulap", "Izolare fonică"],
      property: ["Wi-Fi gratuit", "Parcare gratuită", "Grădină & terasă", "Bar", "Grătar", "Foc de tabără", "Jocuri și puzzle-uri", "Cinema interior/exterior", "Spațiu comun pentru cafea și mic dejun"],
      services: ["Mic dejun continental", "Transfer aeroport", "Pătuț pentru copil", "Recomandări de experiențe locale"],
    },
    quiz: {
      eyebrow: "QUIZ-UL IMPERFECT", title: "De câte zile de Imperfect ai nevoie?",
      sub: "8 întrebări, zero notificări. Află rețeta ta de odihnă — pe bune, dar cu zâmbetul pe buze.",
      start: "Începe quiz-ul", next: "Următoarea", back: "Înapoi", restart: "Ia-l de la capăt",
      teaser: "Vei afla exact de câte nopți ai nevoie și cu ce să-ți umpli zilele, ca să pleci de aici maxim de echilibrat și relaxat.",
      perks: [
        { t: "Durata ideală", d: "afli exact de câte nopți ai nevoie" },
        { t: "Obiective potrivite", d: "primești mini-itinerarul tău pe zile" },
        { t: "Estimare de preț", d: "vezi bugetul pe loc, fără surprize" },
      ],
      step: "Întrebarea", of: "din",
      result_eyebrow: "REȚETA TA DE ODIHNĂ",
      nights_word: "nopți",
      itinerary: "Mini-planul tău",
      recommended: "Cazarea recomandată",
      estimate: "Estimare de preț",
      cta_check: "Verifică perioada",
      cta_wa: "Trimite rezultatul pe WhatsApp",
      consent: "Salvează rezultatul anonim pentru statistici",
      titles: {
        1: "O gură de aer. Una, dar bună.",
        2: "Ai nevoie de 2 nopți și un răsărit fără alarmă.",
        3: "Ai nevoie de 3 nopți și de minimum o dimineață fără alarmă.",
        4: "Nivel de baterie: 14%. Recomandare: 4 nopți, foc de tabără și telefon pe silențios.",
        5: "Caz grav de oraș. Rețeta: 5 nopți de Imperfect, fără grabă.",
      },
      days: {
        arrive: "Sosire, cafea în grădină și foc de tabără seara",
        castles: "Castelul Bran + Cetatea Râșnov, cu prânz în sat",
        nature: "Rezervația de urși Zărnești + plimbare în pădure",
        kids: "Dino Parc + Aventura Parc — energia copiilor, consumată elegant",
        food: "Brașov: cafenele, restaurante și Piața Sfatului",
        relax: "Dimineață fără alarmă, carte în hamac, cinema sub stele",
        brasov: "Poiana Brașov sau centrul vechi, la pas",
        grill: "Grătar cu prietenii și un pahar la bar",
        leave: "Mic dejun lung și plecare cu regret (dar cu plan de revenire)",
      },
      questions: [
        { q: "Cât de obosit te simți în ultima perioadă?", a: ["Sunt baterie plină", "Cam obosit(ă)", "Epuizat(ă) total"] },
        { q: "Când ai avut ultima zi fără notificări?", a: ["Ieri, serios!", "Nu-mi amintesc exact", "Ce înseamnă «fără notificări»?"] },
        { q: "Cu cine călătorești?", a: ["Singur(ă)", "În cuplu", "Cu prietenii", "Cu familia"] },
        { q: "Vii cu copii?", a: ["Nu", "Da, mici (0–6 ani)", "Da, mai mari (7+ ani)"] },
        { q: "Vii cu patrupedul?", a: ["Da, e parte din familie", "Nu de data asta"] },
        { q: "Liniște sau aventură?", a: ["Liniște totală", "Aventură non-stop", "Un amestec echilibrat"] },
        { q: "Ce te atrage cel mai mult?", a: ["Natura", "Castele și istorie", "Activități pentru copii", "Gastronomie", "Relaxare pură"] },
        { q: "Lucrezi în timpul sejurului?", a: ["Nu, deloc", "Câteva ore, dimineața", "Da — e workation"] },
      ],
    },
    exp: {
      eyebrow: "EXPERIENȚE", title: "Serile și diminețile de aici",
      items: [
        { t: "Foc de tabără", d: "Seri la foc, cu povești și cer plin de stele." },
        { t: "Cinema sub stele", d: "Filme pe videoproiector, afară sau înăuntru, după vreme." },
        { t: "Mic dejun local", d: "Produse locale, proaspete, pregătite cu drag." },
        { t: "Cafea în liniște", d: "Dimineți fără grabă în spațiul comun sau în grădină." },
        { t: "Grătar cu prietenii", d: "Bucătăria de vară și grătarul vă așteaptă." },
        { t: "Jocuri în familie", d: "Cărți, puzzle-uri și râsete până târziu." },
        { t: "Workation la munte", d: "Wi-Fi bun, liniște și vedere care te ține inspirat." },
        { t: "Sejur pet friendly", d: "Patrupedul e binevenit — are și el grădină." },
        { t: "Recomandările lui Mihai", d: "Trasee, restaurante și locuri pe care nu le găsești în ghiduri." },
      ],
    },
    att: {
      eyebrow: "ÎN JUR", title: "Ce ai de vizitat, la câțiva pași",
      sub: "Râșnov e punctul perfect: Bran, Brașov, Zărnești și Piatra Craiului, toate aproape.",
      km: "km", bycar: "cu mașina",
      cats: { castele: "Castele", natura: "Natură", familie: "Familie", oras: "Oraș", transport: "Transport" },
      nearby: "Și la câțiva pași: stația de autobuz spre Brașov chiar în fața casei, magazin la 3 minute, parc la 1 minut, pădurea la 3 minute.",
      map_title: "Harta zonei", here: "Aici ești tu — Imperfect House",
    },
    rev: {
      eyebrow: "RECENZII", title: "Ce spun oaspeții",
      general: "Scor general", cleanliness: "Curățenie", comfort: "Confort", location: "Locație", host: "Gazdă", value: "Calitate/preț",
      count: "evaluări", verified: "recenzii reale, de pe Booking.com și Google",
      google: "Google 5/5 · 9 recenzii", booking: "Booking 9,6 · 62 evaluări",
    },
    host: {
      eyebrow: "GAZDA", title: "Mihai. Gazda care nu te tratează ca pe un număr de cameră.",
      p1: "O fire deschisă și liniștită, căreia îi place viața și oamenii frumoși. Mihai te ajută cu orice cerință, îți recomandă cele mai bune locuri din zonă și pregătește micul dejun cu produse locale.",
      p2: "La Imperfect House nu ești doar un oaspete — ești un prieten care abia așteptăm să revină.",
      cta: "Întreabă-l pe Mihai pe WhatsApp",
      photo_soon: "Fotografia lui Mihai — în curând",
    },
    bk: {
      eyebrow: "DISPONIBILITATE", title: "Planifică-ți sejurul",
      sub: "Vezi calendarul real, alege perioada și trimite cererea. Mihai confirmă personal fiecare rezervare.",
      select_unit: "Alege cazarea",
      legend_avail: "disponibil", legend_limited: "cerere în așteptare", legend_booked: "rezervat", legend_blocked: "indisponibil",
      nights: "nopți", total: "Total estimat", from: "de la", per_night: "/noapte",
      name: "Numele tău", phone: "Telefon", email: "Email (opțional)", message: "Mesaj pentru Mihai (opțional)",
      adults: "Adulți", children: "Copii", children_ages: "Vârste copii", pet: "Vin cu animal de companie",
      gdpr: "Sunt de acord cu prelucrarea datelor pentru această cerere de rezervare.",
      submit: "Continuă spre WhatsApp", sending: "Se pregătește…",
      wa_notice: "Rezervarea NU se confirmă prin email. Cererea se finalizează pe WhatsApp — Mihai îți confirmă acolo disponibilitatea.",
      success_title: "Cererea ta este pregătită — încă NU a fost trimisă.",
      success_text: "Site-ul nu trimite nimic automat. Ca să ajungă la Mihai, apasă butonul de mai jos: se deschide WhatsApp cu mesajul deja completat, dai Trimite, iar el îți confirmă disponibilitatea direct:",
      success_wa: "Trimite cererea pe WhatsApp",
      new_request: "Cerere nouă",
      error: "Ceva nu s-a așezat perfect. Mai încearcă o dată sau scrie-ne direct pe WhatsApp.",
      unavailable: "Camera aceasta își așteaptă deja oaspeții în perioada aleasă. Încearcă alte date.",
      min_nights: "Pentru perioada aleasă, minimul este de {n} nopți.",
      pick_dates: "Alege sosirea și plecarea în calendar",
      available_msg: "Da, perioada aceasta arată bine.",
    },
    faq: {
      eyebrow: "ÎNTREBĂRI", title: "Întrebări frecvente",
      items: [
        { q: "Cum rezerv?", a: "Alegi perioada în calendar, trimiți cererea, iar Mihai confirmă personal — de obicei în câteva minute pe WhatsApp. Rezervarea devine fermă doar după confirmarea gazdei." },
        { q: "Care este programul de check-in / check-out?", a: "Check-in: 15:00 – 22:00. Check-out: până la 11:00. Dacă ai nevoie de alte ore, scrie-ne — găsim o soluție." },
        { q: "Pot veni cu animalul de companie?", a: "Da! Animalele sunt acceptate la cerere și pot exista taxe suplimentare. Avem grădină și doi căței prietenoși ai casei." },
        { q: "Micul dejun este inclus?", a: "Micul dejun continental este opțional, cu produse locale. Spațiul de living și bar este deschis tuturor oaspeților pentru cafea și ceai." },
        { q: "Unde parchez?", a: "Parcare publică gratuită chiar în fața casei, fără rezervare." },
        { q: "Cum ajung fără mașină?", a: "Stația de autobuz cu legătură directă spre Brașov este chiar în fața casei. Transferul de la aeroport se poate organiza la cerere." },
      ],
    },
    footer: {
      tagline: "Locul în care Imperfect devine I.M. Perfect. Simplu.",
      contact: "Contact", explore: "Explorează", legal: "Politici",
      privacy: "Politica de confidențialitate", terms: "Termeni și condiții",
      checkin: "Check-in", checkout: "Check-out",
      rights: "Toate drepturile rezervate.",
      final: "Imperfect House — mai puțin zgomot, mai mult din ce contează.",
    },
    wa: {
      tooltip: "Scrie-ne pe WhatsApp",
      menu_title: "Cu ce te ajutăm?",
      menu_book: "Scrie-i lui Mihai pentru rezervare",
      menu_quiz: "Quiz: ce fel de om ești în vacanță?",
      menu_rooms: "Vezi camerele",
      msg: "Bună, Mihai! Doresc o rezervare la Imperfect House.\n\nTip cazare: {type}\nPerioada: {ci} – {co}\nNopți: {nights}\nAdulți: {adults}\nCopii: {children}\nAnimal de companie: {pet}\nPreț estimat: {total} EUR\nNume: {name}\n\nTe rog să-mi confirmi disponibilitatea.",
      quiz_msg: "Bună, Mihai! Am făcut quiz-ul pe site și mi-a ieșit că am nevoie de {nights} nopți de Imperfect. Cazare recomandată: {unit}. Mă ajuți cu o perioadă potrivită?",
      pet_yes: "da", pet_no: "nu",
    },
    legal: {
      privacy_title: "Politica de confidențialitate",
      privacy_body: "Datele tale (nume, telefon, email) sunt folosite exclusiv pentru procesarea cererii de rezervare și comunicarea cu gazda. Nu vindem și nu partajăm datele cu terți în scopuri de marketing. Poți cere oricând ștergerea sau exportul datelor tale scriindu-ne la adresa de contact. Quiz-ul salvează răspunsuri anonimizate doar cu acordul tău explicit.",
      terms_title: "Termeni și condiții",
      terms_body: "Cererea trimisă prin site nu reprezintă o rezervare fermă; aceasta devine valabilă doar după confirmarea gazdei. Tarifele sunt afișate în EUR și pot varia sezonier. Anularea se face prin contact direct cu gazda. Animalele de companie sunt acceptate la cerere, cu posibile taxe suplimentare. Fumatul este interzis în toate spațiile interioare.",
    },
    popup: { close: "Închide", cta: "Rezervă acum", dates: "Perioada" },
    ev: {
      eyebrow: "FESTIVAL RADAR", title: "Live acum în Transilvania",
      sub: "Poate n-ai ales încă data vacanței. Uite un motiv s-o alegi.",
      live: "ACUM", upcoming: "peste {d} zile", ended: "ediție încheiată",
      tba: "date în curs de confirmare",
      official: "Site oficial", book: "Rezervă camera",
      details: "Pagina evenimentului",
      approx: "date aproximative — verifică site-ul oficial",
      verified: "verificat la {d}",
    },
    story2: {
      eyebrow: "POVESTEA RÂȘNOVULUI", title: "De aici începe Transilvania ta",
      lead: "Nu ai venit până în Transilvania doar ca să dormi. Râșnovul este genul acela de loc rar în care te trezești cu pădurea aproape, iei micul dejun fără grabă, iar apoi alegi ce fel de zi vrei să trăiești. Castel? Munte? Dinozauri? Istorie? Zbor? Schi? Legende? Bere? Muzică? Le ai pe toate în jur.",
      p1: "Nemții îi spuneau Rosenau — Valea Trandafirilor. Râșnovul apare documentar în 1331, iar în 1427 primea dreptul de târg. Când veneau vremuri rele, oamenii urcau la cetate. Și uite-așa cetatea a rămas sus, de parcă ar spune: «Eu v-am zis să construiți pe deal.»",
      p2: "Cu mult înainte de Bran și de toate poveștile cu Dracula, romanii erau deja aici — la marginea orașului se află Cumidava, castrul care păzea drumurile regiunii acum aproape două milenii.",
      p3: "Două biserici. Două comunități. Aceeași vale. Biserica Evanghelică a sașilor, cu rădăcini în secolul al XIII-lea, și Biserica Veche Sf. Nicolae din 1384 — la câteva minute de casă, povestea a 800 de ani de Transilvanie.",
      p4: "Astăzi Râșnovul nu mai trebuie să se apere de invadatori. Doar de turiștii care nu mai vor să plece.",
      nearby_title: "La câțiva pași de Imperfect House",
      nearby: ["Stația de autobuz spre Brașov — chiar în fața casei", "Magazin — aprox. 3 minute", "Parc — 1 minut", "Pădurea — câteva minute de mers"],
      map1_caption: "Harta relaxării — tot ce contează, pe înțelesul tuturor",
      map2_caption: "Harta experiențelor — baza ta de explorare",
      maps_note: "Ilustrații editoriale. Distanțele și timpii sunt aproximativi.",
    },
    attx: {
      all: "Toate",
      cats: {
        aproape: "Aproape de casă", copii: "Cu copiii", castele: "Castele & istorie",
        history_faith: "History & Faith", natura: "Natură", adrenalina: "Adrenalină",
        dark: "Dark Transylvania", iarna: "Iarnă", nightlife: "Nightlife",
        solo: "Solo & Social", taste: "Taste Transylvania", saxon: "Saxon Transylvania",
      },
      approx: "aprox.", kids: "copii", adventure: "aventură",
      legend_note: "Prezentat ca legendă și folclor, nu ca fapt demonstrat.",
      seasonal: "program sezonier — verifică înainte",
      weather: "depinde de vreme și programare",
      fav_add: "Salvează la favorite", fav_remove: "Șters de la favorite",
    },
    ad: {
      eyebrow: "BRAȘOV AFTER DARK", title: "Munții dorm. Tu nu trebuie.",
      sub: "Ziua ai Bran, Râșnov și Piatra Craiului. Seara, la o jumătate de oră, Brașovul schimbă decorul: Centrul Vechi, cocktailuri, muzică live, rock, DJ și oameni din toată lumea. Ziua vezi Transilvania. Noaptea îi cunoști oamenii.",
      selector: "Ce vrei în seara asta?",
      moods: { dance: "Dans", rock: "Rock", live: "Live & Social", dj: "DJ", cocktail: "Cocktail", beer: "Bere craft" },
      all: "Toate",
      note: "Programul și serile se schimbă — verifică paginile localelor înainte să pleci.",
      home: "După care te întorci la Râșnov — unde singura petrecere la 8 dimineața ar trebui să fie cafeaua.",
      solo_title: "Ai venit singur? Foarte bine.",
      solo_text: "Brașovul este oraș universitar și turistic, cu localnici, studenți, expați și călători din toată lumea. Uneori cea mai bună amintire dintr-o vacanță nu e castelul fotografiat — e omul cunoscut. Meet people, not profiles. Pentru prima întâlnire, alege întotdeauna un loc public și transport sigur.",
    },
    ret: {
      eyebrow: "RETREATS & EVENTS", title: "Pentru companii, tabere și oameni care s-au săturat de PowerPoint",
      sub: "Strategie dimineața. Pădure după-amiaza. Foc seara. Poate că cea mai bună idee din trimestrul vostru nu apare într-o sală de conferințe.",
      items: [
        { t: "Corporate Escape", d: "Ședințe, brainstorming, training și team building — cu pădurea la pauză și focul seara." },
        { t: "Creative Camp", d: "Pentru fotografi, videografi, creatori de conținut, scriitori, artiști și workshop-uri." },
        { t: "Parents & Kids Camp", d: "Dino Parc + Magic Parc + natură + jocuri + cinema. Copiii consumați elegant, părinții odihniți." },
        { t: "Adventure Retreat", d: "Zbor + Cheile Râșnoavei + drumeție + foc. Pentru grupuri care nu știu să stea locului." },
        { t: "Private Celebration", d: "Aniversări, reuniuni, petreceri private, cine tematice și seri de degustare — în format decent și controlat." },
        { t: "Small Symposium", d: "Mini-simpozioane și reuniuni profesionale, departe de zgomotul orașului." },
      ],
      capacity: "Cazare: până la 12 persoane în configurația completă. Evenimentele cu invitați suplimentari: numai la cerere, în limitele de capacitate, zgomot și siguranță stabilite de proprietate.",
      cta: "Mihai, vreau să vorbim despre grupul nostru",
      wa_msg: "Bună, Mihai! Sunt interesat(ă) de Imperfect House pentru un eveniment de grup ({type}). Ne poți ajuta cu detalii?",
    },
    fav: {
      button: "Transilvania mea", title: "Transilvania mea",
      empty: "Încă n-ai salvat nimic. Apasă inimioara de la atracțiile care îți plac și construiește-ți lista.",
      count: "{n} locuri salvate",
      cta: "Trimite lista lui Mihai pe WhatsApp",
      clear: "Golește lista",
      wa_msg: "Bună, Mihai! Mi-am făcut lista «Transilvania mea» pe site:\n\n{list}\n\nMă ajuți să-mi fac planul?",
    },
    concierge: {
      cta: "Mihai, ajută-mă să-mi fac planul",
      result_title: "Am înțeles. Uite Transilvania ta.",
      wa_msg: "Bună, Mihai! Am făcut quiz-ul «Ce fel de om ești în vacanță?» și mi-a ieșit planul de {nights} nopți:\n\n{plan}\n\nCazare recomandată: {unit}.\nMă ajuți să-l punem în practică?",
    },
    rpx: { floor: "Etaj", shower: "Duș", saying: "Vorba casei", max: "capacitate maximă la închirierea integrală: 12 persoane" },
    vt: {
      eyebrow: "VIA TRANSILVANICA · TERRA BORZA TEUTONICA",
      title: "Via Transilvanica stops here",
      sub: "Ai mers destul pentru azi.",
      lead: "Imperfect House este în Râșnov, una dintre localitățile de pe extensia Via Transilvanica — Terra Borza Teutonica. E genul acela de drum care nu te grăbește: te trece prin sate, păduri, poieni, cetăți și povești, apoi îți amintește ceva simplu — uneori, cea mai bună parte a mersului este oprirea.",
      brand_quote: "Via Transilvanica îți spune să mergi înainte. Noi îți spunem că uneori e bine să te și oprești.",
      brand_quote2: "Rucsacul la podea. Bocancii la odihnă. Tu la fel.",
      simple_title: "După kilometri de drum, lucrurile simple devin lux.",
      simple: [
        ["Pat king-size", "180 × 200 cm"],
        ["Duș generos", "aprox. 100 × 170 cm"],
        ["Cafea dimineața", "înainte să pornești din nou"],
        ["Mic dejun opțional", "50 lei / persoană · la cerere"],
        ["Grădină", "liniște, aer și verde"],
        ["Foc", "pentru serile cu povești"],
        ["Wi-Fi", "pentru hartă, familie sau următoarea etapă"],
        ["Local knowledge", "recomandări despre Râșnov și împrejurimi"],
      ],
      story_title: "De la Râșnov la Brașov",
      story_sub: "Pădure. Poieni. Liniște. Și Brașovul la capătul drumului.",
      story: "Etapa pornește din centrul Râșnovului și urmează Promenada Sissi spre marginea pădurii. Poteca urcă ușor prin pădure de foioase, iar kilometrii alternează între umbră, poieni, creste line și luminișuri. Pe traseu poți face un scurt ocol spre Capela Greco-Catolică, într-un loc retras, aproape de pădure. Mai târziu, traseul traversează drumul spre Poiana Brașov și începe coborârea către oraș, trecând pe lângă o troiță veche. Ultimii kilometri schimbă decorul: pădurea devine oraș, iar etapa se încheie în Piața Sfatului — acolo unde se termină și călătoria prin Terra Borza Teutonica.",
      timeline: ["Râșnov", "Promenada Sissi", "Pădure", "Poieni și luminișuri", "Capela Greco-Catolică · ocol opțional", "Drumul spre Poiana Brașov", "Troița veche", "Brașov", "Piața Sfatului"],
      stage_cta: "Vezi etapa oficială Râșnov – Brașov",
      stage_note: "Pentru hartă, actualizări și informații tehnice, verifică întotdeauna pagina oficială Via Transilvanica înainte de plecare.",
      guide_title: "Ghidul Drumețului",
      guide_text: "Sfaturi generale, traseul pe zile, hărți, profil de nivel, infrastructură și descrieri de etape — gratuit, în RO, EN, DE, HU și ES, pe site-ul oficial.",
      guide_cta: "Descarcă Ghidul Drumețului",
      bike_title: "Ghidul Biciclistului",
      bike_text: "Via Transilvanica nu e doar pentru bocanci. Pentru cei pe două roți există Ghidul Biciclistului, gratuit, tot pe platforma oficială.",
      bike_cta: "Descarcă Ghidul Biciclistului",
      bike_note: "Verifică întotdeauna condițiile actuale ale traseului înainte de plecare.",
      video_title: "Ce pui în rucsac? Și ce faci dacă apare ursul?",
      video_text: "Cinci filmulețe de pregătire de la Via Transilvanica: echipament, îmbrăcăminte, câini, urși și siguranță.",
      video_cta: "Vezi ghidurile video",
      cta_title: "Ai mers destul pentru azi?",
      cta_text: "Oprește-te în Râșnov. Fă un duș. Mănâncă ceva bun. Stai puțin la foc. Dormi într-un pat king-size. Mâine Via Transilvanica e tot acolo.",
      cta_book: "Verifică disponibilitatea",
      cta_wa: "Scrie-i lui Mihai",
      wa_msg: "Bună, Mihai! Parcurg Via Transilvanica și ajung în Râșnov. Aș vrea să verific disponibilitatea la Imperfect House.",
      final1: "Via Transilvanica continuă.",
      final2: "Dar nu trebuie să continui chiar acum.",
      final3: "Rucsacul la podea. Bocancii la odihnă. Cafeaua mâine dimineață.",
      source_note: "Informațiile tehnice despre traseu provin din resursele oficiale Via Transilvanica. Nu suntem parteneri oficiali — doar o casă bună de oprire pe traseu.",
      badge: "Hikers & cyclists welcome · Via Transilvanica · Râșnov",
    },
  },

  en: {
    nav: { rooms: "Rooms", house: "Entire house", gallery: "Gallery", experiences: "Experiences", attractions: "Attractions", events: "Festivals", retreats: "Groups", reviews: "Reviews", faq: "FAQ", book: "Check availability", menu: "Menu" },
    hero: {
      eyebrow: "BOUTIQUE GUEST HOUSE · RÂȘNOV",
      h1a: "It doesn't have to be perfect",
      h1b: "for you to feel perfect.",
      sub: "Spacious rooms, quiet, nature and sincere hospitality, close to Bran, Brașov and the most beautiful places around Râșnov.",
      slogan: "Where Imperfect becomes I.M. Perfect. Simple.",
      cta1: "Check availability",
      cta2: "Book on WhatsApp",
      cta3: "Discover the place",
      trust: "from 58 reviews",
      badge: "guest score",
    },
    widget: { checkin: "Check-in", checkout: "Check-out", adults: "Adults", children: "Children", pet: "Pet", type: "Stay type", room: "Room", house: "Entire house", cta: "See availability" },
    marquee: "less noise · more of what matters · quiet · nature · calm ·",
    gal: { eyebrow: "GALLERY", title: "The house, in pictures", sub: "Real photos, taken here — no filters, no staging." },
    rp: { back: "Back to the site", type_room: "Room · Imperfect House", type_house: "Entire house · Imperfect House", size: "Size", bed: "Bed", view: "View", capacity: "Capacity", adults: "adults", children: "children", gallery: "Gallery", amenities: "Amenities", shared: "Access to shared spaces: living room, bar, garden, terrace.", includes_rooms: "Includes all 4 rooms — Cream, Sage, Terracotta and Walnut — each with private bathroom, plus living room, kitchen, balcony and garden.", book: "Book", from: "from", night: "/night" },
    bf: {
      eyebrow: "COFFEE & BREAKFAST · ON REQUEST", title: "Fancy something good?",
      intro: "At Imperfect House we don't have a restaurant, nor hotel-style spreads. We do have a bar, coffee, tea and a host who adapts. If you'd like breakfast, tell us in advance and we'll see what goodies we can prepare. And in the evening, if you fancy a glass and a story, the bar is right there.",
      includes_title: "Every option includes",
      includes: ["Freshly ground coffee — espresso, lungo, with milk or cappuccino", "Tea — green, black, mint, fruit or ginger", "Still or sparkling water", "The „Good morning” shot — an apple & sea buckthorn elixir, full of vitamins"],
      philosophy: "We use ingredients from local producers — eggs from the farm in Zărnești, telemea from the sheepfold in Piatra Craiului, vegetables from the greenhouse in Ghimbav, sourdough bread from the artisan bakery in Brașov. We don't promise a perfect breakfast. We promise an honest one, made with soul and served with a smile.",
      serving: "Have it in the living room, where the morning light pours through the big windows — or, when the weather is kind, on the terrace, looking towards the hills.",
      info1: "Every morning · 8:00 – 10:00", info2: "50 lei / person", info3: "Order by 8 PM", info4: "Allergies or preferences? We happily adapt",
      quote1: "The mornings… a real treat! An extraordinarily rich breakfast, with local, fresh and healthy products, prepared with so much love.",
      quote2: "Very beautiful place, a welcoming and kind host, and at breakfast you get traditional Romanian products.",
      final: "We don't promise a Swedish buffet. We promise we'll try to start your day well.",
      img_alt: "Breakfast at Imperfect House — local produce, coffee and sourdough bread",
    },
    ck: {
      title: "Cookies, in short",
      text: "We use strictly necessary cookies for the site to work and, only with your consent, analytics and marketing cookies. You can change your preferences anytime.",
      accept_all: "Accept all", reject: "Necessary only", customize: "Customize", save: "Save",
      necessary: "Necessary", necessary_d: "Essential for the site to function.",
      analytics: "Analytics", analytics_d: "Help us understand how the site is used (optional).",
      marketing: "Marketing", marketing_d: "Personalised content and campaigns (optional).",
      always_on: "always on",
    },
    story: {
      eyebrow: "OUR STORY", title: "A temporary home",
      p1: "Somewhere in Râșnov, at the foot of the hill, there is a house that doesn't try to be anything other than what it is: a living, honest place where you can be yourself. No mask. No pressure. With quiet, fresh air and room to breathe.",
      p2: "We are not a hotel. And we don't want to be. Imperfect House is a house in Râșnov with enough comfort to make you feel pampered and enough freedom to make you feel at home.",
      sig: "Less hotel. More home.",
      c1t: "Quiet", c1d: "A residential lane, far from city noise. The church bells don't ring before 9 AM.",
      c2t: "Nature", c2d: "The forest starts 3 minutes away. The garden, the campfire and the open sky are yours.",
      c3t: "Calm", c3d: "King-size beds, large rooms and slow mornings. Time moves softer here.",
    },
    acc: {
      eyebrow: "STAY", title: "Choose how you want to stay", sub: "4 warm rooms, each with its own story. And if you come as a group, let's talk about the whole house.",
      from: "from", night: "/night", capacity: "Capacity", book_room: "Choose a room", book_house: "Book the entire house",
      rooms_name: "The Imperfect Rooms", rooms_tag: "4 rooms · private bathrooms",
      rf: ["180 × 200 cm bed & generous shower (approx. 100 × 170 cm)", "Private bathroom in every room", "Attic 30 m² or ground floor 20 m²", "Access to living room, bar & garden"],
      house_name: "Imperfect Private House", house_tag: "the whole house · just for you",
      hf: ["4 rooms with 180 × 200 cm beds + living room & kitchen", "8 people standard, up to 12 with extra sleeping spots", "Balcony, bathroom & private garden", "Total privacy for groups"],
      note: "We don't have a lobby. We have a living room. No reception bell — we have a bar and, most of the time, Mihai somewhere nearby.",
      group_title: "Coming as a group?",
      group_text: "On request, we can discuss renting the entire property: 8 people in the four 180 × 200 cm double beds, maximum 12 in the extended configuration, using the available extra sleeping spots.",
      group_cta: "Ask Mihai about the whole house",
      group_wa: "Hi Mihai! We're coming as a group and we're interested in renting the whole Imperfect House. Can you tell us more?",
    },
    am: {
      eyebrow: "AMENITIES", title: "Everything you need, nothing you don't",
      g1: "In the room", g2: "Around the property", g3: "Optional services",
      pet: "Pet friendly — pets are welcome on request. Additional fees may apply.",
      room: ["Private bathroom", "King-size bed", "Flat-screen TV", "Relaxation corner", "Kettle & coffee maker", "Towels & linen", "Hair dryer", "Toiletries", "Wardrobe", "Sound insulation"],
      property: ["Free Wi-Fi", "Free parking", "Garden & terrace", "Bar", "BBQ", "Campfire spot", "Games & puzzles", "Indoor/outdoor cinema", "Shared space for coffee & breakfast"],
      services: ["Continental breakfast", "Airport transfer", "Baby cot", "Local experience tips"],
    },
    quiz: {
      eyebrow: "THE IMPERFECT QUIZ", title: "How many days of Imperfect do you need?",
      sub: "8 questions, zero notifications. Find your rest recipe — honest, but with a smile.",
      start: "Start the quiz", next: "Next", back: "Back", restart: "Start over",
      teaser: "You'll find out exactly how many nights you need and what to fill your days with, so you leave here perfectly balanced and relaxed.",
      perks: [
        { t: "The ideal length", d: "find out exactly how many nights you need" },
        { t: "The right sights", d: "get your day-by-day mini-itinerary" },
        { t: "Price estimate", d: "see the budget instantly, no surprises" },
      ],
      step: "Question", of: "of",
      result_eyebrow: "YOUR REST RECIPE",
      nights_word: "nights",
      itinerary: "Your mini-plan",
      recommended: "Recommended stay",
      estimate: "Price estimate",
      cta_check: "Check these dates",
      cta_wa: "Send result on WhatsApp",
      consent: "Save my result anonymously for statistics",
      titles: {
        1: "A breath of fresh air. One, but a good one.",
        2: "You need 2 nights and one sunrise without an alarm.",
        3: "You need 3 nights and at least one morning without an alarm.",
        4: "Battery level: 14%. Prescription: 4 nights, a campfire and your phone on silent.",
        5: "Severe case of city. The cure: 5 nights of Imperfect, no rushing.",
      },
      days: {
        arrive: "Arrival, coffee in the garden and an evening campfire",
        castles: "Bran Castle + Râșnov Fortress, with lunch in the village",
        nature: "Zărnești Bear Sanctuary + a walk in the forest",
        kids: "Dino Parc + Aventura Parc — kids' energy, elegantly spent",
        food: "Brașov: coffee shops, restaurants and the Council Square",
        relax: "A morning with no alarm, a book in the hammock, cinema under the stars",
        brasov: "Poiana Brașov or the old town, at walking pace",
        grill: "BBQ with friends and a glass at the bar",
        leave: "A long breakfast and a reluctant goodbye (with a plan to return)",
      },
      questions: [
        { q: "How tired have you been feeling lately?", a: ["I'm a full battery", "Somewhat tired", "Completely drained"] },
        { q: "When was your last notification-free day?", a: ["Yesterday, honestly!", "I can't quite remember", "What does «notification-free» mean?"] },
        { q: "Who are you travelling with?", a: ["Solo", "As a couple", "With friends", "With family"] },
        { q: "Travelling with kids?", a: ["No", "Yes, little ones (0–6)", "Yes, older (7+)"] },
        { q: "Bringing your pet?", a: ["Yes, they're family", "Not this time"] },
        { q: "Quiet or adventure?", a: ["Total quiet", "Non-stop adventure", "A balanced mix"] },
        { q: "What attracts you most?", a: ["Nature", "Castles & history", "Kids' activities", "Food & drink", "Pure relaxation"] },
        { q: "Working during your stay?", a: ["Not at all", "A few morning hours", "Yes — it's a workation"] },
      ],
    },
    exp: {
      eyebrow: "EXPERIENCES", title: "The evenings and mornings here",
      items: [
        { t: "Campfire nights", d: "Evenings by the fire, with stories and a sky full of stars." },
        { t: "Cinema under the stars", d: "Movies on the projector, outside or in, weather permitting." },
        { t: "Local breakfast", d: "Fresh local produce, prepared with care." },
        { t: "Quiet coffee", d: "Slow mornings in the shared space or in the garden." },
        { t: "BBQ with friends", d: "The summer kitchen and grill are waiting for you." },
        { t: "Family games", d: "Cards, puzzles and laughter until late." },
        { t: "Mountain workation", d: "Good Wi-Fi, quiet and a view that keeps you inspired." },
        { t: "Pet friendly stay", d: "Your four-legged friend is welcome — they get a garden too." },
        { t: "Mihai's tips", d: "Trails, restaurants and places you won't find in guidebooks." },
      ],
    },
    att: {
      eyebrow: "NEARBY", title: "What to visit, steps away",
      sub: "Râșnov is the perfect base: Bran, Brașov, Zărnești and Piatra Craiului, all close.",
      km: "km", bycar: "by car",
      cats: { castele: "Castles", natura: "Nature", familie: "Family", oras: "City", transport: "Transport" },
      nearby: "And just steps away: the bus stop to Brașov right in front of the house, a shop 3 minutes away, a park 1 minute away, the forest 3 minutes away.",
      map_title: "Map of the area", here: "You are here — Imperfect House",
    },
    rev: {
      eyebrow: "REVIEWS", title: "What guests say",
      general: "Overall score", cleanliness: "Cleanliness", comfort: "Comfort", location: "Location", host: "Host", value: "Value",
      count: "reviews", verified: "real reviews, from Booking.com and Google",
      google: "Google 5/5 · 9 reviews", booking: "Booking 9.6 · 62 reviews",
    },
    host: {
      eyebrow: "THE HOST", title: "Mihai. The host who doesn't treat you like a room number.",
      p1: "An open, calm soul who loves life and good people. Mihai helps with anything you need, recommends the best spots in the area and prepares breakfast with local produce.",
      p2: "At Imperfect House you're not just a guest — you're a friend we can't wait to welcome back.",
      cta: "Ask Mihai on WhatsApp",
      photo_soon: "Mihai's photo — coming soon",
    },
    bk: {
      eyebrow: "AVAILABILITY", title: "Plan your stay",
      sub: "See the real calendar, pick your dates and send the request. Mihai personally confirms every booking.",
      select_unit: "Choose your stay",
      legend_avail: "available", legend_limited: "request pending", legend_booked: "booked", legend_blocked: "unavailable",
      nights: "nights", total: "Estimated total", from: "from", per_night: "/night",
      name: "Your name", phone: "Phone", email: "Email (optional)", message: "Message for Mihai (optional)",
      adults: "Adults", children: "Children", children_ages: "Children's ages", pet: "I'm bringing a pet",
      gdpr: "I agree to my data being processed for this booking request.",
      submit: "Continue to WhatsApp", sending: "Preparing…",
      wa_notice: "Bookings are NOT confirmed by email. Your request is finalized on WhatsApp — Mihai confirms availability there.",
      success_title: "Your request is ready — it has NOT been sent yet.",
      success_text: "This site does not send anything automatically. To make your request reach Mihai, press the button below: WhatsApp opens with your message pre-filled — just hit Send and he will confirm availability directly:",
      success_wa: "Send request via WhatsApp",
      new_request: "New request",
      error: "Something didn't fall perfectly into place. Try again or message us on WhatsApp.",
      unavailable: "This room is already expecting guests on those dates. Try other dates.",
      min_nights: "For the selected period, the minimum is {n} nights.",
      pick_dates: "Pick check-in and check-out in the calendar",
      available_msg: "Yes, this period looks good.",
      view_photos: "View photos",
    },
    faq: {
      eyebrow: "FAQ", title: "Frequently asked questions",
      items: [
        { q: "How do I book?", a: "Pick your dates in the calendar, send the request, and Mihai confirms personally — usually within minutes on WhatsApp. The booking is final only after the host's confirmation." },
        { q: "What are the check-in / check-out times?", a: "Check-in: 3 PM – 10 PM. Check-out: by 11 AM. Need other hours? Message us — we'll find a solution." },
        { q: "Can I bring my pet?", a: "Yes! Pets are welcome on request and additional fees may apply. We have a garden and two friendly house dogs." },
        { q: "Is breakfast included?", a: "Continental breakfast is optional, with local produce. The living room and bar are open to all guests for coffee and tea." },
        { q: "Where do I park?", a: "Free public parking right in front of the house, no reservation needed." },
        { q: "How do I get there without a car?", a: "The bus stop with a direct connection to Brașov is right in front of the house. Airport transfer can be arranged on request." },
      ],
    },
    footer: {
      tagline: "Where Imperfect becomes I.M. Perfect. Simple.",
      contact: "Contact", explore: "Explore", legal: "Policies",
      privacy: "Privacy policy", terms: "Terms & conditions",
      checkin: "Check-in", checkout: "Check-out",
      rights: "All rights reserved.",
      final: "Imperfect House — less noise, more of what matters.",
    },
    wa: {
      tooltip: "Message us on WhatsApp",
      msg: "Hi Mihai! I'd like to book at Imperfect House.\n\nStay type: {type}\nDates: {ci} – {co}\nNights: {nights}\nAdults: {adults}\nChildren: {children}\nPet: {pet}\nEstimated price: {total} EUR\nName: {name}\n\nPlease confirm availability.",
      quiz_msg: "Hi Mihai! I took the quiz on the site and it says I need {nights} nights of Imperfect. Recommended stay: {unit}. Can you help me find the right dates?",
      pet_yes: "yes", pet_no: "no",
    },
    legal: {
      privacy_title: "Privacy policy",
      privacy_body: "Your data (name, phone, email) is used exclusively to process your booking request and communicate with the host. We do not sell or share your data with third parties for marketing. You can request deletion or export of your data at any time via our contact details. The quiz saves anonymised answers only with your explicit consent.",
      terms_title: "Terms & conditions",
      terms_body: "A request sent through the site is not a firm booking; it becomes valid only after the host's confirmation. Rates are shown in EUR and may vary seasonally. Cancellation is done by contacting the host directly. Pets are accepted on request, with possible additional fees. Smoking is prohibited in all indoor areas.",
    },
    popup: { close: "Close", cta: "Book now", dates: "Dates" },
    ev: {
      eyebrow: "FESTIVAL RADAR", title: "Live now in Transylvania",
      sub: "Haven't picked your holiday dates yet? Here's a reason to.",
      live: "NOW", upcoming: "in {d} days", ended: "edition ended",
      tba: "dates to be confirmed",
      official: "Official site", book: "Book your room",
      details: "Event page",
      approx: "approximate dates — check the official site",
      verified: "verified on {d}",
    },
    story2: {
      eyebrow: "THE STORY OF RÂȘNOV", title: "Your Transylvania starts here",
      lead: "You didn't come all the way to Transylvania just to sleep. Râșnov is that rare kind of place where you wake up with the forest nearby, have breakfast without rushing, and then choose what kind of day you want to live. Castle? Mountains? Dinosaurs? History? Flying? Skiing? Legends? Beer? Music? You have them all around.",
      p1: "The Germans called it Rosenau — the Valley of Roses. Râșnov appears in documents in 1331, and in 1427 it was granted the right to hold a fair. When rough times came, people climbed up to the fortress. Which is why the fortress still stands above, as if saying: 'I told you to build on the hill.'",
      p2: "Long before Bran and all the Dracula stories, the Romans were already here — at the edge of town lies Cumidava, the fort that guarded the region's roads almost two millennia ago.",
      p3: "Two churches. Two communities. The same valley. The Saxons' Evangelical Church, rooted in the 13th century, and the Old St. Nicholas Church from 1384 — 800 years of Transylvania, minutes from the house.",
      p4: "Today Râșnov no longer has to defend itself from invaders. Only from tourists who don't want to leave.",
      nearby_title: "A few steps from Imperfect House",
      nearby: ["Bus stop to Brașov — right in front of the house", "Shop — approx. 3 minutes", "Park — 1 minute", "Forest — a few minutes' walk"],
      map1_caption: "The relaxation map — everything that matters, made simple",
      map2_caption: "The experiences map — your base for exploring",
      maps_note: "Editorial illustrations. Distances and times are approximate.",
    },
    attx: {
      all: "All",
      cats: {
        aproape: "Close to home", copii: "With kids", castele: "Castles & history",
        history_faith: "History & Faith", natura: "Nature", adrenalina: "Adrenaline",
        dark: "Dark Transylvania", iarna: "Winter", nightlife: "Nightlife",
        solo: "Solo & Social", taste: "Taste Transylvania", saxon: "Saxon Transylvania",
      },
      approx: "approx.", kids: "kids", adventure: "adventure",
      legend_note: "Presented as legend and folklore, not as proven fact.",
      seasonal: "seasonal schedule — check before visiting",
      weather: "depends on weather and booking",
      fav_add: "Save to favourites", fav_remove: "Removed from favourites",
    },
    ad: {
      eyebrow: "BRAȘOV AFTER DARK", title: "The mountains sleep. You don't have to.",
      sub: "By day you have Bran, Râșnov and Piatra Craiului. In the evening, half an hour away, Brașov changes the scenery: the Old Town, cocktails, live music, rock, DJs and people from all over the world. By day you see Transylvania. By night you meet its people.",
      selector: "What do you want tonight?",
      moods: { dance: "Dance", rock: "Rock", live: "Live & Social", dj: "DJ", cocktail: "Cocktail", beer: "Craft beer" },
      all: "All",
      note: "Schedules and theme nights change — check the venues' pages before you go.",
      home: "Then come back to Râșnov — where the only party at 8 in the morning should be the coffee.",
      solo_title: "Came alone? Very good.",
      solo_text: "Brașov is a university and tourist city, with locals, students, expats and travellers from all over the world. Sometimes the best memory of a holiday is not the castle you photographed — it's the person you met. Meet people, not profiles. For a first date, always choose a public place and safe transport.",
    },
    ret: {
      eyebrow: "RETREATS & EVENTS", title: "For companies, camps and people tired of PowerPoint",
      sub: "Strategy in the morning. Forest in the afternoon. Fire in the evening. Maybe your team's best idea this quarter won't come from a conference room.",
      items: [
        { t: "Corporate Escape", d: "Meetings, brainstorming, training and team building — with the forest at break time and the fire in the evening." },
        { t: "Creative Camp", d: "For photographers, videographers, content creators, writers, artists and workshops." },
        { t: "Parents & Kids Camp", d: "Dino Parc + Magic Parc + nature + games + cinema. Kids elegantly tired out, parents rested." },
        { t: "Adventure Retreat", d: "Flying + Râșnov Gorges + hiking + fire. For groups that can't sit still." },
        { t: "Private Celebration", d: "Birthdays, reunions, private parties, themed dinners and tasting nights — in a decent, controlled format." },
        { t: "Small Symposium", d: "Mini-symposiums and professional reunions, away from the city noise." },
      ],
      capacity: "Accommodation: up to 12 people in the full configuration. Events with additional guests: only on request, within the capacity, noise and safety limits set by the property.",
      cta: "Mihai, let's talk about our group",
      wa_msg: "Hi Mihai! I'm interested in Imperfect House for a group event ({type}). Can you help us with details?",
    },
    fav: {
      button: "My Transylvania", title: "My Transylvania",
      empty: "Nothing saved yet. Tap the heart on the attractions you like and build your list.",
      count: "{n} saved places",
      cta: "Send the list to Mihai on WhatsApp",
      clear: "Clear the list",
      wa_msg: "Hi Mihai! I made my 'My Transylvania' list on the site:\n\n{list}\n\nCan you help me plan it?",
    },
    concierge: {
      cta: "Mihai, help me plan my trip",
      result_title: "Got it. Here's your Transylvania.",
      wa_msg: "Hi Mihai! I took the 'What kind of traveller are you?' quiz and got a {nights}-night plan:\n\n{plan}\n\nRecommended stay: {unit}.\nCan you help me make it happen?",
    },
    rpx: { floor: "Floor", shower: "Shower", saying: "The house says", max: "maximum capacity for full-house rental: 12 people" },
    vt: {
      eyebrow: "VIA TRANSILVANICA · TERRA BORZA TEUTONICA",
      title: "Via Transilvanica stops here",
      sub: "You've walked enough for today.",
      lead: "Imperfect House is in Râșnov, one of the stops on the Via Transilvanica extension — Terra Borza Teutonica. It's the kind of road that doesn't rush you: it takes you through villages, forests, meadows, fortresses and stories, then reminds you of something simple — sometimes the best part of walking is stopping.",
      brand_quote: "Via Transilvanica tells you to keep walking. We tell you that sometimes it's good to stop.",
      brand_quote2: "Backpack on the floor. Boots at rest. You too.",
      simple_title: "After kilometres on the road, simple things become luxury.",
      simple: [
        ["King-size bed", "180 × 200 cm"],
        ["Generous shower", "approx. 100 × 170 cm"],
        ["Morning coffee", "before you set off again"],
        ["Optional breakfast", "50 lei / person · on request"],
        ["Garden", "quiet, air and green"],
        ["Fire", "for evenings with stories"],
        ["Wi-Fi", "for maps, family or the next stage"],
        ["Local knowledge", "tips about Râșnov and the surroundings"],
      ],
      story_title: "From Râșnov to Brașov",
      story_sub: "Forest. Meadows. Silence. And Brașov at the end of the road.",
      story: "The stage starts in the centre of Râșnov and follows the Sissi Promenade towards the edge of the forest. The trail climbs gently through beech woods, and the kilometres alternate between shade, meadows, soft ridges and clearings. Along the way you can take a short detour to the Greek-Catholic Chapel, in a secluded spot near the forest. Later, the route crosses the road to Poiana Brașov and begins the descent towards the city, passing an old wayside cross. The last kilometres change the scenery: the forest becomes a city, and the stage ends in the Council Square — where the journey through Terra Borza Teutonica also ends.",
      timeline: ["Râșnov", "Sissi Promenade", "Forest", "Meadows and clearings", "Greek-Catholic Chapel · optional detour", "The road to Poiana Brașov", "The old wayside cross", "Brașov", "Council Square"],
      stage_cta: "See the official Râșnov – Brașov stage",
      stage_note: "For maps, updates and technical information, always check the official Via Transilvanica page before leaving.",
      guide_title: "The Hiker's Guide",
      guide_text: "General tips, day-by-day route, maps, elevation profile, infrastructure and stage descriptions — free, in RO, EN, DE, HU and ES, on the official site.",
      guide_cta: "Download the Hiker's Guide",
      bike_title: "The Cyclist's Guide",
      bike_text: "Via Transilvanica is not just for boots. For those on two wheels there's the Cyclist's Guide, free, also on the official platform.",
      bike_cta: "Download the Cyclist's Guide",
      bike_note: "Always check the current trail conditions before leaving.",
      video_title: "What goes in the backpack? And what if a bear shows up?",
      video_text: "Five preparation videos from Via Transilvanica: gear, clothing, dogs, bears and safety.",
      video_cta: "Watch the video guides",
      cta_title: "Walked enough for today?",
      cta_text: "Stop in Râșnov. Take a shower. Eat something good. Sit by the fire for a while. Sleep in a king-size bed. Tomorrow, Via Transilvanica is still there.",
      cta_book: "Check availability",
      cta_wa: "Message Mihai",
      wa_msg: "Hi Mihai! I'm hiking Via Transilvanica and arriving in Râșnov. I'd like to check availability at Imperfect House.",
      final1: "Via Transilvanica goes on.",
      final2: "But you don't have to go on right now.",
      final3: "Backpack on the floor. Boots at rest. Coffee in the morning.",
      source_note: "Technical trail information comes from the official Via Transilvanica resources. We are not official partners — just a good house to stop at along the route.",
      badge: "Hikers & cyclists welcome · Via Transilvanica · Râșnov",
    },
  },

  it: {
    nav: { rooms: "Camere", house: "Casa intera", gallery: "Galleria", experiences: "Esperienze", attractions: "Attrazioni", events: "Festival", retreats: "Gruppi", reviews: "Recensioni", faq: "Domande", book: "Verifica disponibilità", menu: "Menu" },
    hero: {
      eyebrow: "BOUTIQUE GUEST HOUSE · RÂȘNOV",
      h1a: "Non deve essere perfetto",
      h1b: "per farti sentire perfetto.",
      sub: "Camere spaziose, quiete, natura e ospitalità sincera, vicino a Bran, Brașov e ai luoghi più belli intorno a Râșnov.",
      slogan: "Dove Imperfect diventa I.M. Perfect. Semplice.",
      cta1: "Verifica disponibilità",
      cta2: "Prenota su WhatsApp",
      cta3: "Scopri il posto",
      trust: "da 58 recensioni",
      badge: "punteggio ospiti",
    },
    widget: { checkin: "Arrivo", checkout: "Partenza", adults: "Adulti", children: "Bambini", pet: "Animale", type: "Tipo di soggiorno", room: "Camera", house: "Casa intera", cta: "Vedi disponibilità" },
    marquee: "meno rumore · più ciò che conta · quiete · natura · calma ·",
    gal: { eyebrow: "GALLERIA", title: "La casa, in immagini", sub: "Foto reali, scattate qui — senza filtri, senza finzioni." },
    rp: { back: "Torna al sito", type_room: "Camera · Imperfect House", type_house: "Casa intera · Imperfect House", size: "Superficie", bed: "Letto", view: "Vista", capacity: "Capacità", adults: "adulti", children: "bambini", gallery: "Galleria", amenities: "Servizi", shared: "Accesso agli spazi comuni: soggiorno, bar, giardino, terrazza.", includes_rooms: "Include tutte e 4 le camere — Crema, Salvia, Terracotta e Noce — ognuna con bagno privato, più soggiorno, cucina, balcone e giardino.", book: "Prenota", from: "da", night: "/notte" },
    bf: {
      eyebrow: "CAFFÈ & COLAZIONE · SU RICHIESTA", title: "Ti va qualcosa di buono?",
      intro: "A Imperfect House non abbiamo un ristorante, né tavolate in stile hotel. Abbiamo però un bar, caffè, tè e un host che si adatta. Se desideri la colazione, dillo in anticipo e vediamo che bontà possiamo preparare. E la sera, se ti va un bicchiere e una storia, il bar è proprio lì.",
      includes_title: "Ogni variante include",
      includes: ["Caffè appena macinato — espresso, lungo, macchiato o cappuccino", "Tè — verde, nero, menta, frutta o zenzero", "Acqua naturale o frizzante", "Lo shot „Buongiorno” — elisir di mele e olivello spinoso, pieno di vitamine"],
      philosophy: "Usiamo ingredienti di produttori locali — uova dalla fattoria di Zărnești, telemea dall'ovile di Piatra Craiului, verdure dalla serra di Ghimbav, pane a lievitazione naturale dal panificio artigianale di Brașov. Non promettiamo una colazione perfetta. Ne promettiamo una autentica, fatta con l'anima e servita con il sorriso.",
      serving: "La prendi nel living, dove la luce del mattino entra dalle grandi finestre — o, quando il tempo è bello, in terrazza, guardando le colline.",
      info1: "Ogni mattina · 8:00 – 10:00", info2: "50 lei / persona", info3: "Ordina entro le 20:00", info4: "Allergie o preferenze? Ci adattiamo volentieri",
      quote1: "Le mattine… una vera coccola! Colazione straordinariamente ricca, con prodotti locali, freschi e sani, preparata con tanto amore.",
      quote2: "Posto molto bello, host accogliente e gentile, e a colazione trovi prodotti tradizionali rumeni.",
      final: "Non promettiamo un buffet svedese. Promettiamo di provare a iniziare bene la tua giornata.",
      img_alt: "Colazione a Imperfect House — prodotti locali, caffè e pane a lievitazione naturale",
    },
    ck: {
      title: "Cookie, in breve",
      text: "Usiamo cookie strettamente necessari al funzionamento del sito e, solo con il tuo consenso, cookie di analisi e marketing. Puoi cambiare le preferenze in qualsiasi momento.",
      accept_all: "Accetta tutto", reject: "Solo necessari", customize: "Personalizza", save: "Salva",
      necessary: "Necessari", necessary_d: "Essenziali per il funzionamento del sito.",
      analytics: "Analisi", analytics_d: "Ci aiutano a capire come viene usato il sito (opzionale).",
      marketing: "Marketing", marketing_d: "Contenuti personalizzati e campagne (opzionale).",
      always_on: "sempre attivi",
    },
    story: {
      eyebrow: "LA NOSTRA STORIA", title: "Una casa temporanea",
      p1: "Da qualche parte a Râșnov, ai piedi della collina, c'è una casa che non cerca di essere altro da sé: un luogo vivo e sincero, dove puoi essere te stesso. Senza maschere. Senza pressioni. Con quiete, aria pulita e spazio per respirare.",
      p2: "Imperfect House non parla di perfezione. Parla di verità, semplicità e calma. Di una «casa temporanea» in cui ritrovarti.",
      sig: "Più di un soggiorno. Uno stato d'animo.",
      c1t: "Quiete", c1d: "Una via residenziale, lontano dal rumore. Le campane non suonano prima delle 9.",
      c2t: "Natura", c2d: "Il bosco inizia a 3 minuti a piedi. Il giardino, il falò e il cielo aperto sono tuoi.",
      c3t: "Calma", c3d: "Letti king-size, camere grandi e mattine lente. Qui il tempo scorre più piano.",
    },
    acc: {
      eyebrow: "SOGGIORNO", title: "Scegli come vuoi stare", sub: "4 camere accoglienti, ognuna con la sua storia. E se venite in gruppo, parliamo di tutta la casa.",
      from: "da", night: "/notte", capacity: "Capacità", book_room: "Scegli la camera", book_house: "Prenota tutta la casa",
      rooms_name: "Le Camere Imperfect", rooms_tag: "4 camere · bagni privati",
      rf: ["Letto 180 × 200 cm e doccia ampia (ca. 100 × 170 cm)", "Bagno privato in ogni camera", "Mansarda 30 m² o piano terra 20 m²", "Accesso a soggiorno, bar e giardino"],
      house_name: "Imperfect Private House", house_tag: "tutta la casa · solo per voi",
      hf: ["4 camere con letti 180 × 200 cm + soggiorno e cucina", "8 persone standard, fino a 12 con posti extra", "Balcone, bagno e giardino privato", "Privacy totale per gruppi"],
      note: "Non abbiamo una lobby. Abbiamo un living. Niente reception con campanello — abbiamo un bar e, il più delle volte, Mihai nei paraggi.",
      group_title: "Venite in gruppo?",
      group_text: "Su richiesta, possiamo parlare dell'affitto dell'intera proprietà: 8 persone nei quattro letti matrimoniali 180 × 200 cm, massimo 12 nella configurazione estesa, con i posti extra disponibili.",
      group_cta: "Chiedi a Mihai della casa intera",
      group_wa: "Ciao Mihai! Veniamo in gruppo e ci interessa l'affitto dell'intera Imperfect House. Puoi dirci di più?",
    },
    am: {
      eyebrow: "SERVIZI", title: "Tutto ciò che serve, niente di superfluo",
      g1: "In camera", g2: "Nella proprietà", g3: "Servizi opzionali",
      pet: "Pet friendly — gli animali sono benvenuti su richiesta. Possono applicarsi costi aggiuntivi.",
      room: ["Bagno privato", "Letto king-size", "TV a schermo piatto", "Angolo relax", "Bollitore e macchina del caffè", "Asciugamani e biancheria", "Asciugacapelli", "Articoli da toilette", "Armadio", "Insonorizzazione"],
      property: ["Wi-Fi gratuito", "Parcheggio gratuito", "Giardino e terrazza", "Bar", "Barbecue", "Posto per il falò", "Giochi e puzzle", "Cinema interno/esterno", "Spazio comune per caffè e colazione"],
      services: ["Colazione continentale", "Transfer aeroporto", "Culla per bambini", "Consigli su esperienze locali"],
    },
    quiz: {
      eyebrow: "IL QUIZ IMPERFECT", title: "Di quanti giorni di Imperfect hai bisogno?",
      sub: "8 domande, zero notifiche. Scopri la tua ricetta di riposo — sincera, ma col sorriso.",
      start: "Inizia il quiz", next: "Avanti", back: "Indietro", restart: "Ricomincia",
      teaser: "Scoprirai esattamente di quante notti hai bisogno e con cosa riempire le giornate, per ripartire perfettamente equilibrato e rilassato.",
      perks: [
        { t: "La durata ideale", d: "scopri esattamente di quante notti hai bisogno" },
        { t: "I luoghi giusti", d: "ricevi il tuo mini-itinerario giornaliero" },
        { t: "Stima del prezzo", d: "vedi subito il budget, senza sorprese" },
      ],
      step: "Domanda", of: "di",
      result_eyebrow: "LA TUA RICETTA DI RIPOSO",
      nights_word: "notti",
      itinerary: "Il tuo mini-piano",
      recommended: "Soggiorno consigliato",
      estimate: "Stima del prezzo",
      cta_check: "Verifica queste date",
      cta_wa: "Invia il risultato su WhatsApp",
      consent: "Salva il risultato in forma anonima per statistiche",
      titles: {
        1: "Una boccata d'aria. Una, ma buona.",
        2: "Ti servono 2 notti e un'alba senza sveglia.",
        3: "Ti servono 3 notti e almeno una mattina senza sveglia.",
        4: "Livello batteria: 14%. Ricetta: 4 notti, un falò e il telefono in silenzioso.",
        5: "Grave caso di città. La cura: 5 notti di Imperfect, senza fretta.",
      },
      days: {
        arrive: "Arrivo, caffè in giardino e falò serale",
        castles: "Castello di Bran + Fortezza di Râșnov, con pranzo in paese",
        nature: "Santuario degli orsi di Zărnești + passeggiata nel bosco",
        kids: "Dino Parc + Aventura Parc — l'energia dei bambini, spesa con eleganza",
        food: "Brașov: caffè, ristoranti e Piazza del Consiglio",
        relax: "Mattina senza sveglia, libro sull'amaca, cinema sotto le stelle",
        brasov: "Poiana Brașov o il centro storico, a passo lento",
        grill: "Grigliata con gli amici e un bicchiere al bar",
        leave: "Colazione lunga e arrivederci a malincuore (con piano di ritorno)",
      },
      questions: [
        { q: "Quanto ti senti stanco ultimamente?", a: ["Sono una batteria carica", "Abbastanza stanco/a", "Completamente esausto/a"] },
        { q: "Quando è stato il tuo ultimo giorno senza notifiche?", a: ["Ieri, davvero!", "Non lo ricordo bene", "Cosa significa «senza notifiche»?"] },
        { q: "Con chi viaggi?", a: ["Da solo/a", "In coppia", "Con amici", "Con la famiglia"] },
        { q: "Viaggi con bambini?", a: ["No", "Sì, piccoli (0–6 anni)", "Sì, più grandi (7+)"] },
        { q: "Porti il tuo animale?", a: ["Sì, è parte della famiglia", "Non questa volta"] },
        { q: "Quiete o avventura?", a: ["Quiete totale", "Avventura non-stop", "Un mix equilibrato"] },
        { q: "Cosa ti attrae di più?", a: ["La natura", "Castelli e storia", "Attività per bambini", "Gastronomia", "Relax puro"] },
        { q: "Lavori durante il soggiorno?", a: ["No, affatto", "Qualche ora al mattino", "Sì — è una workation"] },
      ],
    },
    exp: {
      eyebrow: "ESPERIENZE", title: "Le sere e le mattine di qui",
      items: [
        { t: "Serate al falò", d: "Sere intorno al fuoco, con racconti e un cielo pieno di stelle." },
        { t: "Cinema sotto le stelle", d: "Film col videoproiettore, fuori o dentro, secondo il meteo." },
        { t: "Colazione locale", d: "Prodotti locali e freschi, preparati con cura." },
        { t: "Caffè in silenzio", d: "Mattine lente nello spazio comune o in giardino." },
        { t: "Grigliata con amici", d: "La cucina estiva e il barbecue vi aspettano." },
        { t: "Giochi in famiglia", d: "Carte, puzzle e risate fino a tardi." },
        { t: "Workation in montagna", d: "Buon Wi-Fi, quiete e una vista che ispira." },
        { t: "Soggiorno pet friendly", d: "Il tuo amico a quattro zampe è il benvenuto — anche lui ha il giardino." },
        { t: "I consigli di Mihai", d: "Sentieri, ristoranti e luoghi che non trovi nelle guide." },
      ],
    },
    att: {
      eyebrow: "NEI DINTORNI", title: "Cosa visitare, a pochi passi",
      sub: "Râșnov è la base perfetta: Bran, Brașov, Zărnești e Piatra Craiului, tutto vicino.",
      km: "km", bycar: "in auto",
      cats: { castele: "Castelli", natura: "Natura", familie: "Famiglia", oras: "Città", transport: "Trasporti" },
      nearby: "E a pochi passi: la fermata dell'autobus per Brașov proprio davanti a casa, un negozio a 3 minuti, un parco a 1 minuto, il bosco a 3 minuti.",
      map_title: "Mappa della zona", here: "Sei qui — Imperfect House",
    },
    rev: {
      eyebrow: "RECENSIONI", title: "Cosa dicono gli ospiti",
      general: "Punteggio generale", cleanliness: "Pulizia", comfort: "Comfort", location: "Posizione", host: "Host", value: "Qualità/prezzo",
      count: "recensioni", verified: "recensioni reali, da Booking.com e Google",
      google: "Google 5/5 · 9 recensioni", booking: "Booking 9,6 · 62 recensioni",
    },
    host: {
      eyebrow: "L'HOST", title: "Mihai. L'host che non ti tratta come un numero di camera.",
      p1: "Un animo aperto e tranquillo, che ama la vita e le belle persone. Mihai ti aiuta con qualsiasi richiesta, ti consiglia i posti migliori della zona e prepara la colazione con prodotti locali.",
      p2: "A Imperfect House non sei solo un ospite — sei un amico che non vediamo l'ora di rivedere.",
      cta: "Chiedi a Mihai su WhatsApp",
      photo_soon: "La foto di Mihai — in arrivo",
    },
    bk: {
      eyebrow: "DISPONIBILITÀ", title: "Pianifica il tuo soggiorno",
      sub: "Guarda il calendario reale, scegli le date e invia la richiesta. Mihai conferma personalmente ogni prenotazione.",
      select_unit: "Scegli il soggiorno",
      legend_avail: "disponibile", legend_limited: "richiesta in attesa", legend_booked: "prenotato", legend_blocked: "non disponibile",
      nights: "notti", total: "Totale stimato", from: "da", per_night: "/notte",
      name: "Il tuo nome", phone: "Telefono", email: "Email (opzionale)", message: "Messaggio per Mihai (opzionale)",
      adults: "Adulti", children: "Bambini", children_ages: "Età dei bambini", pet: "Porto un animale",
      gdpr: "Accetto il trattamento dei miei dati per questa richiesta di prenotazione.",
      submit: "Continua su WhatsApp", sending: "Preparazione…",
      wa_notice: "La prenotazione NON si conferma via email. La richiesta si finalizza su WhatsApp — Mihai ti conferma lì la disponibilità.",
      success_title: "La tua richiesta è pronta — NON è ancora stata inviata.",
      success_text: "Questo sito non invia nulla automaticamente. Per far arrivare la richiesta a Mihai, premi il pulsante qui sotto: si apre WhatsApp con il messaggio già compilato — premi Invia e ti confermerà la disponibilità direttamente:",
      success_wa: "Invia la richiesta su WhatsApp",
      new_request: "Nuova richiesta",
      error: "Qualcosa non si è incastrato perfettamente. Riprova o scrivici su WhatsApp.",
      unavailable: "Questa camera aspetta già altri ospiti nelle date scelte. Prova altre date.",
      min_nights: "Per il periodo scelto, il minimo è di {n} notti.",
      pick_dates: "Scegli arrivo e partenza nel calendario",
      available_msg: "Sì, questo periodo sembra perfetto.",
      view_photos: "Vedi le foto",
    },
    faq: {
      eyebrow: "DOMANDE", title: "Domande frequenti",
      items: [
        { q: "Come prenoto?", a: "Scegli le date nel calendario, invia la richiesta e Mihai conferma personalmente — di solito in pochi minuti su WhatsApp. La prenotazione è definitiva solo dopo la conferma dell'host." },
        { q: "Quali sono gli orari di check-in / check-out?", a: "Check-in: 15:00 – 22:00. Check-out: entro le 11:00. Hai bisogno di altri orari? Scrivici — troviamo una soluzione." },
        { q: "Posso portare il mio animale?", a: "Sì! Gli animali sono benvenuti su richiesta e possono applicarsi costi aggiuntivi. Abbiamo un giardino e due cani di casa molto amichevoli." },
        { q: "La colazione è inclusa?", a: "La colazione continentale è opzionale, con prodotti locali. Il soggiorno e il bar sono aperti a tutti gli ospiti per caffè e tè." },
        { q: "Dove parcheggio?", a: "Parcheggio pubblico gratuito proprio davanti a casa, senza prenotazione." },
        { q: "Come arrivo senza auto?", a: "La fermata dell'autobus con collegamento diretto per Brașov è proprio davanti a casa. Il transfer dall'aeroporto si organizza su richiesta." },
      ],
    },
    footer: {
      tagline: "Dove Imperfect diventa I.M. Perfect. Semplice.",
      contact: "Contatti", explore: "Esplora", legal: "Policy",
      privacy: "Privacy policy", terms: "Termini e condizioni",
      checkin: "Check-in", checkout: "Check-out",
      rights: "Tutti i diritti riservati.",
      final: "Imperfect House — meno rumore, più ciò che conta.",
    },
    wa: {
      tooltip: "Scrivici su WhatsApp",
      menu_title: "Come possiamo aiutarti?",
      menu_book: "Scrivi a Mihai per prenotare",
      menu_quiz: "Quiz: che tipo di viaggiatore sei?",
      menu_rooms: "Vedi le camere",
      msg: "Ciao Mihai! Vorrei prenotare a Imperfect House.\n\nTipo di soggiorno: {type}\nDate: {ci} – {co}\nNotti: {nights}\nAdulti: {adults}\nBambini: {children}\nAnimale: {pet}\nPrezzo stimato: {total} EUR\nNome: {name}\n\nPer favore confermami la disponibilità.",
      quiz_msg: "Ciao Mihai! Ho fatto il quiz sul sito e mi servono {nights} notti di Imperfect. Soggiorno consigliato: {unit}. Mi aiuti a trovare le date giuste?",
      pet_yes: "sì", pet_no: "no",
    },
    legal: {
      privacy_title: "Privacy policy",
      privacy_body: "I tuoi dati (nome, telefono, email) sono usati esclusivamente per elaborare la richiesta di prenotazione e comunicare con l'host. Non vendiamo né condividiamo i dati con terzi per marketing. Puoi chiedere in qualsiasi momento la cancellazione o l'esportazione dei tuoi dati. Il quiz salva risposte anonime solo con il tuo consenso esplicito.",
      terms_title: "Termini e condizioni",
      terms_body: "La richiesta inviata tramite il sito non è una prenotazione definitiva; diventa valida solo dopo la conferma dell'host. Le tariffe sono in EUR e possono variare stagionalmente. La cancellazione avviene contattando direttamente l'host. Gli animali sono accettati su richiesta, con possibili costi aggiuntivi. Vietato fumare in tutti gli spazi interni.",
    },
    popup: { close: "Chiudi", cta: "Prenota ora", dates: "Date" },
    ev: {
      eyebrow: "FESTIVAL RADAR", title: "Dal vivo ora in Transilvania",
      sub: "Non hai ancora scelto le date delle vacanze? Ecco un motivo per farlo.",
      live: "ORA", upcoming: "tra {d} giorni", ended: "edizione conclusa",
      tba: "date da confermare",
      official: "Sito ufficiale", book: "Prenota la camera",
      details: "Pagina dell'evento",
      approx: "date approssimative — controlla il sito ufficiale",
      verified: "verificato il {d}",
    },
    story2: {
      eyebrow: "LA STORIA DI RÂȘNOV", title: "La tua Transilvania inizia qui",
      lead: "Non sei venuto fino in Transilvania solo per dormire. Râșnov è quel raro tipo di posto dove ti svegli con la foresta vicina, fai colazione senza fretta e poi scegli che tipo di giornata vivere. Castello? Montagne? Dinosauri? Storia? Volo? Sci? Leggende? Birra? Musica? Le hai tutte intorno.",
      p1: "I tedeschi la chiamavano Rosenau — la Valle delle Rose. Râșnov appare nei documenti nel 1331 e nel 1427 ottenne il diritto di fiera. Quando arrivavano tempi duri, la gente saliva alla fortezza. Ed è per questo che la fortezza è ancora lassù, come a dire: «Ve l'avevo detto di costruire sulla collina.»",
      p2: "Molto prima di Bran e di tutte le storie di Dracula, i romani erano già qui — ai margini della città si trova Cumidava, il castro che sorvegliava le strade della regione quasi due millenni fa.",
      p3: "Due chiese. Due comunità. La stessa valle. La Chiesa Evangelica dei sassoni, con radici nel XIII secolo, e la Chiesa Vecchia Sf. Nicolae del 1384 — 800 anni di Transilvania, a pochi minuti da casa.",
      p4: "Oggi Râșnov non deve più difendersi dagli invasori. Solo dai turisti che non vogliono più partire.",
      nearby_title: "A pochi passi da Imperfect House",
      nearby: ["Fermata dell'autobus per Brașov — proprio davanti a casa", "Negozio — ca. 3 minuti", "Parco — 1 minuto", "Foresta — pochi minuti a piedi"],
      map1_caption: "La mappa del relax — tutto ciò che conta, reso semplice",
      map2_caption: "La mappa delle esperienze — la tua base per esplorare",
      maps_note: "Illustrazioni editoriali. Distanze e tempi sono approssimativi.",
    },
    attx: {
      all: "Tutte",
      cats: {
        aproape: "Vicino a casa", copii: "Con i bambini", castele: "Castelli & storia",
        history_faith: "History & Faith", natura: "Natura", adrenalina: "Adrenalina",
        dark: "Dark Transylvania", iarna: "Inverno", nightlife: "Vita notturna",
        solo: "Solo & Social", taste: "Taste Transylvania", saxon: "Saxon Transylvania",
      },
      approx: "ca.", kids: "bambini", adventure: "avventura",
      legend_note: "Presentato come leggenda e folclore, non come fatto dimostrato.",
      seasonal: "orario stagionale — verifica prima della visita",
      weather: "dipende dal meteo e dalla prenotazione",
      fav_add: "Salva nei preferiti", fav_remove: "Rimosso dai preferiti",
    },
    ad: {
      eyebrow: "BRAȘOV AFTER DARK", title: "Le montagne dormono. Tu non devi.",
      sub: "Di giorno hai Bran, Râșnov e il Piatra Craiului. La sera, a mezz'ora, Brașov cambia scena: il centro storico, cocktail, musica dal vivo, rock, DJ e gente da tutto il mondo. Di giorno vedi la Transilvania. Di notte conosci la sua gente.",
      selector: "Cosa vuoi stasera?",
      moods: { dance: "Ballare", rock: "Rock", live: "Live & Social", dj: "DJ", cocktail: "Cocktail", beer: "Birra craft" },
      all: "Tutte",
      note: "Orari e serate a tema cambiano — controlla le pagine dei locali prima di uscire.",
      home: "Poi torni a Râșnov — dove l'unica festa alle 8 di mattina dovrebbe essere il caffè.",
      solo_title: "Sei venuto da solo? Benissimo.",
      solo_text: "Brașov è una città universitaria e turistica, con gente del posto, studenti, expat e viaggiatori da tutto il mondo. A volte il ricordo più bello di una vacanza non è il castello fotografato — è la persona conosciuta. Meet people, not profiles. Per il primo appuntamento, scegli sempre un luogo pubblico e un trasporto sicuro.",
    },
    ret: {
      eyebrow: "RETREATS & EVENTS", title: "Per aziende, campi e persone stanche di PowerPoint",
      sub: "Strategia al mattino. Foresta nel pomeriggio. Fuoco la sera. Forse la migliore idea del trimestre non nasce in una sala conferenze.",
      items: [
        { t: "Corporate Escape", d: "Riunioni, brainstorming, training e team building — con la foresta in pausa e il fuoco la sera." },
        { t: "Creative Camp", d: "Per fotografi, videomaker, content creator, scrittori, artisti e workshop." },
        { t: "Parents & Kids Camp", d: "Dino Parc + Magic Parc + natura + giochi + cinema. Bambini elegantemente stanchi, genitori riposati." },
        { t: "Adventure Retreat", d: "Volo + Gole di Râșnov + escursione + fuoco. Per gruppi che non sanno stare fermi." },
        { t: "Private Celebration", d: "Compleanni, reunion, feste private, cene a tema e serate di degustazione — in formato decente e controllato." },
        { t: "Small Symposium", d: "Mini-simposi e riunioni professionali, lontano dal rumore della città." },
      ],
      capacity: "Alloggio: fino a 12 persone nella configurazione completa. Eventi con ospiti aggiuntivi: solo su richiesta, nei limiti di capacità, rumore e sicurezza stabiliti dalla proprietà.",
      cta: "Mihai, parliamo del nostro gruppo",
      wa_msg: "Ciao Mihai! Sono interessato a Imperfect House per un evento di gruppo ({type}). Puoi aiutarci con i dettagli?",
    },
    fav: {
      button: "La mia Transilvania", title: "La mia Transilvania",
      empty: "Niente di salvato ancora. Tocca il cuoricino sulle attrazioni che ti piacciono e costruisci la tua lista.",
      count: "{n} luoghi salvati",
      cta: "Invia la lista a Mihai su WhatsApp",
      clear: "Svuota la lista",
      wa_msg: "Ciao Mihai! Ho fatto la mia lista «La mia Transilvania» sul sito:\n\n{list}\n\nMi aiuti a organizzare il piano?",
    },
    concierge: {
      cta: "Mihai, aiutami a organizzare il viaggio",
      result_title: "Capito. Ecco la tua Transilvania.",
      wa_msg: "Ciao Mihai! Ho fatto il quiz «Che tipo di viaggiatore sei?» e mi è uscito un piano di {nights} notti:\n\n{plan}\n\nAlloggio consigliato: {unit}.\nMi aiuti a realizzarlo?",
    },
    rpx: { floor: "Piano", shower: "Doccia", saying: "Dice la casa", max: "capacità massima per l'affitto dell'intera casa: 12 persone" },
    vt: {
      eyebrow: "VIA TRANSILVANICA · TERRA BORZA TEUTONICA",
      title: "Via Transilvanica stops here",
      sub: "Per oggi hai camminato abbastanza.",
      lead: "Imperfect House è a Râșnov, una delle località attraversate dall'estensione della Via Transilvanica — Terra Borza Teutonica. È quel tipo di cammino che non ti mette fretta: ti porta attraverso paesi, foreste, radure, fortezze e storie, e poi ti ricorda una cosa semplice — a volte la parte più bella del cammino è la sosta.",
      brand_quote: "La Via Transilvanica ti dice di andare avanti. Noi ti diciamo che a volte è bene anche fermarsi.",
      brand_quote2: "Zaino a terra. Scarponi a riposo. Tu pure.",
      simple_title: "Dopo chilometri di strada, le cose semplici diventano lusso.",
      simple: [
        ["Letto king-size", "180 × 200 cm"],
        ["Doccia ampia", "ca. 100 × 170 cm"],
        ["Caffè al mattino", "prima di ripartire"],
        ["Colazione opzionale", "50 lei / persona · su richiesta"],
        ["Giardino", "quiete, aria e verde"],
        ["Fuoco", "per le sere di racconti"],
        ["Wi-Fi", "per la mappa, la famiglia o la prossima tappa"],
        ["Local knowledge", "consigli su Râșnov e dintorni"],
      ],
      story_title: "Da Râșnov a Brașov",
      story_sub: "Foresta. Radure. Silenzio. E Brașov alla fine della strada.",
      story: "La tappa parte dal centro di Râșnov e segue la Promenade Sissi verso il margine della foresta. Il sentiero sale dolcemente nel bosco di latifoglie e i chilometri si alternano tra ombra, radure, creste morbide e radure luminose. Lungo il percorso puoi fare una breve deviazione verso la Cappella Greco-Cattolica, in un luogo appartato, vicino al bosco. Più avanti, il tracciato attraversa la strada per Poiana Brașov e inizia la discesa verso la città, passando accanto a una vecchia croce di legno. Gli ultimi chilometri cambiano scena: la foresta diventa città e la tappa si conclude in Piazza Sfatului — dove finisce anche il viaggio attraverso la Terra Borza Teutonica.",
      timeline: ["Râșnov", "Promenade Sissi", "Foresta", "Radure e luminischi", "Cappella Greco-Cattolica · deviazione opzionale", "La strada per Poiana Brașov", "La vecchia croce", "Brașov", "Piazza Sfatului"],
      stage_cta: "Vedi la tappa ufficiale Râșnov – Brașov",
      stage_note: "Per mappe, aggiornamenti e informazioni tecniche, controlla sempre la pagina ufficiale della Via Transilvanica prima di partire.",
      guide_title: "La Guida dell'Escursionista",
      guide_text: "Consigli generali, percorso giorno per giorno, mappe, profilo altimetrico, infrastrutture e descrizioni delle tappe — gratuita, in RO, EN, DE, HU ed ES, sul sito ufficiale.",
      guide_cta: "Scarica la Guida dell'Escursionista",
      bike_title: "La Guida del Ciclista",
      bike_text: "La Via Transilvanica non è solo per gli scarponi. Per chi va su due ruote c'è la Guida del Ciclista, gratuita, sempre sulla piattaforma ufficiale.",
      bike_cta: "Scarica la Guida del Ciclista",
      bike_note: "Controlla sempre le condizioni attuali del percorso prima di partire.",
      video_title: "Cosa metti nello zaino? E se arriva l'orso?",
      video_text: "Cinque video di preparazione dalla Via Transilvanica: attrezzatura, vestiario, cani, orsi e sicurezza.",
      video_cta: "Guarda le guide video",
      cta_title: "Camminato abbastanza per oggi?",
      cta_text: "Fermati a Râșnov. Fai una doccia. Mangia qualcosa di buono. Stai un po' al fuoco. Dormi in un letto king-size. Domani la Via Transilvanica è sempre lì.",
      cta_book: "Verifica disponibilità",
      cta_wa: "Scrivi a Mihai",
      wa_msg: "Ciao Mihai! Sto percorrendo la Via Transilvanica e arrivo a Râșnov. Vorrei verificare la disponibilità a Imperfect House.",
      final1: "La Via Transilvanica continua.",
      final2: "Ma non devi continuare proprio adesso.",
      final3: "Zaino a terra. Scarponi a riposo. Il caffè domani mattina.",
      source_note: "Le informazioni tecniche sul percorso provengono dalle risorse ufficiali della Via Transilvanica. Non siamo partner ufficiali — solo una buona casa dove fermarsi lungo il cammino.",
      badge: "Hikers & cyclists welcome · Via Transilvanica · Râșnov",
    },
  },
  de:   {
      "nav": {
          "rooms": "Zimmer",
          "house": "Ganzes Haus",
          "gallery": "Galerie",
          "experiences": "Erlebnisse",
          "attractions": "Attraktionen",
          "events": "Festivals",
          "retreats": "Gruppen",
          "reviews": "Bewertungen",
          "faq": "Fragen",
          "book": "Verfügbarkeit prüfen",
          "menu": "Menü"
      },
      "hero": {
          "eyebrow": "BOUTIQUE GUEST HOUSE · ROSENAU (RÂȘNOV)",
          "h1a": "Es muss nicht perfekt sein,",
          "h1b": "damit du dich perfekt fühlst.",
          "sub": "Großzügige Zimmer, Ruhe, Natur und ehrliche Gastfreundschaft — nahe Bran, Kronstadt (Brașov) und den schönsten Orten rund um Rosenau.",
          "slogan": "Der Ort, an dem Imperfect zu I.M. Perfect wird. Einfach.",
          "cta1": "Verfügbarkeit prüfen",
          "cta2": "Auf WhatsApp buchen",
          "cta3": "Entdecke den Ort",
          "trust": "aus 58 Bewertungen",
          "badge": "Gästebewertung"
      },
      "widget": {
          "checkin": "Anreise",
          "checkout": "Abreise",
          "adults": "Erwachsene",
          "children": "Kinder",
          "pet": "Haustier",
          "type": "Unterkunftsart",
          "room": "Zimmer",
          "house": "Ganzes Haus",
          "cta": "Verfügbarkeit ansehen"
      },
      "marquee": "weniger Lärm · mehr von dem, was zählt · Ruhe · Natur · Gemütlichkeit ·",
      "gal": {
          "eyebrow": "GALERIE",
          "title": "Das Haus in Bildern",
          "sub": "Echte Fotos, hier aufgenommen — ohne Filter, ohne Posen."
      },
      "rp": {
          "back": "Zurück zur Seite",
          "type_room": "Zimmer · Imperfect House",
          "type_house": "Ganzes Haus · Imperfect House",
          "size": "Fläche",
          "bed": "Bett",
          "view": "Ausblick",
          "capacity": "Kapazität",
          "adults": "Erwachsene",
          "children": "Kinder",
          "gallery": "Galerie",
          "amenities": "Ausstattung",
          "shared": "Zugang zu den Gemeinschaftsräumen: Wohnzimmer, Bar, Garten, Terrasse.",
          "includes_rooms": "Umfasst alle 4 Zimmer — Crem, Salvie, Teracotă und Nuc — jedes mit eigenem Bad, plus Wohnzimmer, Küche, Balkon und Garten.",
          "book": "Buchen",
          "from": "ab",
          "night": "/Nacht"
      },
      "bf": {
          "eyebrow": "KAFFEE & FRÜHSTÜCK · AUF ANFRAGE",
          "title": "Lust auf etwas Gutes?",
          "intro": "Im Imperfect House gibt es kein Restaurant und keine Hoteltafeln. Dafür haben wir eine Bar, Kaffee, Tee und einen Gastgeber, der sich anpasst. Wenn du Frühstück möchtest, sag es uns rechtzeitig — und wir schauen, welche Köstlichkeiten wir zaubern können. Und abends, wenn du Lust auf ein Glas und eine Geschichte hast, ist die Bar genau da.",
          "includes_title": "Alle Varianten beinhalten",
          "includes": [
              "Frisch gemahlener Kaffee — Espresso, Lungo, mit Milch oder Cappuccino",
              "Tee — grün, schwarz, Minze, Früchte oder Ingwer",
              "Stilles oder Mineralwasser",
              "Der „Guten-Morgen“-Shot — Elixier aus Äpfeln und Sanddorn, voller Vitamine"
          ],
          "philosophy": "Wir verwenden Zutaten von lokalen Erzeugern — Eier vom Hof in Zărnești, Telemea von der Schäferei am Piatra Craiului, Gemüse aus dem Gewächshaus in Ghimbav, Sauerteigbrot aus der Handwerksbäckerei in Kronstadt. Wir versprechen kein perfektes Frühstück. Wir versprechen ein ehrliches, mit Seele gemachtes und mit einem Lächeln serviertes.",
          "serving": "Du nimmst es im Wohnzimmer, wo das Morgenlicht durch die großen Fenster fällt — oder bei gutem Wetter auf der Terrasse, mit Blick auf die Hügel.",
          "info1": "Jeden Morgen · 8:00 – 10:00",
          "info2": "50 Lei / Person",
          "info3": "Bis 20:00 am Vortag bestellen",
          "info4": "Allergien oder Vorlieben? Wir passen uns gerne an",
          "quote1": "Die Morgen... ein wahrer Genuss! Außergewöhnlich reichhaltiges Frühstück mit lokalen, frischen und gesunden Produkten, mit viel Liebe zubereitet.",
          "quote2": "Sehr schöner Ort, sehr herzlicher und freundlicher Gastgeber, und zum Frühstück gibt es traditionelle rumänische Produkte.",
          "final": "Wir versprechen kein schwedisches Buffet. Wir versprechen, dass wir versuchen, deinen Tag gut zu beginnen.",
          "img_alt": "Frühstück im Imperfect House — lokale Produkte, Kaffee und Sauerteigbrot"
      },
      "ck": {
          "title": "Cookies, kurz erklärt",
          "text": "Wir verwenden nur die für den Betrieb der Seite notwendigen Cookies und — nur mit deiner Zustimmung — Analyse- und Marketing-Cookies. Du kannst deine Einstellungen jederzeit ändern.",
          "accept_all": "Alle akzeptieren",
          "reject": "Nur notwendige",
          "customize": "Anpassen",
          "save": "Speichern",
          "necessary": "Notwendige",
          "necessary_d": "Unverzichtbar für den Betrieb der Seite.",
          "analytics": "Analyse",
          "analytics_d": "Helfen uns zu verstehen, wie die Seite genutzt wird (optional).",
          "marketing": "Marketing",
          "marketing_d": "Personalisierte Inhalte und Kampagnen (optional).",
          "always_on": "immer aktiv"
      },
      "story": {
          "eyebrow": "UNSERE GESCHICHTE",
          "title": "Ein Zuhause auf Zeit",
          "p1": "Irgendwo in Rosenau, am Fuße des Hügels, steht ein Haus, das nicht versucht, etwas anderes zu sein als das, was es ist: ein lebendiger, ehrlicher Ort, an dem du du selbst sein kannst. Ohne Maske. Ohne Druck. Mit Ruhe, frischer Luft und Platz zum Atmen.",
          "p2": "Wir sind kein Hotel. Und wir wollen auch keins sein. Imperfect House ist ein Haus in Rosenau, mit genug Komfort, um dich verwöhnt zu fühlen, und genug Freiheit, um dich zu Hause zu fühlen.",
          "sig": "Weniger Hotel. Mehr Zuhause.",
          "c1t": "Ruhe",
          "c1d": "Ein Wohnviertel, weit weg vom Stadtlärm. Die Kirchenglocken läuten nicht vor 9 Uhr morgens.",
          "c2t": "Natur",
          "c2d": "Der Wald beginnt 3 Gehminuten entfernt. Der Garten, das Lagerfeuer und der freie Himmel gehören dir.",
          "c3t": "Gemütlichkeit",
          "c3d": "King-Size-Betten, große Zimmer und Morgen ohne Eile. Hier vergeht die Zeit langsamer."
      },
      "acc": {
          "eyebrow": "UNTERKUNFT",
          "title": "Wähle, wie du wohnen willst",
          "sub": "4 warme Zimmer, jedes mit seiner eigenen Geschichte. Und wenn ihr als Gruppe kommt, sprechen wir über das ganze Haus.",
          "from": "ab",
          "night": "/Nacht",
          "capacity": "Kapazität",
          "book_room": "Zimmer wählen",
          "book_house": "Ganzes Haus buchen",
          "rooms_name": "Die Imperfect Zimmer",
          "rooms_tag": "4 Zimmer · eigene Bäder",
          "rf": [
              "Bett 180 × 200 cm und großzügige Dusche (ca. 100 × 170 cm)",
              "Eigenes Bad in jedem Zimmer",
              "Dachgeschoss 30 m² oder Erdgeschoss 20 m²",
              "Zugang zu Wohnzimmer, Bar und Garten"
          ],
          "house_name": "Imperfect Private House",
          "house_tag": "das ganze Haus · nur für euch",
          "hf": [
              "4 Zimmer mit 180 × 200 cm Betten + Wohnzimmer und Küche",
              "8 Personen Standard, bis zu 12 mit Zusatzschlafplätzen",
              "Balkon, Bad und privater Garten",
              "Absolute Privatsphäre für Gruppen"
          ],
          "note": "Wir haben keine Lobby. Wir haben ein Wohnzimmer. Keine Rezeption mit Glocke — wir haben eine Bar und meistens Mihai irgendwo in der Nähe.",
          "group_title": "Ihr kommt als Gruppe?",
          "group_text": "Auf Anfrage besprechen wir gerne die komplette Miete des Hauses: 8 Personen in den vier Doppelbetten 180 × 200 cm, maximal 12 in der erweiterten Konfiguration, mit den verfügbaren Zusatzschlafplätzen.",
          "group_cta": "Frag Mihai nach dem ganzen Haus",
          "group_wa": "Hallo Mihai! Wir kommen als Gruppe und interessieren uns für die komplette Miete des Imperfect House. Kannst du uns mehr erzählen?"
      },
      "am": {
          "eyebrow": "AUSSTATTUNG",
          "title": "Alles, was du brauchst, nichts Überflüssiges",
          "g1": "Im Zimmer",
          "g2": "Im Haus",
          "g3": "Optionale Services",
          "pet": "Haustierfreundlich — Haustiere sind auf Anfrage willkommen. Es können zusätzliche Gebühren anfallen.",
          "room": [
              "Eigenes Bad",
              "King-Size-Bett",
              "Flachbild-TV",
              "Sitzecke",
              "Wasserkocher & Kaffeemaschine",
              "Handtücher und Bettwäsche",
              "Haartrockner",
              "Pflegeprodukte",
              "Kleiderschrank",
              "Schalldämmung"
          ],
          "property": [
              "Kostenloses WLAN",
              "Kostenlose Parkplätze",
              "Garten & Terrasse",
              "Bar",
              "Grill",
              "Lagerfeuer",
              "Spiele und Puzzles",
              "Kino innen/außen",
              "Gemeinschaftsraum für Kaffee und Frühstück"
          ],
          "services": [
              "Kontinentales Frühstück",
              "Flughafentransfer",
              "Babybett",
              "Empfehlungen für lokale Erlebnisse"
          ]
      },
      "quiz": {
          "eyebrow": "DAS IMPERFECT QUIZ",
          "title": "Wie viele Tage Imperfect brauchst du?",
          "sub": "8 Fragen, null Benachrichtigungen. Finde dein Erholungsrezept — ehrlich, aber mit einem Lächeln.",
          "start": "Quiz starten",
          "next": "Weiter",
          "back": "Zurück",
          "restart": "Nochmal von vorn",
          "teaser": "Du erfährst genau, wie viele Nächte du brauchst und womit du deine Tage füllst, damit du maximal ausgeglichen und entspannt abreist.",
          "perks": [
              {
                  "t": "Die ideale Dauer",
                  "d": "erfahre genau, wie viele Nächte du brauchst"
              },
              {
                  "t": "Passende Ziele",
                  "d": "erhalte deine Mini-Route für jeden Tag"
              },
              {
                  "t": "Preisschätzung",
                  "d": "sieh dein Budget sofort, ohne Überraschungen"
              }
          ],
          "step": "Frage",
          "of": "von",
          "result_eyebrow": "DEIN ERHOLUNGSREZEPT",
          "nights_word": "Nächte",
          "itinerary": "Dein Mini-Plan",
          "recommended": "Empfohlene Unterkunft",
          "estimate": "Preisschätzung",
          "cta_check": "Zeitraum prüfen",
          "cta_wa": "Ergebnis per WhatsApp senden",
          "consent": "Ergebnis anonym für Statistiken speichern",
          "titles": {
              "1": "Einmal tief durchatmen. Einmal, aber richtig.",
              "2": "Du brauchst 2 Nächte und einen Sonnenaufgang ohne Wecker.",
              "3": "Du brauchst 3 Nächte und mindestens einen Morgen ohne Wecker.",
              "4": "Akkustand: 14%. Empfehlung: 4 Nächte, Lagerfeuer und Telefon auf lautlos.",
              "5": "Schwerer Fall von Stadt. Rezept: 5 Nächte Imperfect, ohne Eile."
          },
          "days": {
              "arrive": "Ankunft, Kaffee im Garten und Lagerfeuer am Abend",
              "castles": "Schloss Bran + Festung Rosenau, mit Mittagessen im Dorf",
              "nature": "Bärenreservat Zărnești + Waldspaziergang",
              "kids": "Dino Parc + Aventura Parc — die Kinderenergie, elegant verbraucht",
              "food": "Kronstadt: Cafés, Restaurants und der Rathausplatz",
              "relax": "Morgen ohne Wecker, Buch in der Hängematte, Kino unter Sternen",
              "brasov": "Poiana Brașov oder die Altstadt, zu Fuß",
              "grill": "Grillen mit Freunden und ein Glas an der Bar",
              "leave": "Langes Frühstück und Abreise mit Wehmut (aber mit Rückkehrplan)"
          },
          "questions": [
              {
                  "q": "Wie müde fühlst du dich in letzter Zeit?",
                  "a": [
                      "Volle Batterie",
                      "Etwas müde",
                      "Total erschöpft"
                  ]
              },
              {
                  "q": "Wann hattest du deinen letzten Tag ohne Benachrichtigungen?",
                  "a": [
                      "Gestern, ehrlich!",
                      "Ich erinnere mich nicht genau",
                      "Was heißt „ohne Benachrichtigungen“?"
                  ]
              },
              {
                  "q": "Mit wem reist du?",
                  "a": [
                      "Allein",
                      "Zu zweit",
                      "Mit Freunden",
                      "Mit der Familie"
                  ]
              },
              {
                  "q": "Kommen Kinder mit?",
                  "a": [
                      "Nein",
                      "Ja, kleine (0–6 Jahre)",
                      "Ja, größere (7+ Jahre)"
                  ]
              },
              {
                  "q": "Kommt dein Vierbeiner mit?",
                  "a": [
                      "Ja, er gehört zur Familie",
                      "Diesmal nicht"
                  ]
              },
              {
                  "q": "Ruhe oder Abenteuer?",
                  "a": [
                      "Totale Ruhe",
                      "Abenteuer non-stop",
                      "Eine ausgewogene Mischung"
                  ]
              },
              {
                  "q": "Was reizt dich am meisten?",
                  "a": [
                      "Natur",
                      "Burgen und Geschichte",
                      "Aktivitäten für Kinder",
                      "Essen",
                      "Pure Entspannung"
                  ]
              },
              {
                  "q": "Arbeitest du während des Aufenthalts?",
                  "a": [
                      "Nein, überhaupt nicht",
                      "Ein paar Stunden morgens",
                      "Ja — Workation"
                  ]
              }
          ]
      },
      "exp": {
          "eyebrow": "ERLEBNISSE",
          "title": "Die Abende und Morgen hier",
          "items": [
              {
                  "t": "Lagerfeuer",
                  "d": "Abende am Feuer, mit Geschichten und einem Himmel voller Sterne."
              },
              {
                  "t": "Kino unter Sternen",
                  "d": "Filme auf dem Beamer, draußen oder drinnen, je nach Wetter."
              },
              {
                  "t": "Lokales Frühstück",
                  "d": "Lokale, frische Produkte, mit Liebe zubereitet."
              },
              {
                  "t": "Kaffee in Ruhe",
                  "d": "Morgen ohne Eile im Gemeinschaftsraum oder im Garten."
              },
              {
                  "t": "Grillen mit Freunden",
                  "d": "Die Sommerküche und der Grill warten auf euch."
              },
              {
                  "t": "Familienspiele",
                  "d": "Karten, Puzzles und Gelächter bis spät."
              },
              {
                  "t": "Workation am Berg",
                  "d": "Gutes WLAN, Ruhe und ein Ausblick, der inspiriert."
              },
              {
                  "t": "Aufenthalt mit Haustier",
                  "d": "Der Vierbeiner ist willkommen — er hat auch einen Garten."
              },
              {
                  "t": "Mihais Empfehlungen",
                  "d": "Routen, Restaurants und Orte, die in keinem Reiseführer stehen."
              }
          ]
      },
      "att": {
          "eyebrow": "IN DER NÄHE",
          "title": "Was du besuchen kannst, nur wenige Schritte entfernt",
          "sub": "Rosenau ist der perfekte Ausgangspunkt: Bran, Kronstadt, Zărnești und der Piatra Craiului — alles ganz nah.",
          "km": "km",
          "bycar": "mit dem Auto",
          "cats": {
              "castele": "Burgen",
              "natura": "Natur",
              "familie": "Familie",
              "oras": "Stadt",
              "transport": "Anreise"
          },
          "nearby": "Und nur wenige Schritte entfernt: die Bushaltestelle nach Kronstadt direkt vor dem Haus, ein Geschäft in 3 Minuten, ein Park in 1 Minute, der Wald in 3 Minuten.",
          "map_title": "Karte der Gegend",
          "here": "Hier bist du — Imperfect House"
      },
      "rev": {
          "eyebrow": "BEWERTUNGEN",
          "title": "Was unsere Gäste sagen",
          "general": "Gesamtwertung",
          "cleanliness": "Sauberkeit",
          "comfort": "Komfort",
          "location": "Lage",
          "host": "Gastgeber",
          "value": "Preis/Leistung",
          "count": "Bewertungen",
          "google": "Google 5/5 · 9 Bewertungen", "booking": "Booking 9,6 · 62 Bewertungen",
          "verified": "echte Bewertungen von Booking.com und Google"
      },
      "host": {
          "eyebrow": "DER GASTGEBER",
          "title": "Mihai. Ein Gastgeber, der dich nicht wie eine Zimmernummer behandelt.",
          "p1": "Ein offener, ruhiger Mensch, der das Leben und gute Menschen mag. Mihai hilft dir bei jedem Anliegen, empfiehlt dir die besten Orte der Gegend und bereitet das Frühstück mit lokalen Produkten zu.",
          "p2": "Im Imperfect House bist du nicht nur ein Gast — du bist ein Freund, dessen Rückkehr wir kaum erwarten können.",
          "cta": "Frag Mihai auf WhatsApp",
          "photo_soon": "Ein Foto von Mihai — in Kürze"
      },
      "bk": {
          "eyebrow": "VERFÜGBARKEIT",
          "title": "Plane deinen Aufenthalt",
          "sub": "Sieh dir den echten Kalender an, wähle deinen Zeitraum und sende die Anfrage. Mihai bestätigt jede Buchung persönlich.",
          "select_unit": "Unterkunft wählen",
          "legend_avail": "verfügbar",
          "legend_limited": "Anfrage ausstehend",
          "legend_booked": "gebucht",
          "legend_blocked": "nicht verfügbar",
          "nights": "Nächte",
          "total": "Geschätzte Summe",
          "from": "ab",
          "per_night": "/Nacht",
          "name": "Dein Name",
          "phone": "Telefon",
          "email": "E-Mail (optional)",
          "message": "Nachricht an Mihai (optional)",
          "adults": "Erwachsene",
          "children": "Kinder",
          "children_ages": "Alter der Kinder",
          "pet": "Ich komme mit Haustier",
          "gdpr": "Ich stimme der Verarbeitung meiner Daten für diese Buchungsanfrage zu.",
          "submit": "Weiter zu WhatsApp",
          "sending": "Wird vorbereitet…",
          "wa_notice": "Die Buchung wird NICHT per E-Mail bestätigt. Die Anfrage wird auf WhatsApp abgeschlossen — Mihai bestätigt dir dort die Verfügbarkeit.",
          "success_title": "Deine Anfrage ist fertig — sie wurde noch NICHT gesendet.",
          "success_text": "Diese Seite sendet nichts automatisch. Damit deine Anfrage Mihai erreicht, drücke den Button unten: WhatsApp öffnet sich mit der fertig ausgefüllten Nachricht — einfach Senden drücken, und er bestätigt dir die Verfügbarkeit direkt:",
          "success_wa": "Anfrage per WhatsApp senden",
          "new_request": "Neue Anfrage",
          "error": "Etwas hat nicht ganz gepasst. Versuch es noch einmal oder schreib uns direkt auf WhatsApp.",
          "unavailable": "Dieses Zimmer erwartet im gewählten Zeitraum bereits Gäste. Versuch andere Daten.",
          "min_nights": "Für den gewählten Zeitraum beträgt das Minimum {n} Nächte.",
          "pick_dates": "Wähle An- und Abreise im Kalender",
          "available_msg": "Ja, dieser Zeitraum sieht gut aus."
      },
      "faq": {
          "eyebrow": "FRAGEN",
          "title": "Häufige Fragen",
          "items": [
              {
                  "q": "Wie buche ich?",
                  "a": "Wähle den Zeitraum im Kalender, sende die Anfrage, und Mihai bestätigt persönlich — meist innerhalb weniger Minuten auf WhatsApp. Die Buchung wird erst nach der Bestätigung des Gastgebers verbindlich."
              },
              {
                  "q": "Wann ist Check-in / Check-out?",
                  "a": "Check-in: 15:00 – 22:00. Check-out: bis 11:00. Wenn du andere Zeiten brauchst, schreib uns — wir finden eine Lösung."
              },
              {
                  "q": "Kann ich mein Haustier mitbringen?",
                  "a": "Ja! Haustiere sind auf Anfrage willkommen, es können zusätzliche Gebühren anfallen. Wir haben einen Garten und zwei freundliche Haushunde."
              },
              {
                  "q": "Ist das Frühstück inklusive?",
                  "a": "Das kontinentale Frühstück ist optional, mit lokalen Produkten. Der Wohn- und Barbereich steht allen Gästen für Kaffee und Tee offen."
              },
              {
                  "q": "Wo kann ich parken?",
                  "a": "Kostenlose öffentliche Parkplätze direkt vor dem Haus, ohne Reservierung."
              },
              {
                  "q": "Wie komme ich ohne Auto hin?",
                  "a": "Die Bushaltestelle mit direkter Verbindung nach Kronstadt liegt direkt vor dem Haus. Ein Flughafentransfer kann auf Anfrage organisiert werden."
              }
          ]
      },
      "footer": {
          "tagline": "Der Ort, an dem Imperfect zu I.M. Perfect wird. Einfach.",
          "contact": "Kontakt",
          "explore": "Entdecken",
          "legal": "Richtlinien",
          "privacy": "Datenschutzerklärung",
          "terms": "AGB",
          "checkin": "Check-in",
          "checkout": "Check-out",
          "rights": "Alle Rechte vorbehalten.",
          "final": "Imperfect House — weniger Lärm, mehr von dem, was zählt."
      },
      "wa": {
          "tooltip": "Schreib uns auf WhatsApp",
          "menu_title": "Womit können wir helfen?",
          "menu_book": "Schreib Mihai für eine Buchung",
          "menu_quiz": "Quiz: Was für ein Urlauber bist du?",
          "menu_rooms": "Zimmer ansehen",
          "msg": "Hallo Mihai! Ich möchte eine Buchung im Imperfect House.\n\nUnterkunft: {type}\nZeitraum: {ci} – {co}\nNächte: {nights}\nErwachsene: {adults}\nKinder: {children}\nHaustier: {pet}\nGeschätzter Preis: {total} EUR\nName: {name}\n\nBitte bestätige mir die Verfügbarkeit.",
          "quiz_msg": "Hallo Mihai! Ich habe das Quiz auf der Seite gemacht und herausgekommen sind {nights} Nächte Imperfect. Empfohlene Unterkunft: {unit}. Hilfst du mir mit einem passenden Zeitraum?",
          "pet_yes": "ja",
          "pet_no": "nein"
      },
      "legal": {
          "privacy_title": "Datenschutzerklärung",
          "privacy_body": "Deine Daten (Name, Telefon, E-Mail) werden ausschließlich zur Bearbeitung der Buchungsanfrage und zur Kommunikation mit dem Gastgeber verwendet. Wir verkaufen keine Daten und geben sie nicht zu Marketingzwecken an Dritte weiter. Du kannst jederzeit die Löschung oder den Export deiner Daten anfordern, indem du uns an die Kontaktadresse schreibst. Das Quiz speichert anonymisierte Antworten nur mit deiner ausdrücklichen Zustimmung.",
          "terms_title": "Allgemeine Geschäftsbedingungen",
          "terms_body": "Die über die Seite gesendete Anfrage ist keine verbindliche Buchung; sie wird erst nach Bestätigung durch den Gastgeber gültig. Die Preise werden in EUR angezeigt und können saisonal variieren. Stornierungen erfolgen durch direkten Kontakt mit dem Gastgeber. Haustiere werden auf Anfrage akzeptiert, eventuell gegen Aufpreis. Rauchen ist in allen Innenräumen verboten."
      },
      "popup": {
          "close": "Schließen",
          "cta": "Jetzt buchen",
          "dates": "Zeitraum"
      },
      "ev": {
          "eyebrow": "FESTIVAL RADAR",
          "title": "Jetzt live in Transsilvanien",
          "sub": "Du hast deine Urlaubsdaten noch nicht gewählt? Hier ein Grund dafür.",
          "live": "JETZT",
          "upcoming": "in {d} Tagen",
          "ended": "Edition beendet",
          "tba": "Termine folgen",
          "official": "Offizielle Seite",
          "details": "Eventseite",
          "book": "Zimmer buchen",
          "approx": "ungefähre Daten — prüfe die offizielle Seite",
          "verified": "geprüft am {d}"
      },
      "story2": {
          "eyebrow": "DIE GESCHICHTE VON ROSENAU",
          "title": "Hier beginnt dein Transsilvanien",
          "lead": "Du bist nicht bis nach Transsilvanien gereist, nur um zu schlafen. Rosenau ist einer dieser seltenen Orte, an denen du mit dem Wald in der Nähe aufwachst, ohne Eile frühstückst und dann wählst, was für einen Tag du leben willst. Burg? Berge? Dinosaurier? Geschichte? Fliegen? Skifahren? Legenden? Bier? Musik? Du hast alles in der Nähe.",
          "p1": "Die Deutschen nannten es Rosenau — das Tal der Rosen. Rosenau erscheint urkundlich 1331, und 1427 erhielt es das Marktrecht. Wenn harte Zeiten kamen, stiegen die Menschen hinauf zur Festung. Und so steht die Festung noch immer oben, als würde sie sagen: „Ich habe euch doch gesagt, ihr sollt auf dem Hügel bauen.“",
          "p2": "Lange vor Bran und all den Dracula-Geschichten waren die Römer bereits hier — am Rande der Stadt liegt Cumidava, das Kastell, das vor fast zwei Jahrtausenden die Straßen dieser Region bewachte.",
          "p3": "Zwei Kirchen. Zwei Gemeinschaften. Dasselbe Tal. Die Evangelische Kirche der Sachsen mit Wurzeln im 13. Jahrhundert und die Alte St.-Nikolaus-Kirche von 1384 — 800 Jahre Transsilvanien, nur Minuten vom Haus entfernt.",
          "p4": "Heute muss sich Rosenau nicht mehr gegen Eindringlinge verteidigen. Nur noch gegen Touristen, die nicht mehr weg wollen.",
          "nearby_title": "Nur wenige Schritte vom Imperfect House",
          "nearby": [
              "Bushaltestelle nach Kronstadt — direkt vor dem Haus",
              "Geschäft — ca. 3 Minuten",
              "Park — 1 Minute",
              "Wald — ein paar Minuten zu Fuß"
          ],
          "map1_caption": "Die Entspannungskarte — alles Wichtige, einfach erklärt",
          "map2_caption": "Die Erlebniskarte — deine Basis zum Erkunden",
          "maps_note": "Redaktionelle Illustrationen. Entfernungen und Zeiten sind ungefähre Angaben."
      },
      "attx": {
          "all": "Alle",
          "cats": {
              "aproape": "Nah am Haus",
              "copii": "Mit Kindern",
              "castele": "Burgen & Geschichte",
              "history_faith": "Geschichte & Glaube",
              "natura": "Natur",
              "adrenalina": "Adrenalin",
              "dark": "Dark Transylvania",
              "iarna": "Winter",
              "nightlife": "Nachtleben",
              "solo": "Solo & Gesellig",
              "taste": "Transsilvanien schmecken",
              "saxon": "Sächsisches Transsilvanien"
          },
          "approx": "ca.",
          "kids": "Kinder",
          "adventure": "Abenteuer",
          "legend_note": "Als Legende und Folklore dargestellt, nicht als erwiesene Tatsache.",
          "seasonal": "Saisonale Öffnungszeiten — vorher prüfen",
          "weather": "abhängig von Wetter und Buchung",
          "fav_add": "Zu Favoriten speichern",
          "fav_remove": "Aus Favoriten entfernt"
      },
      "ad": {
          "eyebrow": "BRAȘOV AFTER DARK",
          "title": "Die Berge schlafen. Du musst nicht.",
          "sub": "Tagsüber hast du Bran, Rosenau und den Piatra Craiului. Abends, eine halbe Stunde entfernt, wechselt Kronstadt die Kulisse: die Altstadt, Cocktails, Live-Musik, Rock, DJs und Menschen aus aller Welt. Tagsüber siehst du Transsilvanien. Nachts lernst du seine Menschen kennen.",
          "selector": "Was willst du heute Abend?",
          "moods": {
              "dance": "Tanzen",
              "rock": "Rock",
              "live": "Live & Social",
              "dj": "DJ",
              "cocktail": "Cocktail",
              "beer": "Craft Beer"
          },
          "all": "Alle",
          "note": "Programme und Themenabende ändern sich — prüfe die Seiten der Lokale, bevor du losgehst.",
          "home": "Danach kehrst du nach Rosenau zurück — wo die einzige Party um 8 Uhr morgens der Kaffee sein sollte.",
          "solo_title": "Allein gekommen? Sehr gut.",
          "solo_text": "Kronstadt ist eine Universitäts- und Touristenstadt, mit Einheimischen, Studenten, Expats und Reisenden aus aller Welt. Manchmal ist die beste Erinnerung an einen Urlaub nicht die fotografierte Burg — sondern der Mensch, den du kennengelernt hast. Meet people, not profiles. Wähle fürs erste Treffen immer einen öffentlichen Ort und ein sicheres Verkehrsmittel."
      },
      "ret": {
          "eyebrow": "RETREATS & EVENTS",
          "title": "Für Firmen, Camps und Menschen, die PowerPoint satt haben",
          "sub": "Strategie am Morgen. Wald am Nachmittag. Feuer am Abend. Vielleicht entsteht die beste Idee eures Quartals nicht in einem Konferenzraum.",
          "items": [
              {
                  "t": "Corporate Escape",
                  "d": "Meetings, Brainstorming, Training und Teambuilding — mit dem Wald in der Pause und dem Feuer am Abend."
              },
              {
                  "t": "Creative Camp",
                  "d": "Für Fotografen, Videografen, Content-Creator, Schriftsteller, Künstler und Workshops."
              },
              {
                  "t": "Parents & Kids Camp",
                  "d": "Dino Parc + Magic Parc + Natur + Spiele + Kino. Kinder elegant müde gemacht, Eltern ausgeruht."
              },
              {
                  "t": "Adventure Retreat",
                  "d": "Fliegen + Râșnov-Schluchten + Wandern + Feuer. Für Gruppen, die nicht stillsitzen können."
              },
              {
                  "t": "Private Celebration",
                  "d": "Geburtstage, Jubiläen, private Feiern, Themen-Dinner und Verkostungsabende — in einem gesitteten, kontrollierten Rahmen."
              },
              {
                  "t": "Small Symposium",
                  "d": "Mini-Symposien und professionelle Treffen, fernab vom Stadtlärm."
              }
          ],
          "capacity": "Unterkunft: bis zu 12 Personen in der vollen Konfiguration. Veranstaltungen mit zusätzlichen Gästen: nur auf Anfrage, innerhalb der vom Haus festgelegten Kapazitäts-, Lärm- und Sicherheitsgrenzen.",
          "cta": "Mihai, lass uns über unsere Gruppe sprechen",
          "wa_msg": "Hallo Mihai! Ich interessiere mich für das Imperfect House für eine Gruppenveranstaltung ({type}). Kannst du uns mit Details helfen?"
      },
      "fav": {
          "button": "Mein Transsilvanien",
          "title": "Mein Transsilvanien",
          "empty": "Noch nichts gespeichert. Tippe auf das Herz bei den Attraktionen, die dir gefallen, und bau deine Liste.",
          "count": "{n} gespeicherte Orte",
          "cta": "Liste an Mihai per WhatsApp senden",
          "clear": "Liste leeren",
          "wa_msg": "Hallo Mihai! Ich habe mir auf der Seite meine Liste „Mein Transsilvanien“ zusammengestellt:\n\n{list}\n\nHilfst du mir bei der Planung?"
      },
      "concierge": {
          "cta": "Mihai, hilf mir bei der Planung",
          "result_title": "Verstanden. Hier ist dein Transsilvanien.",
          "wa_msg": "Hallo Mihai! Ich habe das Quiz „Was für ein Urlauber bist du?“ gemacht und ein {nights}-Nächte-Plan kam dabei heraus:\n\n{plan}\n\nEmpfohlene Unterkunft: {unit}.\nHilfst du mir, ihn umzusetzen?"
      },
      "rpx": {
          "floor": "Etage",
          "shower": "Dusche",
          "saying": "Das Haus sagt",
          "max": "Maximalkapazität bei kompletter Miete: 12 Personen"
      },
      "vt": {
          "eyebrow": "VIA TRANSILVANICA · TERRA BORZA TEUTONICA",
          "title": "Via Transilvanica stops here",
          "sub": "Für heute bist du genug gewandert.",
          "lead": "Imperfect House liegt in Rosenau (Râșnov), einer der Orte an der Via-Transilvanica-Erweiterung — Terra Borza Teutonica. Es ist diese Art von Weg, die dich nicht hetzt: Sie führt dich durch Dörfer, Wälder, Wiesen, Burgen und Geschichten und erinnert dich dann an etwas Einfaches — manchmal ist der beste Teil des Wanderns das Innehalten.",
          "brand_quote": "Die Via Transilvanica sagt dir, geh weiter. Wir sagen dir, manchmal ist es gut, auch anzuhalten.",
          "brand_quote2": "Rucksack auf den Boden. Wanderschuhe in Ruhe. Du auch.",
          "simple_title": "Nach Kilometern auf dem Weg werden einfache Dinge zum Luxus.",
          "simple": [
              [
                  "King-Size-Bett",
                  "180 × 200 cm"
              ],
              [
                  "Großzügige Dusche",
                  "ca. 100 × 170 cm"
              ],
              [
                  "Kaffee am Morgen",
                  "bevor du wieder losziehst"
              ],
              [
                  "Optionales Frühstück",
                  "50 Lei / Person · auf Anfrage"
              ],
              [
                  "Garten",
                  "Ruhe, Luft und Grün"
              ],
              [
                  "Feuer",
                  "für Abende mit Geschichten"
              ],
              [
                  "WLAN",
                  "für Karten, Familie oder die nächste Etappe"
              ],
              [
                  "Lokales Wissen",
                  "Tipps zu Rosenau und Umgebung"
              ]
          ],
          "story_title": "Von Rosenau nach Kronstadt",
          "story_sub": "Wald. Wiesen. Stille. Und Kronstadt am Ende des Weges.",
          "story": "Die Etappe beginnt im Zentrum von Rosenau und folgt der Sissi-Promenade bis zum Waldrand. Der Pfad steigt sanft durch den Laubwald, und die Kilometer wechseln zwischen Schatten, Wiesen, sanften Graten und Lichtungen. Unterwegs lohnt ein kurzer Abstecher zur Griechisch-Katholischen Kapelle, an einem abgeschiedenen Ort am Waldrand. Später kreuzt der Weg die Straße nach Poiana Brașov und beginnt den Abstieg Richtung Stadt, vorbei an einem alten Wegkreuz. Die letzten Kilometer wechseln die Kulisse: Der Wald wird zur Stadt, und die Etappe endet am Rathausplatz — dort endet auch die Reise durch die Terra Borza Teutonica.",
          "timeline": [
              "Rosenau",
              "Sissi-Promenade",
              "Wald",
              "Wiesen und Lichtungen",
              "Griechisch-Katholische Kapelle · optionaler Abstecher",
              "Die Straße nach Poiana Brașov",
              "Das alte Wegkreuz",
              "Kronstadt",
              "Rathausplatz"
          ],
          "stage_cta": "Offizielle Etappe Rosenau – Kronstadt ansehen",
          "stage_note": "Für Karten, Aktualisierungen und technische Informationen prüfe vor der Abreise immer die offizielle Via-Transilvanica-Seite.",
          "guide_title": "Der Wanderführer",
          "guide_text": "Allgemeine Tipps, die Route Tag für Tag, Karten, Höhenprofil, Infrastruktur und Etappenbeschreibungen — kostenlos, auf RO, EN, DE, HU und ES, auf der offiziellen Seite.",
          "guide_cta": "Wanderführer herunterladen",
          "bike_title": "Der Radfahrerführer",
          "bike_text": "Die Via Transilvanica ist nicht nur für Wanderschuhe. Für alle auf zwei Rädern gibt es den Radfahrerführer, kostenlos, ebenfalls auf der offiziellen Plattform.",
          "bike_cta": "Radfahrerführer herunterladen",
          "bike_note": "Prüfe vor der Abfahrt immer die aktuellen Streckenbedingungen.",
          "video_title": "Was kommt in den Rucksack? Und was, wenn der Bär kommt?",
          "video_text": "Fünf Vorbereitungsvideos der Via Transilvanica: Ausrüstung, Kleidung, Hunde, Bären und Sicherheit.",
          "video_cta": "Video-Guides ansehen",
          "cta_title": "Genug gewandert für heute?",
          "cta_text": "Halte in Rosenau an. Dusch dich. Iss etwas Gutes. Sitz noch ein wenig am Feuer. Schlaf in einem King-Size-Bett. Morgen ist die Via Transilvanica immer noch da.",
          "cta_book": "Verfügbarkeit prüfen",
          "cta_wa": "Schreib Mihai",
          "wa_msg": "Hallo Mihai! Ich wandere auf der Via Transilvanica und komme nach Rosenau. Ich würde gerne die Verfügbarkeit im Imperfect House prüfen.",
          "final1": "Die Via Transilvanica geht weiter.",
          "final2": "Aber du musst nicht sofort weitergehen.",
          "final3": "Rucksack auf den Boden. Wanderschuhe in Ruhe. Der Kaffee morgen früh.",
          "source_note": "Die technischen Streckeninformationen stammen aus den offiziellen Via-Transilvanica-Quellen. Wir sind keine offiziellen Partner — nur ein gutes Haus zum Anhalten am Weg.",
          "badge": "Hikers & cyclists welcome · Via Transilvanica · Rosenau"
      }
  },
  he:   {
      "nav": {
          "rooms": "חדרים",
          "house": "כל הבית",
          "gallery": "גלריה",
          "experiences": "חוויות",
          "attractions": "אטרקציות",
          "events": "פסטיבלים",
          "retreats": "קבוצות",
          "reviews": "ביקורות",
          "faq": "שאלות",
          "book": "בדיקת זמינות",
          "menu": "תפריט"
      },
      "hero": {
          "eyebrow": "BOUTIQUE GUEST HOUSE · ראשנוב",
          "h1a": "זה לא חייב להיות מושלם",
          "h1b": "כדי שתרגישו מושלם.",
          "sub": "חדרים מרווחים, שקט, טבע ואירוח כן — קרוב לבראן, בראשוב ולמקומות היפים ביותר סביב ראשנוב.",
          "slogan": "המקום שבו Imperfect הופך ל-I.M. Perfect. פשוט.",
          "cta1": "בדיקת זמינות",
          "cta2": "הזמנה בוואטסאפ",
          "cta3": "גלו את המקום",
          "trust": "מתוך 58 ביקורות",
          "badge": "ציון אורחים"
      },
      "widget": {
          "checkin": "הגעה",
          "checkout": "עזיבה",
          "adults": "מבוגרים",
          "children": "ילדים",
          "pet": "חיית מחמד",
          "type": "סוג לינה",
          "room": "חדר",
          "house": "כל הבית",
          "cta": "צפייה בזמינות"
      },
      "marquee": "פחות רעש · יותר ממה שחשוב · שקט · טבע · שלווה ·",
      "gal": {
          "eyebrow": "גלריה",
          "title": "הבית בתמונות",
          "sub": "תמונות אמיתיות, שצולמו כאן — בלי פילטרים, בלי פוזות."
      },
      "rp": {
          "back": "חזרה לאתר",
          "type_room": "חדר · Imperfect House",
          "type_house": "כל הבית · Imperfect House",
          "size": "שטח",
          "bed": "מיטה",
          "view": "נוף",
          "capacity": "תפוסה",
          "adults": "מבוגרים",
          "children": "ילדים",
          "gallery": "גלריה",
          "amenities": "מתקנים",
          "shared": "גישה לאזורים המשותפים: סלון, בר, גינה, טרסה.",
          "includes_rooms": "כולל את כל 4 החדרים — קרם, מרווה, טרקוטה ואגוז — לכל אחד חדר רחצה פרטי, ועוד סלון, מטבח, מרפסת וגינה.",
          "book": "הזמנה",
          "from": "החל מ-",
          "night": "/לילה"
      },
      "bf": {
          "eyebrow": "קפה וארוחת בוקר · בהזמנה",
          "title": "בא לכם משהו טוב?",
          "intro": "ב-Imperfect House אין מסעדה ואין שולחנות מלון מושטחים. יש לנו בר, קפה, תה ומארח שמסתגל. אם מתחשק לכם ארוחת בוקר, ספרו לנו מראש ונראה אילו מעדנים אפשר להכין. ובערב, אם בא לכם כוס וסיפור — הבר ממש שם.",
          "includes_title": "כל האפשרויות כוללות",
          "includes": [
              "קפה טחון טרי — אספרסו, ארוך, עם חלב או קפוצ'ינו",
              "תה — ירוק, שחור, נענע, פירות או ג'ינג'ר",
              "מים רגילים או מוגזים",
              "שוט «בוקר טוב» — אליקסיר תפוחים ואובליפיחה, מלא ויטמינים"
          ],
          "philosophy": "אנחנו משתמשים במרכיבים מיצרנים מקומיים — ביצים מהחווה בזרנשט, טלמאה מהרפת בפיאטרה קריולוי, ירקות מהחממה בגימבאב, לחם מחמצת מהמאפייה המלאכותית בבראשוב. אנחנו לא מבטיחים ארוחת בוקר מושלמת. אנחנו מבטיחים אחת אותנטית, מוכנה בנשמה ומוגשת עם חיוך.",
          "serving": "לוקחים אותה בסלון, שם אור הבוקר נכנס דרך החלונות הגדולים — או, כשמזג האוויר יפה, בטרסה, מול הגבעות.",
          "info1": "כל בוקר · 8:00 – 10:00",
          "info2": "50 ליי / אדם",
          "info3": "להזמין עד 20:00 בערב הקודם",
          "info4": "אלרגיות או העדפות? אנחנו מסתגלים בשמחה",
          "quote1": "הבקרים... פינוק אמיתי! ארוחת בוקר עשירה להפליא, עם מוצרים מקומיים, טריים ובריאים, מוכנת בהמון אהבה.",
          "quote2": "מקום יפה מאוד, מארח מסביר פנים ונעים, ובארוחת הבוקר מוצרים רומניים מסורתיים.",
          "final": "אנחנו לא מבטיחים מזנון שוודי. אנחנו מבטיחים שננסה להתחיל לכם את היום טוב.",
          "img_alt": "ארוחת בוקר ב-Imperfect House — מוצרים מקומיים, קפה ולחם מחמצת"
      },
      "ck": {
          "title": "עוגיות, בקצרה",
          "text": "אנחנו משתמשים רק בעוגיות ההכרחיות לתפקוד האתר ו — רק בהסכמתך — עוגיות ניתוח ושיווק. אפשר לשנות את ההעדפות בכל עת.",
          "accept_all": "אישור הכל",
          "reject": "הכרחיות בלבד",
          "customize": "התאמה אישית",
          "save": "שמירה",
          "necessary": "הכרחיות",
          "necessary_d": "חיוניות לתפקוד האתר.",
          "analytics": "ניתוח",
          "analytics_d": "עוזרות לנו להבין איך משתמשים באתר (אופציונלי).",
          "marketing": "שיווק",
          "marketing_d": "תוכן מותאם אישית וקמפיינים (אופציונלי).",
          "always_on": "תמיד פעילות"
      },
      "story": {
          "eyebrow": "הסיפור שלנו",
          "title": "בית זמני",
          "p1": "איפשהו בראשנוב, למרגלות הגבעה, יש בית שלא מנסה להיות משהו אחר ממה שהוא: מקום חי וכן, שבו אפשר להיות אתם. בלי מסכה. בלי לחץ. עם שקט, אוויר נקי ומקום לנשום.",
          "p2": "אנחנו לא מלון. וגם לא רוצים להיות. Imperfect House הוא בית בראשנוב עם מספיק נוחות כדי שתרגישו מפונקים, ומספיק חופש כדי שתרגישו בבית.",
          "sig": "פחות מלון. יותר בית.",
          "c1t": "שקט",
          "c1d": "שכונת בתים, הרחק מרעש העיר. פעמוני הכנסייה לא מצלצלים לפני 9 בבוקר.",
          "c2t": "טבע",
          "c2d": "היער מתחיל במרחק 3 דקות הליכה. הגינה, מדורת הלילה והשמיים הפתוחים — שלכם.",
          "c3t": "שלווה",
          "c3d": "מיטות קינג-סייז, חדרים גדולים ובקרים בלי ממהר. כאן הזמן זורם לאט יותר."
      },
      "acc": {
          "eyebrow": "לינה",
          "title": "בחרו איך אתם רוצים להישאר",
          "sub": "4 חדרים חמים, לכל אחד הסיפור שלו. ואם אתם באים בקבוצה — נדבר על כל הבית.",
          "from": "החל מ-",
          "night": "/לילה",
          "capacity": "תפוסה",
          "book_room": "בחירת חדר",
          "book_house": "הזמנת כל הבית",
          "rooms_name": "חדרי Imperfect",
          "rooms_tag": "4 חדרים · חדרי רחצה פרטיים",
          "rf": [
              "מיטה 180 × 200 ס\"מ ומקלחת מרווחת (כ-100 × 170 ס\"מ)",
              "חדר רחצה פרטי בכל חדר",
              "עליית גג 30 מ\"ר או קומת קרקע 20 מ\"ר",
              "גישה לסלון, בר וגינה"
          ],
          "house_name": "Imperfect Private House",
          "house_tag": "כל הבית · רק בשבילכם",
          "hf": [
              "4 חדרים עם מיטות 180 × 200 ס\"מ + סלון ומטבח",
              "8 אורחים בסטנדרט, עד 12 עם מקומות שינה נוספים",
              "מרפסת, חדר רחצה וגינה פרטית",
              "פרטיות מלאה לקבוצות"
          ],
          "note": "אין לנו לובי. יש לנו סלון. אין פעמון בקבלה — יש בר, ורוב הזמן גם את מיכאי איפשהו קרוב.",
          "group_title": "באים בקבוצה?",
          "group_text": "בבקשה, אפשר לדבר גם על השכרת כל הנכס: 8 אנשים בארבע המיטות הזוגיות 180 × 200 ס\"מ, עד 12 מקסימום בקונפיגורציה המורחבת, עם מקומות השינה הנוספים הזמינים.",
          "group_cta": "שאלו את מיכאי על כל הבית",
          "group_wa": "שלום מיכאי! אנחנו באים בקבוצה ומעוניינים להשכיר את כל Imperfect House. אפשר לשמוע עוד?"
      },
      "am": {
          "eyebrow": "מתקנים",
          "title": "כל מה שצריך, ושום דבר מיותר",
          "g1": "בחדר",
          "g2": "בנכס",
          "g3": "שירותים אופציונליים",
          "pet": "ידידותי לחיות מחמד — חיות מחמד מתקבלות בתיאום מראש. ייתכנו חיובים נוספים.",
          "room": [
              "חדר רחצה פרטי",
              "מיטת קינג-סייז",
              "טלוויזיה מסך שטוח",
              "פינת רהיטים",
              "קומקום ומכונת קפה",
              "מגבות ומצעים",
              "מייבש שיער",
              "מוצרי טואלטיקה",
              "ארון",
              "בידוד קול"
          ],
          "property": [
              "Wi-Fi חינם",
              "חניה חינם",
              "גינה וטרסה",
              "בר",
              "מנגל",
              "מדורה",
              "משחקים ופאזלים",
              "קולנוע פנים/חוץ",
              "מרחב משותף לקפה וארוחת בוקר"
          ],
          "services": [
              "ארוחת בוקר קונטיננטלית",
              "הסעה לשדה התעופה",
              "עריסת תינוק",
              "המלצות לחוויות מקומיות"
          ]
      },
      "quiz": {
          "eyebrow": "חידון IMPERFECT",
          "title": "כמה ימי Imperfect אתם צריכים?",
          "sub": "8 שאלות, אפס התראות. גלו את מתכון המנוחה שלכם — ברצינות, אבל עם חיוך.",
          "start": "להתחיל את החידון",
          "next": "הבאה",
          "back": "חזרה",
          "restart": "להתחיל מחדש",
          "teaser": "תגלו בדיוק כמה לילות אתם צריכים ובמה למלא את הימים, כדי לצאת מכאן הכי מאוזנים ורגועים.",
          "perks": [
              {
                  "t": "המשך האידיאלי",
                  "d": "תגלו בדיוק כמה לילות אתם צריכים"
              },
              {
                  "t": "יעדים מתאימים",
                  "d": "תקבלו מסלול מיני לכל יום"
              },
              {
                  "t": "הערכת מחיר",
                  "d": "תראו את התקציב מיד, בלי הפתעות"
              }
          ],
          "step": "שאלה",
          "of": "מתוך",
          "result_eyebrow": "מתכון המנוחה שלכם",
          "nights_word": "לילות",
          "itinerary": "המיני-תוכנית שלכם",
          "recommended": "הלינה המומלצת",
          "estimate": "הערכת מחיר",
          "cta_check": "בדיקת התקופה",
          "cta_wa": "שליחת התוצאה בוואטסאפ",
          "consent": "שמירת התוצאה באופן אנונימי לסטטיסטיקה",
          "titles": {
              "1": "נשימת אוויר אחת. אחת, אבל טובה.",
              "2": "אתם צריכים 2 לילות וזריחה אחת בלי שעון מעורר.",
              "3": "אתם צריכים 3 לילות ולפחות בוקר אחד בלי שעון מעורר.",
              "4": "רמת סוללה: 14%. המלצה: 4 לילות, מדורה וטלפון על שקט.",
              "5": "מקרה חמור של עיר. מרשם: 5 לילות של Imperfect, בלי ממהר."
          },
          "days": {
              "arrive": "הגעה, קפה בגינה ומדורה בערב",
              "castles": "טירת בראן + מבצר ראשנוב, עם ארוחת צהריים בכפר",
              "nature": "שמורת הדובים זרנשט + טיול ביער",
              "kids": "דינו פארק + אוונטורה פארק — אנרגיית הילדים, מנוצלת באלגנטיות",
              "food": "בראשוב: בתי קפה, מסעדות וכיכר העירייה",
              "relax": "בוקר בלי מעורר, ספר בעמקה, קולנוע תחת הכוכבים",
              "brasov": "פויאנה בראשוב או העיר העתיקה, בקצב רגוע",
              "grill": "מנגל עם חברים וכוס בבר",
              "leave": "ארוחת בוקר ארוכה ועזיבה בצער (אבל עם תוכנית לחזור)"
          },
          "questions": [
              {
                  "q": "כמה עייפים אתם מרגישים לאחרונה?",
                  "a": [
                      "סוללה מלאה",
                      "קצת עייפים",
                      "תשושים לגמרי"
                  ]
              },
              {
                  "q": "מתי היה היום האחרון שלכם בלי התראות?",
                  "a": [
                      "אתמול, ברצינות!",
                      "לא זוכרים בדיוק",
                      "מה זה «בלי התראות»?"
                  ]
              },
              {
                  "q": "עם מי אתם נוסעים?",
                  "a": [
                      "לבד",
                      "בזוג",
                      "עם חברים",
                      "עם המשפחה"
                  ]
              },
              {
                  "q": "באים עם ילדים?",
                  "a": [
                      "לא",
                      "כן, קטנים (0–6)",
                      "כן, גדולים (7+)"
                  ]
              },
              {
                  "q": "באים עם חיית המחמד?",
                  "a": [
                      "כן, היא חלק מהמשפחה",
                      "לא הפעם"
                  ]
              },
              {
                  "q": "שקט או הרפתקה?",
                  "a": [
                      "שקט מוחלט",
                      "הרפתקה נון-סטופ",
                      "שילוב מאוזן"
                  ]
              },
              {
                  "q": "מה מושך אתכם הכי הרבה?",
                  "a": [
                      "טבע",
                      "טירות והיסטוריה",
                      "פעילויות לילדים",
                      "אוכל",
                      "מנוחה טהורה"
                  ]
              },
              {
                  "q": "אתם עובדים במהלך השהייה?",
                  "a": [
                      "לא, בכלל לא",
                      "כמה שעות בבוקר",
                      "כן — workation"
                  ]
              }
          ]
      },
      "exp": {
          "eyebrow": "חוויות",
          "title": "הערבים והבקרים של כאן",
          "items": [
              {
                  "t": "מדורה",
                  "d": "ערבים ליד האש, עם סיפורים ושמיים מלאי כוכבים."
              },
              {
                  "t": "קולנוע תחת הכוכבים",
                  "d": "סרטים על המקרן, בחוץ או בפנים, לפי מזג האוויר."
              },
              {
                  "t": "ארוחת בוקר מקומית",
                  "d": "מוצרים מקומיים וטריים, מוכנים באהבה."
              },
              {
                  "t": "קפה בשקט",
                  "d": "בקרים בלי ממהר במרחב המשותף או בגינה."
              },
              {
                  "t": "מנגל עם חברים",
                  "d": "מטבח הקיץ והמנגל מחכים לכם."
              },
              {
                  "t": "משחקי משפחה",
                  "d": "קלפים, פאזלים וצחוק עד מאוחר."
              },
              {
                  "t": "וורקיישן בהר",
                  "d": "Wi-Fi טוב, שקט ונוף שמשאיר אתכם בהשראה."
              },
              {
                  "t": "שהייה עם חיית מחמד",
                  "d": "חיית המחמד מוזמנת — גם לה יש גינה."
              },
              {
                  "t": "ההמלצות של מיכאי",
                  "d": "מסלולים, מסעדות ומקומות שלא תמצאו במדריכים."
              }
          ]
      },
      "att": {
          "eyebrow": "בסביבה",
          "title": "מה יש לבקר, במרחק צעדים ספורים",
          "sub": "ראשנוב היא הנקודה המושלמת: בראן, בראשוב, זרנשט ופיאטרה קריולוי — הכל קרוב.",
          "km": "ק\"מ",
          "bycar": "בנסיעה",
          "cats": {
              "castele": "טירות",
              "natura": "טבע",
              "familie": "משפחה",
              "oras": "עיר",
              "transport": "תחבורה"
          },
          "nearby": "ובמרחק צעדים ספורים: תחנת האוטובוס לבראשוב ממש מול הבית, חנות 3 דקות, פארק דקה, היער 3 דקות.",
          "map_title": "מפת האזור",
          "here": "אתם כאן — Imperfect House"
      },
      "rev": {
          "eyebrow": "ביקורות",
          "title": "מה האורחים אומרים",
          "general": "ציון כללי",
          "cleanliness": "ניקיון",
          "comfort": "נוחות",
          "location": "מיקום",
          "host": "מארח",
          "value": "תמורה למחיר",
          "count": "ביקורות",
          "google": "Google ‏5/5 · ‏9 ביקורות", "booking": "Booking ‏9.6 · ‏62 ביקורות",
          "verified": "ביקורות אמיתיות, מ-Booking.com ומגוגל"
      },
      "host": {
          "eyebrow": "המארח",
          "title": "מיכאי. מארח שלא מתייחס אליכם כמו אל מספר חדר.",
          "p1": "אדם פתוח ורגוע, שאוהב את החיים ואנשים יפים. מיכאי עוזר בכל בקשה, ממליץ על המקומות הטובים ביותר באזור ומכין ארוחת בוקר עם מוצרים מקומיים.",
          "p2": "ב-Imperfect House אתם לא רק אורחים — אתם חברים שאנחנו כבר מחכים שיחזרו.",
          "cta": "שאלו את מיכאי בוואטסאפ",
          "photo_soon": "תמונה של מיכאי — בקרוב"
      },
      "bk": {
          "eyebrow": "זמינות",
          "title": "תכננו את השהייה",
          "sub": "ראו את הלוח האמיתי, בחרו תקופה ושלחו בקשה. מיכאי מאשר אישית כל הזמנה.",
          "select_unit": "בחירת לינה",
          "legend_avail": "זמין",
          "legend_limited": "בקשה ממתינה",
          "legend_booked": "תפוס",
          "legend_blocked": "לא זמין",
          "nights": "לילות",
          "total": "סכום משוער",
          "from": "החל מ-",
          "per_night": "/לילה",
          "name": "השם שלכם",
          "phone": "טלפון",
          "email": "אימייל (אופציונלי)",
          "message": "הודעה למיכאי (אופציונלי)",
          "adults": "מבוגרים",
          "children": "ילדים",
          "children_ages": "גילאי הילדים",
          "pet": "מגיעים עם חיית מחמד",
          "gdpr": "אני מסכים/ה לעיבוד הנתונים שלי לצורך בקשת הזמנה זו.",
          "submit": "המשך לוואטסאפ",
          "sending": "מכין…",
          "wa_notice": "ההזמנה לא מאושרת באימייל. הבקשה מסתיימת בוואטסאפ — מיכאי מאשר לכם שם את הזמינות.",
          "success_title": "הבקשה שלכם מוכנה — היא עוד לא נשלחה.",
          "success_text": "האתר לא שולח שום דבר אוטומטית. כדי שהבקשה תגיע למיכאי, לחצו על הכפתור למטה: וואטסאפ נפתח עם ההודעה כבר מלאה — לחצו שלח, והוא יאשר לכם את הזמינות ישירות:",
          "success_wa": "שליחת הבקשה בוואטסאפ",
          "new_request": "בקשה חדשה",
          "error": "משהו לא הסתדר בול. נסו שוב או כתבו לנו ישירות בוואטסאפ.",
          "unavailable": "החדר הזה כבר מצפה לאורחים בתקופה שבחרתם. נסו תאריכים אחרים.",
          "min_nights": "לתקופה שבחרתם, המינימום הוא {n} לילות.",
          "pick_dates": "בחרו הגעה ועזיבה בלוח השנה",
          "available_msg": "כן, התקופה הזו נראית טוב."
      },
      "faq": {
          "eyebrow": "שאלות",
          "title": "שאלות נפוצות",
          "items": [
              {
                  "q": "איך מזמינים?",
                  "a": "בוחרים תקופה בלוח השנה, שולחים בקשה, ומיכאי מאשר אישית — בדרך כלל תוך דקות בוואטסאפ. ההזמנה הופכת לסופית רק אחרי אישור המארח."
              },
              {
                  "q": "מה שעות הצ'ק-אין / צ'ק-אאוט?",
                  "a": "צ'ק-אין: 15:00 – 22:00. צ'ק-אאוט: עד 11:00. צריכים שעות אחרות? כתבו לנו — נמצא פתרון."
              },
              {
                  "q": "אפשר לבוא עם חיית מחמד?",
                  "a": "כן! חיות מחמד מתקבלות בתיאום מראש וייתכנו חיובים נוספים. יש לנו גינה ושני כלבי בית ידידותיים."
              },
              {
                  "q": "ארוחת הבוקר כלולה?",
                  "a": "ארוחת בוקר קונטיננטלית היא אופציונלית, עם מוצרים מקומיים. הסלון והבר פתוחים לכל האורחים לקפה ותה."
              },
              {
                  "q": "איפה חונים?",
                  "a": "חניה ציבורית חינם ממש מול הבית, בלי הזמנה."
              },
              {
                  "q": "איך מגיעים בלי רכב?",
                  "a": "תחנת האוטובוס עם קו ישיר לבראשוב נמצאת ממש מול הבית. אפשר לארגן הסעה משדה התעופה בתיאום מראש."
              }
          ]
      },
      "footer": {
          "tagline": "המקום שבו Imperfect הופך ל-I.M. Perfect. פשוט.",
          "contact": "יצירת קשר",
          "explore": "גלו",
          "legal": "מדיניות",
          "privacy": "מדיניות פרטיות",
          "terms": "תנאי שימוש",
          "checkin": "צ'ק-אין",
          "checkout": "צ'ק-אאוט",
          "rights": "כל הזכויות שמורות.",
          "final": "Imperfect House — פחות רעש, יותר ממה שחשוב."
      },
      "wa": {
          "tooltip": "כתבו לנו בוואטסאפ",
          "menu_title": "במה נעזור?",
          "menu_book": "כתבו למיכאי להזמנה",
          "menu_quiz": "חידון: איזה מטייל אתם?",
          "menu_rooms": "צפייה בחדרים",
          "msg": "שלום מיכאי! אני רוצה לבצע הזמנה ב-Imperfect House.\n\nסוג לינה: {type}\nתקופה: {ci} – {co}\nלילות: {nights}\nמבוגרים: {adults}\nילדים: {children}\nחיית מחמד: {pet}\nמחיר משוער: {total} EUR\nשם: {name}\n\nאשמח לאישור זמינות.",
          "quiz_msg": "שלום מיכאי! עשיתי את החידון באתר ויצא שאני צריך/ת {nights} לילות של Imperfect. לינה מומלצת: {unit}. תעזור לי עם תקופה מתאימה?",
          "pet_yes": "כן",
          "pet_no": "לא"
      },
      "legal": {
          "privacy_title": "מדיניות פרטיות",
          "privacy_body": "הנתונים שלכם (שם, טלפון, אימייל) משמשים אך ורק לעיבוד בקשת ההזמנה ולתקשורת עם המארח. אנחנו לא מוכרים ולא משתפים נתונים עם צדדים שלישיים לצרכי שיווק. אפשר לבקש בכל עת מחיקה או ייצוא של הנתונים בכתובת יצירת הקשר. החידון שומר תשובות אנונימיות רק בהסכמה מפורשת.",
          "terms_title": "תנאי שימוש",
          "terms_body": "הבקשה הנשלחת דרך האתר אינה הזמנה סופית; היא תקפה רק לאחר אישור המארח. המחירים מוצגים ב-EUR ועשויים להשתנות בעונה. ביטול מתבצע ביצירת קשר ישירה עם המארח. חיות מחמד מתקבלות בתיאום מראש, ייתכנו חיובים נוספים. העישון אסור בכל החללים הפנימיים."
      },
      "popup": {
          "close": "סגירה",
          "cta": "הזמינו עכשיו",
          "dates": "תקופה"
      },
      "ev": {
          "eyebrow": "מכ\"ם פסטיבלים",
          "title": "קורה עכשיו בטרנסילבניה",
          "sub": "עוד לא בחרתם תאריך לחופשה? הנה סיבה.",
          "live": "עכשיו",
          "upcoming": "בעוד {d} ימים",
          "ended": "המהדורה הסתיימה",
          "tba": "התאריכים יאושרו",
          "official": "אתר רשמי",
          "details": "דף האירוע",
          "book": "הזמינו חדר",
          "approx": "תאריכים משוערים — בדקו את האתר הרשמי",
          "verified": "נבדק לאחרונה ב-{d}"
      },
      "story2": {
          "eyebrow": "הסיפור של ראשנוב",
          "title": "הטרנסילבניה שלכם מתחילה כאן",
          "lead": "לא הגעתם עד טרנסילבניה רק כדי לישון. ראשנוב היא אחד מאותם מקומות נדירים שבהם מתעוררים עם היער קרוב, אוכלים ארוחת בוקר בלי ממהר, ואז בוחרים איזה יום רוצים לחיות. טירה? הרים? דינוזאורים? היסטוריה? טיסה? סקי? אגדות? בירה? מוזיקה? הכל מסביב.",
          "p1": "הגרמנים קראו לה רוזנאו — עמק הוורדים. ראשנוב מופיעה במסמכים ב-1331, וב-1427 קיבלה את זכות היריד. כשהגיעו זמנים קשים, האנשים עלו למבצר. וככה המבצר נשאר שם למעלה, כאילו אומר: «אמרתי לכם לבנות על הגבעה.»",
          "p2": "הרבה לפני בראן וכל סיפורי דרקולה, הרומאים כבר היו כאן — בקצה העיר שוכנת קומידאבה, המצודה ששמרה על דרכי האזור לפני כמעט אלפיים שנה.",
          "p3": "שתי כנסיות. שתי קהילות. אותו עמק. הכנסייה האוונגלית של הסקסונים, עם שורשים במאה ה-13, וכנסיית ניקולאה העתיקה מ-1384 — 800 שנה של טרנסילבניה, במרחק דקות מהבית.",
          "p4": "היום ראשנוב כבר לא צריכה להתגונן מפני פולשים. רק מפני תיירים שלא רוצים ללכת.",
          "nearby_title": "במרחק צעדים ספורים מ-Imperfect House",
          "nearby": [
              "תחנת האוטובוס לבראשוב — ממש מול הבית",
              "חנות — כ-3 דקות",
              "פארק — דקה אחת",
              "יער — כמה דקות הליכה"
          ],
          "map1_caption": "מפת הרוגע — כל מה שחשוב, בפשטות",
          "map2_caption": "מפת החוויות — בסיס הטיולים שלכם",
          "maps_note": "איורים עריכתיים. המרחקים והזמנים משוערים."
      },
      "attx": {
          "all": "הכל",
          "cats": {
              "aproape": "קרוב לבית",
              "copii": "עם ילדים",
              "castele": "טירות והיסטוריה",
              "history_faith": "היסטוריה ואמונה",
              "natura": "טבע",
              "adrenalina": "אדרנלין",
              "dark": "טרנסילבניה האפלה",
              "iarna": "חורף",
              "nightlife": "חיי לילה",
              "solo": "סולו וחברתי",
              "taste": "טעמי טרנסילבניה",
              "saxon": "טרנסילבניה הסקסונית"
          },
          "approx": "כ-",
          "kids": "ילדים",
          "adventure": "הרפתקה",
          "legend_note": "מוצג כאגדה ופולקלור, לא כעובדה מוכחת.",
          "seasonal": "שעות עונתיות — לבדוק לפני הביקור",
          "weather": "תלוי במזג האוויר ובתיאום מראש",
          "fav_add": "שמירה למועדפים",
          "fav_remove": "הוסר מהמועדפים"
      },
      "ad": {
          "eyebrow": "בראשוב אחרי החשיכה",
          "title": "ההרים ישנים. אתם לא חייבים.",
          "sub": "ביום יש לכם בראן, ראשנוב ופיאטרה קריולוי. בערב, במרחק חצי שעה, בראשוב מחליפה תפאורה: העיר העתיקה, קוקטיילים, מוזיקה חיה, רוק, די-ג'יי ואנשים מכל העולם. ביום רואים את טרנסילבניה. בלילה מכירים את האנשים שלה.",
          "selector": "מה בא לכם הערב?",
          "moods": {
              "dance": "ריקודים",
              "rock": "רוק",
              "live": "לייב וחברתי",
              "dj": "די-ג'יי",
              "cocktail": "קוקטייל",
              "beer": "בירה קראפט"
          },
          "all": "הכל",
          "note": "התוכניות והערבים משתנים — בדקו את עמודי המקומות לפני שיוצאים.",
          "home": "ואז חוזרים לראשנוב — שם המסיבה היחידה ב-8 בבוקר צריכה להיות הקפה.",
          "solo_title": "באתם לבד? מצוין.",
          "solo_text": "בראשוב היא עיר אוניברסיטאית ותיירותית, עם מקומיים, סטודנטים, אקספאטים ומטיילים מכל העולם. לפעמים הזיכרון הכי טוב מחופשה הוא לא הטירה שצילמתם — אלא האדם שהכרתם. Meet people, not profiles. לפגישה ראשונה בחרו תמיד מקום ציבורי ותחבורה בטוחה."
      },
      "ret": {
          "eyebrow": "ריטריטים ואירועים",
          "title": "לחברות, מחנות ואנשים שנמאס להם מפאוארפוינט",
          "sub": "אסטרטגיה בבוקר. יער אחר הצהריים. מדורה בערב. אולי הרעיון הכי טוב של הרבעון שלכם לא ייוולד בחדר ישיבות.",
          "items": [
              {
                  "t": "Corporate Escape",
                  "d": "ישיבות, סיעור מוחות, הדרכות ובניית צוות — עם היער בהפסקה והמדורה בערב."
              },
              {
                  "t": "Creative Camp",
                  "d": "לצלמים, עורכי וידאו, יוצרי תוכן, סופרים, אמנים וסדנאות."
              },
              {
                  "t": "Parents & Kids Camp",
                  "d": "דינו פארק + מג'יק פארק + טבע + משחקים + קולנוע. ילדים עייפים באלגנטיות, הורים נחים."
              },
              {
                  "t": "Adventure Retreat",
                  "d": "טיסה + קניוני ראשנוב + טיול + מדורה. לקבוצות שלא יודעות לשבת במקום."
              },
              {
                  "t": "Private Celebration",
                  "d": "ימי הולדת, מפגשים, מסיבות פרטיות, ארוחות נושא וערבי טעימות — בפורמט מכובד ומבוקר."
              },
              {
                  "t": "Small Symposium",
                  "d": "מיני-סימפוזיונים ומפגשים מקצועיים, הרחק מרעש העיר."
              }
          ],
          "capacity": "לינה: עד 12 אנשים בקונפיגורציה המלאה. אירועים עם אורחים נוספים: רק בתיאום מראש, במסגרת מגבלות התפוסה, הרעש והבטיחות של הנכס.",
          "cta": "מיכאי, בוא נדבר על הקבוצה שלנו",
          "wa_msg": "שלום מיכאי! אני מתעניין ב-Imperfect House לאירוע קבוצתי ({type}). אפשר לקבל פרטים?"
      },
      "fav": {
          "button": "הטרנסילבניה שלי",
          "title": "הטרנסילבניה שלי",
          "empty": "עוד לא שמרתם כלום. לחצו על הלב אצל האטרקציות שאהבתם ובנו את הרשימה שלכם.",
          "count": "{n} מקומות שמורים",
          "cta": "שליחת הרשימה למיכאי בוואטסאפ",
          "clear": "ניקוי הרשימה",
          "wa_msg": "שלום מיכאי! הכנתי באתר את רשימת «הטרנסילבניה שלי»:\n\n{list}\n\nתעזור לי לתכנן?"
      },
      "concierge": {
          "cta": "מיכאי, תעזור לי לתכנן את הטיול",
          "result_title": "הבנתי. הנה הטרנסילבניה שלכם.",
          "wa_msg": "שלום מיכאי! עשיתי את החידון «איזה מטייל אתם?» ויצאה לי תוכנית של {nights} לילות:\n\n{plan}\n\nלינה מומלצת: {unit}.\nתעזור לי להוציא אותה לפועל?"
      },
      "rpx": {
          "floor": "קומה",
          "shower": "מקלחת",
          "saying": "הבית אומר",
          "max": "תפוסה מקסימלית בהשכרת כל הבית: 12 אנשים"
      },
      "vt": {
          "eyebrow": "VIA TRANSILVANICA · TERRA BORZA TEUTONICA",
          "title": "Via Transilvanica stops here",
          "sub": "להיום הלכתם מספיק.",
          "lead": "Imperfect House נמצא בראשנוב, אחת התחנות על ההרחבה של ה-Via Transilvanica — Terra Borza Teutonica. זו אותה דרך שלא ממהרת בכם: היא מעבירה אתכם דרך כפרים, יערות, אחו, מבצרים וסיפורים, ואז מזכירה משהו פשוט — לפעמים החלק הכי טוב בהליכה הוא העצירה.",
          "brand_quote": "ה-Via Transilvanica אומרת לכם להמשיך ללכת. אנחנו אומרים שלפעמים טוב גם לעצור.",
          "brand_quote2": "תרמיל על הרצפה. נעלי ההליכה במנוחה. אתם גם.",
          "simple_title": "אחרי קילומטרים של דרך, הדברים הפשוטים הופכים ליוקרה.",
          "simple": [
              [
                  "מיטת קינג-סייז",
                  "180 × 200 ס\"מ"
              ],
              [
                  "מקלחת מרווחת",
                  "כ-100 × 170 ס\"מ"
              ],
              [
                  "קפה בבוקר",
                  "לפני שיוצאים שוב"
              ],
              [
                  "ארוחת בוקר אופציונלית",
                  "50 ליי / אדם · בהזמנה"
              ],
              [
                  "גינה",
                  "שקט, אוויר וירוק"
              ],
              [
                  "מדורה",
                  "לערבים עם סיפורים"
              ],
              [
                  "Wi-Fi",
                  "למפה, למשפחה או לקטע הבא"
              ],
              [
                  "ידע מקומי",
                  "המלצות על ראשנוב והסביבה"
              ]
          ],
          "story_title": "מראשנוב לבראשוב",
          "story_sub": "יער. אחו. דממה. ובראשוב בקצה הדרך.",
          "story": "הקטע יוצא ממרכז ראשנוב ועוקב אחרי טיילת סיסי אל קצה היער. השביל מטפס בעדינות ביער בתולי, והקילומטרים מתחלפים בין צל, אחו, צלעות רכות וקרנות. בדרך אפשר לקחת עקיפה קצרה לקפלה היוונית-קתולית, במקום מבודד ליד היער. מאוחר יותר, המסלול חוצה את הדרך לפויאנה בראשוב ומתחיל את הירידה לעבר העיר, עובר ליד צלב דרכים עתיק. הקילומטרים האחרונים מחליפים נוף: היער הופך לעיר, והקטע מסתיים בכיכר העירייה — שם מסתיים גם המסע דרך ה-Terra Borza Teutonica.",
          "timeline": [
              "ראשנוב",
              "טיילת סיסי",
              "יער",
              "אחו וקרנות",
              "הקפלה היוונית-קתולית · עקיפה אופציונלית",
              "הדרך לפויאנה בראשוב",
              "צלב הדרכים העתיק",
              "בראשוב",
              "כיכר העירייה"
          ],
          "stage_cta": "צפייה בקטע הרשמי ראשנוב – בראשוב",
          "stage_note": "למפות, עדכונים ומידע טכני — בדקו תמיד את עמוד ה-Via Transilvanica הרשמי לפני היציאה.",
          "guide_title": "מדריך המטייל",
          "guide_text": "טיפים כלליים, המסלול יום-יום, מפות, פרופיל גובה, תשתיות ותיאורי קטעים — בחינם, ב-RO, EN, DE, HU ו-ES, באתר הרשמי.",
          "guide_cta": "הורדת מדריך המטייל",
          "bike_title": "מדריך הרוכב",
          "bike_text": "ה-Via Transilvanica היא לא רק לנעלי הליכה. למי שעל שני גלגלים יש את מדריך הרוכב, בחינם, גם כן בפלטפורמה הרשמית.",
          "bike_cta": "הורדת מדריך הרוכב",
          "bike_note": "בדקו תמיד את תנאי המסלול העדכניים לפני היציאה.",
          "video_title": "מה שמים בתרמיל? ומה עושים אם מופיע דוב?",
          "video_text": "חמישה סרטוני הכנה של ה-Via Transilvanica: ציוד, לבוש, כלבים, דובים ובטיחות.",
          "video_cta": "צפייה במדריכי הווידאו",
          "cta_title": "הלכתם מספיק להיום?",
          "cta_text": "עצרו בראשנוב. עשו מקלחת. אכלו משהו טוב. שבו קצת ליד האש. ישנו במיטת קינג-סייז. מחר ה-Via Transilvanica עדיין שם.",
          "cta_book": "בדיקת זמינות",
          "cta_wa": "כתבו למיכאי",
          "wa_msg": "שלום מיכאי! אני מטייל/ת ב-Via Transilvanica ומגיע/ה לראשנוב. אשמח לבדוק זמינות ב-Imperfect House.",
          "final1": "ה-Via Transilvanica ממשיכה.",
          "final2": "אבל אתם לא חייבים להמשיך דווקא עכשיו.",
          "final3": "תרמיל על הרצפה. נעלי ההליכה במנוחה. הקפה מחר בבוקר.",
          "source_note": "המידע הטכני על המסלול מגיע ממשאבי ה-Via Transilvanica הרשמיים. אנחנו לא שותפים רשמיים — רק בית טוב לעצור בו בדרך.",
          "badge": "מטיילים ורוכבים מתקבלים בברכה · Via Transilvanica · ראשנוב"
      }
  },
  pl:   {
      "nav": {
          "rooms": "Pokoje",
          "house": "Cały dom",
          "gallery": "Galeria",
          "experiences": "Atrakcje",
          "attractions": "Atrakcje w okolicy",
          "events": "Festiwale",
          "retreats": "Grupy",
          "reviews": "Opinie",
          "faq": "Pytania",
          "book": "Sprawdź dostępność",
          "menu": "Menu"
      },
      "hero": {
          "eyebrow": "BOUTIQUE GUEST HOUSE · RÂȘNOV",
          "h1a": "Nie musi być idealnie,",
          "h1b": "żebyś poczuł się idealnie.",
          "sub": "Przestronne pokoje, cisza, natura i szczera gościnność — blisko Branu, Braszowa i najpiękniejszych miejsc wokół Râșnovu.",
          "slogan": "Miejsce, w którym Imperfect staje się I.M. Perfect. Po prostu.",
          "cta1": "Sprawdź dostępność",
          "cta2": "Zarezerwuj przez WhatsApp",
          "cta3": "Odkryj to miejsce",
          "trust": "z 58 opinii",
          "badge": "ocena gości"
      },
      "widget": {
          "checkin": "Przyjazd",
          "checkout": "Wyjazd",
          "adults": "Dorośli",
          "children": "Dzieci",
          "pet": "Zwierzę",
          "type": "Typ zakwaterowania",
          "room": "Pokój",
          "house": "Cały dom",
          "cta": "Zobacz dostępność"
      },
      "marquee": "mniej hałasu · więcej tego, co ważne · cisza · natura · spokój ·",
      "gal": {
          "eyebrow": "GALERIA",
          "title": "Dom w obrazach",
          "sub": "Prawdziwe zdjęcia, robione tutaj — bez filtrów, bez pozowania."
      },
      "rp": {
          "back": "Powrót do strony",
          "type_room": "Pokój · Imperfect House",
          "type_house": "Cały dom · Imperfect House",
          "size": "Powierzchnia",
          "bed": "Łóżko",
          "view": "Widok",
          "capacity": "Pojemność",
          "adults": "dorośli",
          "children": "dzieci",
          "gallery": "Galeria",
          "amenities": "Udogodnienia",
          "shared": "Dostęp do części wspólnych: salon, bar, ogród, taras.",
          "includes_rooms": "Obejmuje wszystkie 4 pokoje — Crem, Salvie, Teracotă i Nuc — każdy z własną łazienką, plus salon, kuchnia, balkon i ogród.",
          "book": "Zarezerwuj",
          "from": "od",
          "night": "/noc"
      },
      "bf": {
          "eyebrow": "KAWA I ŚNIADANIE · NA ŻYCZENIE",
          "title": "Masz ochotę na coś dobrego?",
          "intro": "W Imperfect House nie mamy restauracji ani hotelowych bankietów. Mamy za to bar, kawę, herbatę i gospodarza, który się dostosuje. Jeśli chcesz śniadanie, powiedz nam z wyprzedzeniem, a zobaczymy, jakie pyszności możemy przygotować. A wieczorem, jeśli masz ochotę na kieliszek i opowieść — bar jest tuż obok.",
          "includes_title": "Wszystkie warianty zawierają",
          "includes": [
              "Świeżo mielona kawa — espresso, lungo, z mlekiem lub cappuccino",
              "Herbata — zielona, czarna, miętowa, owocowa lub imbirowa",
              "Woda niegazowana lub gazowana",
              "Shot „Dzień dobry” — eliksir z jabłek i rokitnika, pełen witamin"
          ],
          "philosophy": "Używamy składników od lokalnych producentów — jajka z farmy w Zărnești, telemea z bacówki pod Piatrą Craiului, warzywa ze szklarni w Ghimbav, chleb na zakwasie z rzemieślniczego piekarnia w Braszowie. Nie obiecujemy idealnego śniadania. Obiecujemy szczere, przygotowane z sercem i podane z uśmiechem.",
          "serving": "Jesz je w salonie, gdzie poranne światło wpada przez duże okna — albo, gdy pogoda sprzyja, na tarasie, z widokiem na wzgórza.",
          "info1": "Każdego ranka · 8:00 – 10:00",
          "info2": "50 lei / osoba",
          "info3": "Zamów do 20:00 dzień wcześniej",
          "info4": "Alergie lub preferencje? Chętnie się dostosujemy",
          "quote1": "Poranki... prawdziwa rozkosz! Wyjątkowo bogate śniadanie z lokalnych, świeżych i zdrowych produktów, przygotowane z wielką miłością.",
          "quote2": "Bardzo ładne miejsce, gospodarz bardzo gościnny i miły, a na śniadanie tradycyjne rumuńskie produkty.",
          "final": "Nie obiecujemy szwedzkiego bufetu. Obiecujemy, że postaramy się dobrze zacząć twój dzień.",
          "img_alt": "Śniadanie w Imperfect House — lokalne produkty, kawa i chleb na zakwasie"
      },
      "ck": {
          "title": "Ciasteczka, w skrócie",
          "text": "Używamy wyłącznie niezbędnych plików cookie do działania strony oraz — tylko za twoją zgodą — plików analitycznych i marketingowych. Preferencje możesz zmienić w każdej chwili.",
          "accept_all": "Akceptuję wszystkie",
          "reject": "Tylko niezbędne",
          "customize": "Dostosuj",
          "save": "Zapisz",
          "necessary": "Niezbędne",
          "necessary_d": "Kluczowe dla działania strony.",
          "analytics": "Analityczne",
          "analytics_d": "Pomagają nam zrozumieć, jak korzystasz ze strony (opcjonalne).",
          "marketing": "Marketingowe",
          "marketing_d": "Spersonalizowane treści i kampanie (opcjonalne).",
          "always_on": "zawsze aktywne"
      },
      "story": {
          "eyebrow": "NASZA HISTORIA",
          "title": "Tymczasowy dom",
          "p1": "Gdzieś w Râșnovie, u podnóża wzgórza, stoi dom, który nie próbuje być niczym innym niż jest: żywym, szczerym miejscem, w którym możesz być sobą. Bez maski. Bez presji. Z ciszą, świeżym powietrzem i przestrzenią do oddychania.",
          "p2": "Nie jesteśmy hotelem. I nie chcemy nim być. Imperfect House to dom w Râșnovie, w którym masz dość komfortu, by czuć się rozpieszczonym, i dość wolności, by czuć się jak w domu.",
          "sig": "Mniej hotelu. Więcej domu.",
          "c1t": "Cisza",
          "c1d": "Dzielnica domów, z dala od miejskiego hałasu. Dzwony kościoła nie biją przed 9 rano.",
          "c2t": "Natura",
          "c2d": "Las zaczyna się 3 minuty spacerem stąd. Ogród, ognisko i otwarte niebo są twoje.",
          "c3t": "Spokój",
          "c3d": "Łóżka king-size, duże pokoje i poranki bez pośpiechu. Tutaj czas płynie wolniej."
      },
      "acc": {
          "eyebrow": "ZAKWATEROWANIE",
          "title": "Wybierz, jak chcesz zostać",
          "sub": "4 ciepłe pokoje, każdy ze swoją historią. A jeśli przyjeżdżacie grupą — porozmawiamy o całym domu.",
          "from": "od",
          "night": "/noc",
          "capacity": "Pojemność",
          "book_room": "Wybierz pokój",
          "book_house": "Zarezerwuj cały dom",
          "rooms_name": "Pokoje Imperfect",
          "rooms_tag": "4 pokoje · własne łazienki",
          "rf": [
              "Łóżko 180 × 200 cm i przestronny prysznic (ok. 100 × 170 cm)",
              "Własna łazienka w każdym pokoju",
              "Poddasze 30 m² lub parter 20 m²",
              "Dostęp do salonu, baru i ogrodu"
          ],
          "house_name": "Imperfect Private House",
          "house_tag": "cały dom · tylko dla was",
          "hf": [
              "4 pokoje z łóżkami 180 × 200 cm + salon i kuchnia",
              "8 osób standardowo, do 12 z dodatkowymi miejscami",
              "Balkon, łazienka i prywatny ogród",
              "Pełna prywatność dla grup"
          ],
          "note": "Nie mamy lobby. Mamy salon. Nie mamy recepcji z dzwonkiem — mamy bar i najczęściej Mihaia gdzieś w pobliżu.",
          "group_title": "Przyjeżdżacie grupą?",
          "group_text": "Na życzenie możemy porozmawiać o wynajęciu całej posiadłości: 8 osób w czterech podwójnych łóżkach 180 × 200 cm, maksymalnie 12 w rozszerzonej konfiguracji, z wykorzystaniem dostępnych dodatkowych miejsc do spania.",
          "group_cta": "Zapytaj Mihaia o cały dom",
          "group_wa": "Cześć Mihai! Przyjeżdżamy grupą i interesuje nas wynajem całego Imperfect House. Możesz powiedzieć więcej?"
      },
      "am": {
          "eyebrow": "UDOGODNIENIA",
          "title": "Wszystko, czego potrzebujesz, nic zbędnego",
          "g1": "W pokoju",
          "g2": "Na posesji",
          "g3": "Usługi opcjonalne",
          "pet": "Przyjazne zwierzętom — zwierzęta akceptowane na życzenie. Mogą obowiązywać dodatkowe opłaty.",
          "room": [
              "Własna łazienka",
              "Łóżko king-size",
              "Telewizor z płaskim ekranem",
              "Kącik wypoczynkowy",
              "Czajnik i ekspres",
              "Ręczniki i pościel",
              "Suszarka do włosów",
              "Przybory toaletowe",
              "Szafa",
              "Wyciszenie"
          ],
          "property": [
              "Darmowe Wi-Fi",
              "Darmowy parking",
              "Ogród i taras",
              "Bar",
              "Grill",
              "Ognisko",
              "Gry i puzzle",
              "Kino wewnątrz/na zewnątrz",
              "Wspólna przestrzeń na kawę i śniadanie"
          ],
          "services": [
              "Śniadanie kontynentalne",
              "Transfer z lotniska",
              "Łóżeczko dziecięce",
              "Rekomendacje lokalnych atrakcji"
          ]
      },
      "quiz": {
          "eyebrow": "QUIZ IMPERFECT",
          "title": "Ilu dni Imperfect potrzebujesz?",
          "sub": "8 pytań, zero powiadomień. Poznaj swój przepis na odpoczynek — na serio, ale z uśmiechem.",
          "start": "Rozpocznij quiz",
          "next": "Dalej",
          "back": "Wstecz",
          "restart": "Od początku",
          "teaser": "Dowiesz się dokładnie, ilu nocy potrzebujesz i czym wypełnić dni, żeby wyjechać stąd maksymalnie wypoczętym.",
          "perks": [
              {
                  "t": "Idealna długość",
                  "d": "dowiedz się dokładnie, ilu nocy potrzebujesz"
              },
              {
                  "t": "Pasujące cele",
                  "d": "otrzymaj mini-plan na każdy dzień"
              },
              {
                  "t": "Szacunek ceny",
                  "d": "zobacz budżet od razu, bez niespodzianek"
              }
          ],
          "step": "Pytanie",
          "of": "z",
          "result_eyebrow": "TWÓJ PRZEPIS NA ODPOCZYNEK",
          "nights_word": "noce",
          "itinerary": "Twój mini-plan",
          "recommended": "Polecane zakwaterowanie",
          "estimate": "Szacunek ceny",
          "cta_check": "Sprawdź termin",
          "cta_wa": "Wyślij wynik przez WhatsApp",
          "consent": "Zapisz wynik anonimowo do statystyk",
          "titles": {
              "1": "Haust świeżego powietrza. Jeden, ale porządny.",
              "2": "Potrzebujesz 2 nocy i jednego wschodu słońca bez budzika.",
              "3": "Potrzebujesz 3 nocy i co najmniej jednego poranka bez budzika.",
              "4": "Poziom baterii: 14%. Zalecenie: 4 noce, ognisko i telefon na cichym.",
              "5": "Ciężki przypadek miasta. Recepta: 5 nocy Imperfect, bez pośpiechu."
          },
          "days": {
              "arrive": "Przyjazd, kawa w ogrodzie i ognisko wieczorem",
              "castles": "Zamek Bran + Twierdza Râșnov, z obiadem we wsi",
              "nature": "Rezerwat niedźwiedzi Zărnești + spacer po lesie",
              "kids": "Dino Parc + Aventura Parc — energia dzieci, spożytkowana z klasą",
              "food": "Braszów: kawiarnie, restauracje i Rynek",
              "relax": "Poranek bez budzika, książka w hamaku, kino pod gwiazdami",
              "brasov": "Poiana Brașov lub stare miasto, spacerem",
              "grill": "Grill z przyjaciółmi i kieliszek w barze",
              "leave": "Długie śniadanie i wyjazd z żalem (ale z planem powrotu)"
          },
          "questions": [
              {
                  "q": "Jak zmęczony czujesz się ostatnio?",
                  "a": [
                      "Pełna bateria",
                      "Trochę zmęczony/a",
                      "Totalnie wyczerpany/a"
                  ]
              },
              {
                  "q": "Kiedy miałeś ostatni dzień bez powiadomień?",
                  "a": [
                      "Wczoraj, serio!",
                      "Nie pamiętam dokładnie",
                      "Co to znaczy «bez powiadomień»?"
                  ]
              },
              {
                  "q": "Z kim podróżujesz?",
                  "a": [
                      "Sam/Sama",
                      "W parze",
                      "Z przyjaciółmi",
                      "Z rodziną"
                  ]
              },
              {
                  "q": "Przyjeżdżasz z dziećmi?",
                  "a": [
                      "Nie",
                      "Tak, małe (0–6 lat)",
                      "Tak, większe (7+ lat)"
                  ]
              },
              {
                  "q": "Przyjeżdżasz z pupilem?",
                  "a": [
                      "Tak, to część rodziny",
                      "Nie tym razem"
                  ]
              },
              {
                  "q": "Cisza czy przygoda?",
                  "a": [
                      "Totalna cisza",
                      "Przygoda non-stop",
                      "Zbalansowana mieszanka"
                  ]
              },
              {
                  "q": "Co przyciąga cię najbardziej?",
                  "a": [
                      "Natura",
                      "Zamki i historia",
                      "Atrakcje dla dzieci",
                      "Jedzenie",
                      "Czysty relaks"
                  ]
              },
              {
                  "q": "Pracujesz podczas pobytu?",
                  "a": [
                      "Nie, wcale",
                      "Kilka godzin rano",
                      "Tak — workation"
                  ]
              }
          ]
      },
      "exp": {
          "eyebrow": "ATRAKCJE",
          "title": "Tutejsze wieczory i poranki",
          "items": [
              {
                  "t": "Ognisko",
                  "d": "Wieczory przy ogniu, z opowieściami i niebem pełnym gwiazd."
              },
              {
                  "t": "Kino pod gwiazdami",
                  "d": "Filmy na projektorze, na zewnątrz lub w środku, zależnie od pogody."
              },
              {
                  "t": "Lokalne śniadanie",
                  "d": "Lokalne, świeże produkty, przygotowane z sercem."
              },
              {
                  "t": "Kawa w ciszy",
                  "d": "Poranki bez pośpiechu w części wspólnej lub w ogrodzie."
              },
              {
                  "t": "Grill z przyjaciółmi",
                  "d": "Kuchnia letnia i grill czekają na was."
              },
              {
                  "t": "Gry rodzinne",
                  "d": "Karty, puzzle i śmiech do późna."
              },
              {
                  "t": "Workation w górach",
                  "d": "Dobre Wi-Fi, cisza i widok, który inspiruje."
              },
              {
                  "t": "Pobyt ze zwierzęciem",
                  "d": "Pupil jest mile widziany — on też ma ogród."
              },
              {
                  "t": "Rekomendacje Mihaia",
                  "d": "Trasy, restauracje i miejsca, których nie znajdziesz w przewodnikach."
              }
          ]
      },
      "att": {
          "eyebrow": "W OKOLICY",
          "title": "Co warto zobaczyć, o krok stąd",
          "sub": "Râșnov to idealna baza: Bran, Braszów, Zărnești i Piatra Craiului — wszystko blisko.",
          "km": "km",
          "bycar": "samochodem",
          "cats": {
              "castele": "Zamki",
              "natura": "Natura",
              "familie": "Rodzina",
              "oras": "Miasto",
              "transport": "Dojazd"
          },
          "nearby": "I o krok: przystanek autobusowy do Braszowa tuż przed domem, sklep 3 minuty, park 1 minuta, las 3 minuty.",
          "map_title": "Mapa okolicy",
          "here": "Tu jesteś — Imperfect House"
      },
      "rev": {
          "eyebrow": "OPINIE",
          "title": "Co mówią nasi goście",
          "general": "Ocena ogólna",
          "cleanliness": "Czystość",
          "comfort": "Komfort",
          "location": "Lokalizacja",
          "host": "Gospodarz",
          "value": "Jakość/cena",
          "count": "opinii",
          "google": "Google 5/5 · 9 opinii", "booking": "Booking 9,6 · 62 opinii",
          "verified": "prawdziwe opinie z Booking.com i Google"
      },
      "host": {
          "eyebrow": "GOSPODARZ",
          "title": "Mihai. Gospodarz, który nie traktuje cię jak numer pokoju.",
          "p1": "Otwarta i spokojna osoba, która kocha życie i dobrych ludzi. Mihai pomoże w każdej sprawie, poleci najlepsze miejsca w okolicy i przygotuje śniadanie z lokalnych produktów.",
          "p2": "W Imperfect House nie jesteś tylko gościem — jesteś przyjacielem, na którego powrót nie możemy się doczekać.",
          "cta": "Zapytaj Mihaia na WhatsApp",
          "photo_soon": "Zdjęcie Mihaia — wkrótce"
      },
      "bk": {
          "eyebrow": "DOSTĘPNOŚĆ",
          "title": "Zaplanuj swój pobyt",
          "sub": "Zobacz prawdziwy kalendarz, wybierz termin i wyślij zapytanie. Mihai osobiście potwierdza każdą rezerwację.",
          "select_unit": "Wybierz zakwaterowanie",
          "legend_avail": "dostępne",
          "legend_limited": "zapytanie oczekuje",
          "legend_booked": "zajęte",
          "legend_blocked": "niedostępne",
          "nights": "noce",
          "total": "Szacunkowa suma",
          "from": "od",
          "per_night": "/noc",
          "name": "Twoje imię",
          "phone": "Telefon",
          "email": "E-mail (opcjonalnie)",
          "message": "Wiadomość dla Mihaia (opcjonalnie)",
          "adults": "Dorośli",
          "children": "Dzieci",
          "children_ages": "Wiek dzieci",
          "pet": "Przyjeżdżam ze zwierzęciem",
          "gdpr": "Zgadzam się na przetwarzanie moich danych na potrzeby tego zapytania o rezerwację.",
          "submit": "Przejdź do WhatsApp",
          "sending": "Przygotowuję…",
          "wa_notice": "Rezerwacja NIE jest potwierdzana e-mailem. Zapytanie finalizuje się na WhatsApp — Mihai potwierdzi ci tam dostępność.",
          "success_title": "Twoje zapytanie jest gotowe — jeszcze NIE zostało wysłane.",
          "success_text": "Ta strona nie wysyła nic automatycznie. Żeby zapytanie dotarło do Mihaia, naciśnij przycisk poniżej: otworzy się WhatsApp z gotową wiadomością — wciśnij Wyślij, a on potwierdzi ci dostępność bezpośrednio:",
          "success_wa": "Wyślij zapytanie przez WhatsApp",
          "new_request": "Nowe zapytanie",
          "error": "Coś nie zagrało idealnie. Spróbuj jeszcze raz albo napisz nam bezpośrednio na WhatsApp.",
          "unavailable": "Ten pokój oczekuje już gości w wybranym terminie. Spróbuj inne daty.",
          "min_nights": "Dla wybranego terminu minimum to {n} noce.",
          "pick_dates": "Wybierz przyjazd i wyjazd w kalendarzu",
          "available_msg": "Tak, ten termin wygląda dobrze."
      },
      "faq": {
          "eyebrow": "PYTANIA",
          "title": "Częste pytania",
          "items": [
              {
                  "q": "Jak zarezerwować?",
                  "a": "Wybierasz termin w kalendarzu, wysyłasz zapytanie, a Mihai potwierdza osobiście — zwykle w kilka minut na WhatsApp. Rezerwacja staje się wiążąca dopiero po potwierdzeniu gospodarza."
              },
              {
                  "q": "Jakie są godziny zameldowania / wymeldowania?",
                  "a": "Zameldowanie: 15:00 – 22:00. Wymeldowanie: do 11:00. Potrzebujesz innych godzin? Napisz — znajdziemy rozwiązanie."
              },
              {
                  "q": "Czy mogę przyjechać ze zwierzęciem?",
                  "a": "Tak! Zwierzęta akceptujemy na życzenie, mogą obowiązywać dodatkowe opłaty. Mamy ogród i dwa przyjazne psy domowe."
              },
              {
                  "q": "Czy śniadanie jest wliczone?",
                  "a": "Śniadanie kontynentalne jest opcjonalne, z lokalnych produktów. Salon i bar są otwarte dla wszystkich gości na kawę i herbatę."
              },
              {
                  "q": "Gdzie zaparkuję?",
                  "a": "Darmowy parking publiczny tuż przed domem, bez rezerwacji."
              },
              {
                  "q": "Jak dojechać bez samochodu?",
                  "a": "Przystanek autobusowy z bezpośrednim połączeniem do Braszowa jest tuż przed domem. Transfer z lotniska można zorganizować na życzenie."
              }
          ]
      },
      "footer": {
          "tagline": "Miejsce, w którym Imperfect staje się I.M. Perfect. Po prostu.",
          "contact": "Kontakt",
          "explore": "Odkrywaj",
          "legal": "Polityki",
          "privacy": "Polityka prywatności",
          "terms": "Regulamin",
          "checkin": "Zameldowanie",
          "checkout": "Wymeldowanie",
          "rights": "Wszelkie prawa zastrzeżone.",
          "final": "Imperfect House — mniej hałasu, więcej tego, co ważne."
      },
      "wa": {
          "tooltip": "Napisz do nas na WhatsApp",
          "menu_title": "W czym pomożemy?",
          "menu_book": "Napisz do Mihaia w sprawie rezerwacji",
          "menu_quiz": "Quiz: jaki jesteś podróżnikiem?",
          "menu_rooms": "Zobacz pokoje",
          "msg": "Cześć Mihai! Chcę zrobić rezerwację w Imperfect House.\n\nTyp zakwaterowania: {type}\nTermin: {ci} – {co}\nNoce: {nights}\nDorośli: {adults}\nDzieci: {children}\nZwierzę: {pet}\nSzacunkowa cena: {total} EUR\nImię: {name}\n\nProszę o potwierdzenie dostępności.",
          "quiz_msg": "Cześć Mihai! Zrobiłem/am quiz na stronie i wyszło, że potrzebuję {nights} nocy Imperfect. Polecane zakwaterowanie: {unit}. Pomożesz z odpowiednim terminem?",
          "pet_yes": "tak",
          "pet_no": "nie"
      },
      "legal": {
          "privacy_title": "Polityka prywatności",
          "privacy_body": "Twoje dane (imię, telefon, e-mail) są używane wyłącznie do obsługi zapytania o rezerwację i komunikacji z gospodarzem. Nie sprzedajemy i nie udostępniamy danych osobom trzecim w celach marketingowych. W każdej chwili możesz poprosić o usunięcie lub eksport swoich danych, pisząc na adres kontaktowy. Quiz zapisuje zanonimizowane odpowiedzi tylko za twoją wyraźną zgodą.",
          "terms_title": "Regulamin",
          "terms_body": "Zapytanie wysłane przez stronę nie jest wiążącą rezerwacją; staje się ważne dopiero po potwierdzeniu przez gospodarza. Ceny podane są w EUR i mogą się różnić sezonowo. Anulowanie odbywa się przez bezpośredni kontakt z gospodarzem. Zwierzęta akceptowane na życzenie, mogą obowiązywać dodatkowe opłaty. Palenie jest zabronione we wszystkich pomieszczeniach."
      },
      "popup": {
          "close": "Zamknij",
          "cta": "Zarezerwuj teraz",
          "dates": "Termin"
      },
      "ev": {
          "eyebrow": "RADAR FESTIWALOWY",
          "title": "Na żywo w Transylwanii",
          "sub": "Nie wybrałeś jeszcze daty wakacji? Oto powód.",
          "live": "TERAZ",
          "upcoming": "za {d} dni",
          "ended": "edycja zakończona",
          "tba": "daty do potwierdzenia",
          "official": "Oficjalna strona",
          "details": "Strona wydarzenia",
          "book": "Zarezerwuj pokój",
          "approx": "daty przybliżone — sprawdź oficjalną stronę",
          "verified": "sprawdzone {d}"
      },
      "story2": {
          "eyebrow": "HISTORIA RÂȘNOVU",
          "title": "Stąd zaczyna się twoja Transylwania",
          "lead": "Nie przyjechałeś aż do Transylwanii tylko po to, żeby spać. Râșnov to jedno z tych rzadkich miejsc, w których budzisz się z lasem blisko, jesz śniadanie bez pośpiechu, a potem wybierasz, jaki dzień chcesz przeżyć. Zamek? Góry? Dinozaury? Historia? Latanie? Narty? Legendy? Piwo? Muzyka? Wszystko masz w zasięgu.",
          "p1": "Niemcy nazywali to Rosenau — Dolina Róż. Râșnov pojawia się w dokumentach w 1331 roku, a w 1427 otrzymał prawo targu. Gdy nadchodziły ciężkie czasy, ludzie wspinali się do twierdzy. I tak twierdza została na górze, jakby mówiła: «Mówiłam wam, budujcie na wzgórzu.»",
          "p2": "Na długo przed Branem i wszystkimi opowieściami o Drakuli Rzymianie byli już tutaj — na skraju miasta leży Cumidava, fort strzegący dróg tego regionu prawie dwa tysiąclecia temu.",
          "p3": "Dwa kościoły. Dwie wspólnoty. Ta sama dolina. Kościół Ewangelicki Sasy, z korzeniami w XIII wieku, i Stary Kościół Św. Mikołaja z 1384 roku — 800 lat Transylwanii, kilka minut od domu.",
          "p4": "Dziś Râșnov nie musi się już bronić przed najeźdźcami. Tylko przed turystami, którzy nie chcą wyjeżdżać.",
          "nearby_title": "O krok od Imperfect House",
          "nearby": [
              "Przystanek autobusowy do Braszowa — tuż przed domem",
              "Sklep — ok. 3 minuty",
              "Park — 1 minuta",
              "Las — kilka minut spacerem"
          ],
          "map1_caption": "Mapa relaksu — wszystko, co ważne, prosto wyjaśnione",
          "map2_caption": "Mapa przygód — twoja baza wypadowa",
          "maps_note": "Ilustracje redakcyjne. Odległości i czasy są przybliżone."
      },
      "attx": {
          "all": "Wszystkie",
          "cats": {
              "aproape": "Blisko domu",
              "copii": "Z dziećmi",
              "castele": "Zamki i historia",
              "history_faith": "Historia i wiara",
              "natura": "Natura",
              "adrenalina": "Adrenalina",
              "dark": "Mroczna Transylwania",
              "iarna": "Zima",
              "nightlife": "Życie nocne",
              "solo": "Solo i towarzysko",
              "taste": "Smaki Transylwanii",
              "saxon": "Saska Transylwania"
          },
          "approx": "ok.",
          "kids": "dzieci",
          "adventure": "przygoda",
          "legend_note": "Prezentowane jako legenda i folklor, nie jako udowodniony fakt.",
          "seasonal": "godziny sezonowe — sprawdź przed wizytą",
          "weather": "zależy od pogody i rezerwacji",
          "fav_add": "Zapisz do ulubionych",
          "fav_remove": "Usunięto z ulubionych"
      },
      "ad": {
          "eyebrow": "BRAȘOV PO ZMROKU",
          "title": "Góry śpią. Ty nie musisz.",
          "sub": "Za dnia masz Bran, Râșnov i Piatrę Craiului. Wieczorem, pół godziny stąd, Braszów zmienia scenerię: stare miasto, koktajle, muzyka na żywo, rock, DJ-e i ludzie z całego świata. Za dnia oglądasz Transylwanię. Nocą poznajesz jej ludzi.",
          "selector": "Na co masz ochotę dziś wieczorem?",
          "moods": {
              "dance": "Taniec",
              "rock": "Rock",
              "live": "Na żywo i towarzysko",
              "dj": "DJ",
              "cocktail": "Koktajl",
              "beer": "Piwo rzemieślnicze"
          },
          "all": "Wszystkie",
          "note": "Programy i wieczory tematyczne się zmieniają — sprawdź strony lokali przed wyjściem.",
          "home": "A potem wracasz do Râșnovu — gdzie jedyną imprezą o 8 rano powinna być kawa.",
          "solo_title": "Przyjechałeś sam? Świetnie.",
          "solo_text": "Braszów to miasto uniwersyteckie i turystyczne, z miejscowymi, studentami, ekspatami i podróżnikami z całego świata. Czasem najlepsze wspomnienie z wakacji to nie sfotografowany zamek — tylko poznany człowiek. Meet people, not profiles. Na pierwsze spotkanie zawsze wybieraj miejsce publiczne i bezpieczny transport."
      },
      "ret": {
          "eyebrow": "RETREATY I EVENTY",
          "title": "Dla firm, obozów i ludzi, którym dość PowerPointu",
          "sub": "Strategia rano. Las po południu. Ognisko wieczorem. Może najlepszy pomysł tego kwartału nie narodzi się w sali konferencyjnej.",
          "items": [
              {
                  "t": "Corporate Escape",
                  "d": "Spotkania, burza mózgów, szkolenia i team building — z lasem na przerwie i ogniskiem wieczorem."
              },
              {
                  "t": "Creative Camp",
                  "d": "Dla fotografów, filmowców, twórców treści, pisarzy, artystów i warsztatów."
              },
              {
                  "t": "Parents & Kids Camp",
                  "d": "Dino Parc + Magic Parc + natura + gry + kino. Dzieci elegancko zmęczone, rodzice wypoczęci."
              },
              {
                  "t": "Adventure Retreat",
                  "d": "Lot + Wąwozy Râșnov + trekking + ognisko. Dla grup, które nie potrafią usiedzieć."
              },
              {
                  "t": "Private Celebration",
                  "d": "Urodziny, zjazdy, prywatne imprezy, kolacje tematyczne i wieczory degustacyjne — w cywilizowanej, kontrolowanej formie."
              },
              {
                  "t": "Small Symposium",
                  "d": "Mini-sympozja i spotkania zawodowe, z dala od miejskiego hałasu."
              }
          ],
          "capacity": "Zakwaterowanie: do 12 osób w pełnej konfiguracji. Wydarzenia z dodatkowymi gośćmi: tylko na życzenie, w granicach pojemności, hałasu i bezpieczeństwa ustalonych przez obiekt.",
          "cta": "Mihai, porozmawiajmy o naszej grupie",
          "wa_msg": "Cześć Mihai! Interesuje mnie Imperfect House na wydarzenie grupowe ({type}). Pomożesz ze szczegółami?"
      },
      "fav": {
          "button": "Moja Transylwania",
          "title": "Moja Transylwania",
          "empty": "Nic jeszcze nie zapisano. Kliknij serduszko przy atrakcjach, które ci się podobają, i zbuduj swoją listę.",
          "count": "{n} zapisanych miejsc",
          "cta": "Wyślij listę Mihaiowi przez WhatsApp",
          "clear": "Wyczyść listę",
          "wa_msg": "Cześć Mihai! Zrobiłem/am na stronie listę «Moja Transylwania»:\n\n{list}\n\nPomożesz mi ją zaplanować?"
      },
      "concierge": {
          "cta": "Mihai, pomóż mi zaplanować podróż",
          "result_title": "Zrozumiano. Oto twoja Transylwania.",
          "wa_msg": "Cześć Mihai! Zrobiłem/am quiz «Jaki jesteś podróżnikiem?» i wyszedł mi plan na {nights} nocy:\n\n{plan}\n\nPolecane zakwaterowanie: {unit}.\nPomożesz mi go zrealizować?"
      },
      "rpx": {
          "floor": "Piętro",
          "shower": "Prysznic",
          "saying": "Dom mówi",
          "max": "maksymalna pojemność przy wynajmie całego domu: 12 osób"
      },
      "vt": {
          "eyebrow": "VIA TRANSILVANICA · TERRA BORZA TEUTONICA",
          "title": "Via Transilvanica stops here",
          "sub": "Na dziś wystarczy chodzenia.",
          "lead": "Imperfect House znajduje się w Râșnovie, jednej z miejscowości na rozszerzeniu Via Transilvanica — Terra Borza Teutonica. To ten rodzaj drogi, która cię nie pogania: prowadzi przez wsie, lasy, polany, twierdze i historie, a potem przypomina coś prostego — czasem najlepszą częścią wędrówki jest postój.",
          "brand_quote": "Via Transilvanica mówi ci: idź dalej. My mówimy: czasem dobrze jest się też zatrzymać.",
          "brand_quote2": "Plecak na podłogę. Buty na odpoczynek. Ty też.",
          "simple_title": "Po kilometrach drogi proste rzeczy stają się luksusem.",
          "simple": [
              [
                  "Łóżko king-size",
                  "180 × 200 cm"
              ],
              [
                  "Przestronny prysznic",
                  "ok. 100 × 170 cm"
              ],
              [
                  "Kawa rano",
                  "zanim znów wyruszysz"
              ],
              [
                  "Śniadanie opcjonalne",
                  "50 lei / osoba · na życzenie"
              ],
              [
                  "Ogród",
                  "cisza, powietrze i zieleń"
              ],
              [
                  "Ognisko",
                  "na wieczory z opowieściami"
              ],
              [
                  "Wi-Fi",
                  "na mapę, rodzinę lub kolejny etap"
              ],
              [
                  "Lokalna wiedza",
                  "polecenia o Râșnovie i okolicy"
              ]
          ],
          "story_title": "Z Râșnovu do Braszowa",
          "story_sub": "Las. Polany. Cisza. I Braszów na końcu drogi.",
          "story": "Etap startuje w centrum Râșnovu i podąża Promenadą Sissi ku skrajowi lasu. Ścieżka wspina się łagodnie przez las liściasty, a kilometry mijają między cieniem, polanami, łagodnymi grzbietami i prześwitami. Po drodze można zrobić krótkie odejście do Kaplicy Greckokatolickiej, w ustronnym miejscu przy lesie. Później trasa przecina drogę do Poiany Brașov i zaczyna zjazd w stronę miasta, mijając stary przydrożny krzyż. Ostatnie kilometry zmieniają scenerię: las staje się miastem, a etap kończy się na Rynku — tam kończy się też podróż przez Terrę Borza Teutonica.",
          "timeline": [
              "Râșnov",
              "Promenada Sissi",
              "Las",
              "Polany i prześwity",
              "Kaplica Greckokatolicka · opcjonalne odejście",
              "Droga do Poiany Brașov",
              "Stary przydrożny krzyż",
              "Braszów",
              "Rynek (Piața Sfatului)"
          ],
          "stage_cta": "Zobacz oficjalny etap Râșnov – Braszów",
          "stage_note": "Po mapy, aktualizacje i informacje techniczne zawsze sprawdzaj oficjalną stronę Via Transilvanica przed wyjściem.",
          "guide_title": "Przewodnik Turysty",
          "guide_text": "Ogólne wskazówki, trasa dzień po dniu, mapy, profil wysokości, infrastruktura i opisy etapów — za darmo, w RO, EN, DE, HU i ES, na oficjalnej stronie.",
          "guide_cta": "Pobierz Przewodnik Turysty",
          "bike_title": "Przewodnik Rowerzysty",
          "bike_text": "Via Transilvanica to nie tylko buty trekkingowe. Dla tych na dwóch kółkach jest Przewodnik Rowerzysty, za darmo, również na oficjalnej platformie.",
          "bike_cta": "Pobierz Przewodnik Rowerzysty",
          "bike_note": "Przed wyjazdem zawsze sprawdzaj aktualne warunki na trasie.",
          "video_title": "Co spakować do plecaka? I co zrobić, gdy pojawi się niedźwiedź?",
          "video_text": "Pięć filmów przygotowawczych od Via Transilvanica: sprzęt, ubranie, psy, niedźwiedzie i bezpieczeństwo.",
          "video_cta": "Zobacz przewodniki wideo",
          "cta_title": "Nachodziłeś się na dziś?",
          "cta_text": "Zatrzymaj się w Râșnovie. Weź prysznic. Zjedz coś dobrego. Posiedź chwilę przy ognisku. Śpij w łóżku king-size. Jutro Via Transilvania wciąż tam będzie.",
          "cta_book": "Sprawdź dostępność",
          "cta_wa": "Napisz do Mihaia",
          "wa_msg": "Cześć Mihai! Przechodzę Via Transilvanica i docieram do Râșnovu. Chciałbym/abym sprawdzić dostępność w Imperfect House.",
          "final1": "Via Transilvanica trwa dalej.",
          "final2": "Ale ty nie musisz iść dalej już teraz.",
          "final3": "Plecak na podłogę. Buty na odpoczynek. Kawa jutro rano.",
          "source_note": "Informacje techniczne o trasie pochodzą z oficjalnych zasobów Via Transilvanica. Nie jesteśmy oficjalnymi partnerami — po prostu dobrym domem na postój po drodze.",
          "badge": "Hikers & cyclists welcome · Via Transilvanica · Râșnov"
      }
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("ih_lang") || "ro");
  const applyDir = useCallback((l) => {
    document.documentElement.lang = l;
    document.documentElement.dir = l === "he" ? "rtl" : "ltr";
  }, []);
  useEffect(() => { applyDir(lang); }, [lang, applyDir]);
  const setLang = useCallback((l) => {
    localStorage.setItem("ih_lang", l);
    setLangState(l);
    applyDir(l);
  }, [applyDir]);
  const t = useCallback((path) => {
    const resolve = (obj) => path.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
    const val = resolve(translations[lang]);
    if (val !== undefined) return val;
    const enFallback = resolve(translations.en);
    if (enFallback !== undefined) return enFallback;
    const roFallback = resolve(translations.ro);
    return roFallback !== undefined ? roFallback : path;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
  // corecție după animație: imaginile lazy se pot încărca în timpul scrollului
  // și mută ținta; realiniem o dată, instant, dacă am ratat vizibil.
  setTimeout(() => {
    const target = el.getBoundingClientRect().top + window.scrollY - 72;
    if (Math.abs(window.scrollY - target) > 120) {
      if (window.__lenis) window.__lenis.scrollTo(target, { immediate: true });
      else window.scrollTo(0, target);
    }
  }, 1700);
};
